//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_CAMPAIGNS_BASE_URL = new InjectionToken<string>('API_CAMPAIGNS_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class CampaignsAdvertiserAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create or updates a advertiser
     * @param request (optional) 
     * @return Success
     */
    createOrUpdateAdvertiser(request: CreateAdvertiserRequestDto | null | undefined): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/admin/advertiser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAdvertiser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAdvertiser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processCreateOrUpdateAdvertiser(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get advertiser by id
     * @return Success
     */
    getAdvertiserById(id: string): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/admin/advertiser/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processGetAdvertiserById(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get advertiser by id
     * @return Success
     */
    getAdvertisersByOrganizationId(id: string): Observable<Advertiser[]> {
        let url_ = this.baseUrl + "/api/admin/advertiser/organization/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertisersByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertisersByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser[]>;
        }));
    }

    protected processGetAdvertisersByOrganizationId(response: HttpResponseBase): Observable<Advertiser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Advertiser.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search advertisers
     * @param query (optional) 
     * @return Success
     */
    queryAdvertisers(query: AdvertiserQueryRequestDto | null | undefined): Observable<AdvertiserQueryResponseDto> {
        let url_ = this.baseUrl + "/api/admin/advertiser/queryAdvertisers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryAdvertisers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryAdvertisers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserQueryResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserQueryResponseDto>;
        }));
    }

    protected processQueryAdvertisers(response: HttpResponseBase): Observable<AdvertiserQueryResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertiserQueryResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get advertiser upload URL
     * @return Success
     */
    getAdvertiserUploadUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/advertiser/getAdvertiserUploadUrl/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAdvertiserUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user activities associated with a specific advertiser
     * @param advertiserId The ID of the advertiser
     * @param count (optional) Number of user activities
     * @return Success
     */
    getAdvertiserUserActivities(advertiserId: string, count: number | null | undefined): Observable<UserActivity[]> {
        let url_ = this.baseUrl + "/api/admin/advertiser/{advertiserId}/user-activities?";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserUserActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserUserActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivity[]>;
        }));
    }

    protected processGetAdvertiserUserActivities(response: HttpResponseBase): Observable<UserActivity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param configuration (optional) 
     * @return Success
     */
    updateProfileFieldConfiguration(advertiserId: string, configuration: ProfileFieldConfiguration | null | undefined): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/admin/advertiser/{advertiserId}/profile-field-configuration";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileFieldConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileFieldConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processUpdateProfileFieldConfiguration(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param advertiserIds (optional) 
     * @return Success
     */
    getProfileFieldConfiguration(advertiserIds: string[] | null | undefined): Observable<ProfileFieldConfiguration> {
        let url_ = this.baseUrl + "/api/admin/advertiser/profile-field-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advertiserIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileFieldConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileFieldConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileFieldConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileFieldConfiguration>;
        }));
    }

    protected processGetProfileFieldConfiguration(response: HttpResponseBase): Observable<ProfileFieldConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileFieldConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfileFieldConfigurationByCampaignId(campaignId: string): Observable<ProfileFieldConfiguration> {
        let url_ = this.baseUrl + "/api/admin/advertiser/profile-field-configuration-by-campaign-id/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileFieldConfigurationByCampaignId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileFieldConfigurationByCampaignId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileFieldConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileFieldConfiguration>;
        }));
    }

    protected processGetProfileFieldConfigurationByCampaignId(response: HttpResponseBase): Observable<ProfileFieldConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileFieldConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the campaigns that are advertised for the current user as a staff member,
    and returns the latest user role for the current user.
     * @param request (optional) 
     * @return Success
     */
    getAdvertiserUserRole(request: AdvertiserUserRoleRequest | null | undefined): Observable<CampaignTargetUser> {
        let url_ = this.baseUrl + "/api/admin/advertiser/advertiser-user-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignTargetUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignTargetUser>;
        }));
    }

    protected processGetAdvertiserUserRole(response: HttpResponseBase): Observable<CampaignTargetUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdvertisersByCurrentUser(): Observable<AdvertiserDto[]> {
        let url_ = this.baseUrl + "/api/admin/advertiser/by-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertisersByCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertisersByCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserDto[]>;
        }));
    }

    protected processGetAdvertisersByCurrentUser(response: HttpResponseBase): Observable<AdvertiserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvertiserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsCampaignAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates an admin campaign
     * @param campaignRequest (optional) 
     * @return Success
     */
    createCampaign(campaignRequest: CampaignAdminRequest | null | undefined): Observable<Campaign> {
        let url_ = this.baseUrl + "/api/admin/campaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaignRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign>;
        }));
    }

    protected processCreateCampaign(response: HttpResponseBase): Observable<Campaign> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Campaign.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCampaign(campaignId: string): Observable<Campaign> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign>;
        }));
    }

    protected processGetCampaign(response: HttpResponseBase): Observable<Campaign> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Campaign.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    updateCampaignPartial(campaignId: string, request: UpdateCampaignPartialRequest | null | undefined): Observable<CampaignDto> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCampaignPartial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCampaignPartial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto>;
        }));
    }

    protected processUpdateCampaignPartial(response: HttpResponseBase): Observable<CampaignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    updateCampaignOnboardingUrl(campaignId: string, request: UpdateCampaignOnboardingUrlRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/onboarding-url";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCampaignOnboardingUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCampaignOnboardingUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCampaignOnboardingUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCampaignLiteById(campaignId: string): Observable<CampaignDto> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/lite";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignLiteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignLiteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto>;
        }));
    }

    protected processGetCampaignLiteById(response: HttpResponseBase): Observable<CampaignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCampaignFullConfig(campaignId: string): Observable<CampaignFullConfigDto> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/full-config";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignFullConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignFullConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignFullConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignFullConfigDto>;
        }));
    }

    protected processGetCampaignFullConfig(response: HttpResponseBase): Observable<CampaignFullConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignFullConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productIds (optional) 
     * @return Success
     */
    getCampaignsByProductIds(productIds: string[] | null | undefined): Observable<Campaign> {
        let url_ = this.baseUrl + "/api/admin/campaigns/search-by-productIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignsByProductIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignsByProductIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign>;
        }));
    }

    protected processGetCampaignsByProductIds(response: HttpResponseBase): Observable<Campaign> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Campaign.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCampaignOrganizations(campaignId: string): Observable<Campaign> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/organizations";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign>;
        }));
    }

    protected processGetCampaignOrganizations(response: HttpResponseBase): Observable<Campaign> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Campaign.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCampaignsForAdvertisers(advertiserId: string): Observable<Campaign[]> {
        let url_ = this.baseUrl + "/advertisers/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignsForAdvertisers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignsForAdvertisers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign[]>;
        }));
    }

    protected processGetCampaignsForAdvertisers(response: HttpResponseBase): Observable<Campaign[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Campaign.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param status (optional) 
     * @param searchKeyword (optional) 
     * @param filterAdvertiserId (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param isSystemAdmin (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getCampaignsByUserProfile(userId: string | null | undefined, status: string | null | undefined, searchKeyword: string | null | undefined, filterAdvertiserId: string | null | undefined, sortColumn: string | null | undefined, sortDirection: string | null | undefined, isSystemAdmin: boolean | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PaginatedCampaignResponse> {
        let url_ = this.baseUrl + "/api/admin/campaigns/user-profile?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchKeyword !== undefined && searchKeyword !== null)
            url_ += "SearchKeyword=" + encodeURIComponent("" + searchKeyword) + "&";
        if (filterAdvertiserId !== undefined && filterAdvertiserId !== null)
            url_ += "FilterAdvertiserId=" + encodeURIComponent("" + filterAdvertiserId) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (isSystemAdmin !== undefined && isSystemAdmin !== null)
            url_ += "IsSystemAdmin=" + encodeURIComponent("" + isSystemAdmin) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignsByUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignsByUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedCampaignResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedCampaignResponse>;
        }));
    }

    protected processGetCampaignsByUserProfile(response: HttpResponseBase): Observable<PaginatedCampaignResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedCampaignResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConsumerReferralCampaigns(campaignId: string): Observable<Campaign[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/consumer-referral";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumerReferralCampaigns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerReferralCampaigns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign[]>;
        }));
    }

    protected processGetConsumerReferralCampaigns(response: HttpResponseBase): Observable<Campaign[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Campaign.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStaffReferralCampaigns(campaignId: string): Observable<Campaign[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/staff-referral";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffReferralCampaigns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffReferralCampaigns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Campaign[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Campaign[]>;
        }));
    }

    protected processGetStaffReferralCampaigns(response: HttpResponseBase): Observable<Campaign[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Campaign.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get signed upload URL
     * @return Success
     */
    getUploadUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/campaigns/getUploadUrl/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteCampaign(id: string, advertiserId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{id}/{advertiserId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMediaUploadUrl(campaignId: string, key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/getMediaUploadUrl/{key}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMediaUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMediaUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMediaUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    listMedia(campaignId: string): Observable<MediaObject[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/{campaignId}/media";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaObject[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaObject[]>;
        }));
    }

    protected processListMedia(response: HttpResponseBase): Observable<MediaObject[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MediaObject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Cards campaign by user id
     * @return Success
     */
    getCardCampaignsByUserId(userId: string): Observable<Card[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/cardsWithCampaignByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardCampaignsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardCampaignsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Card[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Card[]>;
        }));
    }

    protected processGetCardCampaignsByUserId(response: HttpResponseBase): Observable<Card[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Card.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param historyPoints (optional) 
     * @return Success
     */
    insertPointsHistory(historyPoints: HistoryPoints | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaigns/historyPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(historyPoints);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertPointsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertPointsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertPointsHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    fuzzyTest(request: FuzzyTestRequest | null | undefined): Observable<FuzzyTestResponse> {
        let url_ = this.baseUrl + "/api/admin/campaigns/fuzzyTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFuzzyTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFuzzyTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuzzyTestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuzzyTestResponse>;
        }));
    }

    protected processFuzzyTest(response: HttpResponseBase): Observable<FuzzyTestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuzzyTestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTimeZoneInfos(): Observable<TimeZoneItem[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/timeZoneInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeZoneInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeZoneInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeZoneItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeZoneItem[]>;
        }));
    }

    protected processGetTimeZoneInfos(response: HttpResponseBase): Observable<TimeZoneItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeZoneItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdvertiserLinkedCampaigns(advertiserId: string): Observable<LinkedCampaignDto[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/linked-campaigns/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserLinkedCampaigns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserLinkedCampaigns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedCampaignDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedCampaignDto[]>;
        }));
    }

    protected processGetAdvertiserLinkedCampaigns(response: HttpResponseBase): Observable<LinkedCampaignDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedCampaignDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * UpdateAdvertiserLinkedCampaigns
     * @param linkedCampaigns (optional) 
     * @return Success
     */
    updateAdvertiserLinkedCampaigns(advertiserId: string, linkedCampaigns: LinkedCampaignDto[] | null | undefined): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/admin/campaigns/linked-campaigns/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(linkedCampaigns);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdvertiserLinkedCampaigns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdvertiserLinkedCampaigns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processUpdateAdvertiserLinkedCampaigns(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateAdvertiserLinkedCampaignsResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = UpdateAdvertiserLinkedCampaignsResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdvertiserDataConnections(advertiserId: string): Observable<ConsumerDataConnection> {
        let url_ = this.baseUrl + "/api/admin/campaigns/data-connection/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserDataConnections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserDataConnections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumerDataConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumerDataConnection>;
        }));
    }

    protected processGetAdvertiserDataConnections(response: HttpResponseBase): Observable<ConsumerDataConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsumerDataConnection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataConnection (optional) 
     * @return Success
     */
    updateAdvertiserDataConnection(advertiserId: string, dataConnection: ConsumerDataConnection | null | undefined): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/admin/campaigns/data-connection/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataConnection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdvertiserDataConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdvertiserDataConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processUpdateAdvertiserDataConnection(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataConnection (optional) 
     * @return Success
     */
    testAdvertiserDataConnections(advertiserId: string, dataConnection: ConsumerDataConnection | null | undefined): Observable<DataConnectionTest> {
        let url_ = this.baseUrl + "/api/admin/campaigns/data-connection/{advertiserId}/test";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataConnection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestAdvertiserDataConnections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestAdvertiserDataConnections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataConnectionTest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataConnectionTest>;
        }));
    }

    protected processTestAdvertiserDataConnections(response: HttpResponseBase): Observable<DataConnectionTest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataConnectionTest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param syncRequest (optional) 
     * @return Success
     */
    syncConsumerData(syncRequest: SyncConsumerDataRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaigns/sync-consumer-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncConsumerData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncConsumerData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSyncConsumerData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Migrates users from CSV file to new target campaigns using step function
     * @param request (optional) Migration request containing CSV S3 URL, target campaigns, and advertiser info
     * @return Success
     */
    migrateUsersFromCsv(request: MigrateUsersRequest | null | undefined): Observable<MigrationStartResponse> {
        let url_ = this.baseUrl + "/api/admin/campaigns/migrate-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateUsersFromCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateUsersFromCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationStartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationStartResponse>;
        }));
    }

    protected processMigrateUsersFromCsv(response: HttpResponseBase): Observable<MigrationStartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationStartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the progress of a specific migration
     * @param migrationId Migration ID to track
     * @return Success
     */
    getMigrationProgress(migrationId: string): Observable<MigrationProgressResponse> {
        let url_ = this.baseUrl + "/api/admin/campaigns/migration-progress/{migrationId}";
        if (migrationId === undefined || migrationId === null)
            throw new globalThis.Error("The parameter 'migrationId' must be defined.");
        url_ = url_.replace("{migrationId}", encodeURIComponent("" + migrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMigrationProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMigrationProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationProgressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationProgressResponse>;
        }));
    }

    protected processGetMigrationProgress(response: HttpResponseBase): Observable<MigrationProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the migration history for a specific user
     * @param userId User ID to get migration history for
     * @param limit (optional) Maximum number of records to return (default 10)
     * @return Success
     */
    getUserMigrationHistory(userId: string, limit: number | null | undefined): Observable<MigrationProgressResponse[]> {
        let url_ = this.baseUrl + "/api/admin/campaigns/migration-history/{userId}?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserMigrationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserMigrationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationProgressResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationProgressResponse[]>;
        }));
    }

    protected processGetUserMigrationHistory(response: HttpResponseBase): Observable<MigrationProgressResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MigrationProgressResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdvertiserLoginOptions(advertiserId: string): Observable<AdvertiserLoginOptions> {
        let url_ = this.baseUrl + "/api/admin/campaigns/login-options/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserLoginOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserLoginOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserLoginOptions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserLoginOptions>;
        }));
    }

    protected processGetAdvertiserLoginOptions(response: HttpResponseBase): Observable<AdvertiserLoginOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertiserLoginOptions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param loginOptions (optional) 
     * @return Success
     */
    updateAdvertiserLoginOptions(advertiserId: string, loginOptions: AdvertiserLoginOptions | null | undefined): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/admin/campaigns/login-options/{advertiserId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdvertiserLoginOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdvertiserLoginOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processUpdateAdvertiserLoginOptions(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCampaignLoginOptions(advertiserId: string, campaignId: string): Observable<AdvertiserLoginOptions> {
        let url_ = this.baseUrl + "/api/admin/campaigns/login-options/{advertiserId}/campaign/{campaignId}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignLoginOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignLoginOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserLoginOptions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserLoginOptions>;
        }));
    }

    protected processGetCampaignLoginOptions(response: HttpResponseBase): Observable<AdvertiserLoginOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertiserLoginOptions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsCampaignLocationFilterAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Save or update a campaign location filter
     * @param request (optional) 
     * @return Success
     */
    save(request: CampaignLocationFilter | null | undefined): Observable<CampaignLocationFilter> {
        let url_ = this.baseUrl + "/api/admin/campaign-location-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignLocationFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignLocationFilter>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<CampaignLocationFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignLocationFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the campaign location filters
     * @return Success
     */
    getByCampaignId(campaignId: string): Observable<CampaignLocationFilter> {
        let url_ = this.baseUrl + "/api/admin/campaign-location-filters/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCampaignId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCampaignId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignLocationFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignLocationFilter>;
        }));
    }

    protected processGetByCampaignId(response: HttpResponseBase): Observable<CampaignLocationFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignLocationFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a campaign location filter
     * @return Success
     */
    delete(campaignId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaign-location-filters/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsCampaignPunchCardSchemaAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param schema (optional) 
     * @return Success
     */
    saveSchema(schema: PunchCardSchema | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaignSchema/punchcard/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schema);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSchema(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByCampaignIdAll(campaignId: string): Observable<PunchCardSchema[]> {
        let url_ = this.baseUrl + "/api/admin/campaignSchema/punchcard/getByCampaignId/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCampaignIdAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCampaignIdAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchCardSchema[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchCardSchema[]>;
        }));
    }

    protected processGetByCampaignIdAll(response: HttpResponseBase): Observable<PunchCardSchema[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchCardSchema.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById(campaignId: string, schemaId: string): Observable<PunchCardSchema> {
        let url_ = this.baseUrl + "/api/admin/campaignSchema/punchcard/getById/{campaignId}/{schemaId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        if (schemaId === undefined || schemaId === null)
            throw new globalThis.Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchCardSchema>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchCardSchema>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PunchCardSchema> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PunchCardSchema.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteSchema(campaignId: string, schemaId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaignSchema/punchcard/delete/{campaignId}/{schemaId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        if (schemaId === undefined || schemaId === null)
            throw new globalThis.Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSchema(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsCampaignReceiptLocationFilterAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Save or update a campaign receipt location filter
     * @param request (optional) 
     * @return Success
     */
    save2(request: CampaignLocationFilter | null | undefined): Observable<CampaignLocationFilter> {
        let url_ = this.baseUrl + "/api/admin/campaign-receipt-location-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignLocationFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignLocationFilter>;
        }));
    }

    protected processSave2(response: HttpResponseBase): Observable<CampaignLocationFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignLocationFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the campaign receipt location filters
     * @return Success
     */
    getByCampaignId2(campaignId: string): Observable<CampaignLocationFilter> {
        let url_ = this.baseUrl + "/api/admin/campaign-receipt-location-filters/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCampaignId2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCampaignId2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignLocationFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignLocationFilter>;
        }));
    }

    protected processGetByCampaignId2(response: HttpResponseBase): Observable<CampaignLocationFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignLocationFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a campaign receipt location filter
     * @return Success
     */
    delete2(campaignId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/campaign-receipt-location-filters/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsOutboundEventConfigurationApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get list of available event types for subscription
     * @return Success
     */
    getEventTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/outbound-events/event-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEventTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get outbound event integration configurations for a campaign
     * @return Success
     */
    getCampaignConfig(campaignId: string): Observable<OutboundEventIntegrationConfigDto[]> {
        let url_ = this.baseUrl + "/api/outbound-events/campaigns/{campaignId}/config";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundEventIntegrationConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundEventIntegrationConfigDto[]>;
        }));
    }

    protected processGetCampaignConfig(response: HttpResponseBase): Observable<OutboundEventIntegrationConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutboundEventIntegrationConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update outbound event integration configuration for a campaign
     * @param request (optional) 
     * @return Success
     */
    updateCampaignConfig(campaignId: string, request: UpdateOutboundEventConfigRequestDto | null | undefined): Observable<OutboundEventIntegrationConfigDto> {
        let url_ = this.baseUrl + "/api/outbound-events/campaigns/{campaignId}/config";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCampaignConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCampaignConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundEventIntegrationConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundEventIntegrationConfigDto>;
        }));
    }

    protected processUpdateCampaignConfig(response: HttpResponseBase): Observable<OutboundEventIntegrationConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutboundEventIntegrationConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get outbound event integration configurations for an advertiser
     * @return Success
     */
    getAdvertiserConfig(advertiserId: string): Observable<OutboundEventIntegrationConfigDto[]> {
        let url_ = this.baseUrl + "/api/outbound-events/advertisers/{advertiserId}/config";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundEventIntegrationConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundEventIntegrationConfigDto[]>;
        }));
    }

    protected processGetAdvertiserConfig(response: HttpResponseBase): Observable<OutboundEventIntegrationConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutboundEventIntegrationConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update outbound event integration configuration for an advertiser
     * @param request (optional) 
     * @return Success
     */
    updateAdvertiserConfig(advertiserId: string, request: UpdateOutboundEventConfigRequestDto | null | undefined): Observable<OutboundEventIntegrationConfigDto> {
        let url_ = this.baseUrl + "/api/outbound-events/advertisers/{advertiserId}/config";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdvertiserConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdvertiserConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundEventIntegrationConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundEventIntegrationConfigDto>;
        }));
    }

    protected processUpdateAdvertiserConfig(response: HttpResponseBase): Observable<OutboundEventIntegrationConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutboundEventIntegrationConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a specific outbound event integration configuration for a campaign by provider
     * @return Success
     */
    deleteCampaignConfig(campaignId: string, provider: any): Observable<void> {
        let url_ = this.baseUrl + "/api/outbound-events/campaigns/{campaignId}/config/{provider}";
        if (campaignId === undefined || campaignId === null)
            throw new globalThis.Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCampaignConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCampaignConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCampaignConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a specific outbound event integration configuration for an advertiser by provider
     * @return Success
     */
    deleteAdvertiserConfig(advertiserId: string, provider: any): Observable<void> {
        let url_ = this.baseUrl + "/api/outbound-events/advertisers/{advertiserId}/config/{provider}";
        if (advertiserId === undefined || advertiserId === null)
            throw new globalThis.Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAdvertiserConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAdvertiserConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAdvertiserConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Test endpoint for receiving outbound webhook events
     * @param security_Key (optional) 
     * @param request (optional) 
     * @return Success
     */
    webhookTest(security_Key: string | null | undefined, request: WebhookRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/outbound-events/webhook-test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Security-Key": security_Key !== undefined && security_Key !== null ? "" + security_Key : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhookTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhookTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWebhookTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsProductAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param cvt (optional) 
     * @param o (optional) 
     * @return Success
     */
    getProducts(cvt: ConsumptionValidationToolEnum[] | null | undefined, o: any | null | undefined): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/admin/products/all?";
        if (cvt !== undefined && cvt !== null)
            cvt && cvt.forEach(item => { url_ += "cvt=" + encodeURIComponent("" + item) + "&"; });
        if (o !== undefined && o !== null)
            url_ += "o=" + encodeURIComponent("" + o) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsReceiptAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search receipts
     * @param query (optional) 
     * @return Success
     */
    queryReceipts(query: ReceiptQuery | null | undefined): Observable<ReceiptResponse> {
        let url_ = this.baseUrl + "/api/admin/receipt/queryReceipts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryReceipts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptResponse>;
        }));
    }

    protected processQueryReceipts(response: HttpResponseBase): Observable<ReceiptResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get receipt by id
     * @return Success
     */
    getReceiptById(id: string): Observable<Receipt> {
        let url_ = this.baseUrl + "/api/admin/receipt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Receipt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Receipt>;
        }));
    }

    protected processGetReceiptById(response: HttpResponseBase): Observable<Receipt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Receipt.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update receipt by id
     * @param request (optional) 
     * @return Success
     */
    updateReceiptById(id: string, request: UpdateReceiptRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/receipt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceiptById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceiptById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReceiptById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete receipt by id
     * @return Success
     */
    deleteReceiptById(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/receipt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReceiptById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceiptById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteReceiptById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getReceiptHistory(id: string): Observable<ReceiptHistoryChange[]> {
        let url_ = this.baseUrl + "/api/admin/receipt/receipt-history/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptHistoryChange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptHistoryChange[]>;
        }));
    }

    protected processGetReceiptHistory(response: HttpResponseBase): Observable<ReceiptHistoryChange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReceiptHistoryChange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get receipt detailed information including history changes and campaign details
     * @return Success
     */
    getReceiptDetailedInfo(docId: string): Observable<ReceiptDetailedInfoResponse> {
        let url_ = this.baseUrl + "/api/admin/receipt/receipt-detailed-info/{docId}";
        if (docId === undefined || docId === null)
            throw new globalThis.Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptDetailedInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptDetailedInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptDetailedInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptDetailedInfoResponse>;
        }));
    }

    protected processGetReceiptDetailedInfo(response: HttpResponseBase): Observable<ReceiptDetailedInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDetailedInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param text (optional) 
     * @param skip (optional) 
     * @param maxItems (optional) 
     * @return Success
     */
    searchReceiptsByText(text: string | null | undefined, skip: number | null | undefined, maxItems: number | null | undefined): Observable<ReceiptResponse> {
        let url_ = this.baseUrl + "/api/admin/receipt/searchReceiptsByText?";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (maxItems !== undefined && maxItems !== null)
            url_ += "maxItems=" + encodeURIComponent("" + maxItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReceiptsByText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReceiptsByText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptResponse>;
        }));
    }

    protected processSearchReceiptsByText(response: HttpResponseBase): Observable<ReceiptResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * import user consumption from csv file
     * @param model (optional) 
     * @return Success
     */
    importUserConsumption(model: ImportUserConsumption | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/receipt/import-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportUserConsumption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportUserConsumption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportUserConsumption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get import file upload url
     * @return Success
     */
    getImportFileUploadUrlS3(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/receipt/getImportFileUploadUrlS3/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportFileUploadUrlS3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportFileUploadUrlS3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetImportFileUploadUrlS3(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send email error
     * @param errorMessage (optional) 
     * @param model (optional) 
     * @return Success
     */
    sendMailErrorImportFile(errorMessage: string | null | undefined, model: ImportUserConsumption | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/receipt/importFile/sendMailError?";
        if (errorMessage !== undefined && errorMessage !== null)
            url_ += "errorMessage=" + encodeURIComponent("" + errorMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailErrorImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailErrorImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailErrorImportFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsReceiptCodeAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search receipts
     * @param query (optional) 
     * @return Success
     */
    queryReceiptCodes(query: ReceiptCodeQuery | null | undefined): Observable<ReceiptCodeResponse> {
        let url_ = this.baseUrl + "/api/admin/receipt-code/queryReceiptCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryReceiptCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryReceiptCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptCodeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptCodeResponse>;
        }));
    }

    protected processQueryReceiptCodes(response: HttpResponseBase): Observable<ReceiptCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptCodeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    generateSample(request: GenerateSampleRequest | null | undefined): Observable<GenerateSampleResponse> {
        let url_ = this.baseUrl + "/api/admin/receipt-code/generate-sample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateSampleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateSampleResponse>;
        }));
    }

    protected processGenerateSample(response: HttpResponseBase): Observable<GenerateSampleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateSampleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsSafeBoxAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates an universal code for the given campaign. This code is a reusable qr-code that would make the user automatically join the campaing.
     * @param campaignId (optional) 
     * @return Success
     */
    createUniversalCode(campaignId: string | null | undefined): Observable<SafeBox> {
        let url_ = this.baseUrl + "/api/admin/safe-box";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaignId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUniversalCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUniversalCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBox>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBox>;
        }));
    }

    protected processCreateUniversalCode(response: HttpResponseBase): Observable<SafeBox> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SafeBox.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param safeBoxProductSku (optional) 
     * @return Success
     */
    createSafeBoxProductSku(safeBoxProductSku: AddSafeBoxProductSku | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/safe-box/safeBox-product-sku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(safeBoxProductSku);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSafeBoxProductSku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSafeBoxProductSku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSafeBoxProductSku(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUploadUrlS3(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/safe-box/getUploadUrlS3/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadUrlS3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadUrlS3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUploadUrlS3(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param errorMessage (optional) 
     * @param safeBoxProductSku (optional) 
     * @return Success
     */
    sendMailError(errorMessage: string | null | undefined, safeBoxProductSku: ImportSafeBoxProductSku | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/safe-box/sendMailError?";
        if (errorMessage !== undefined && errorMessage !== null)
            url_ += "errorMessage=" + encodeURIComponent("" + errorMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(safeBoxProductSku);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMailError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param safeBoxProductSku (optional) 
     * @return Success
     */
    importSafeBoxProductSku(safeBoxProductSku: ImportSafeBoxProductSku | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/safe-box/import-safeBox-product-sku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(safeBoxProductSku);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSafeBoxProductSku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSafeBoxProductSku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportSafeBoxProductSku(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Lists recent Simulate/Redeem batch jobs across all staff, newest first, so the UI can offer
    to resume watching a job after navigating away.
     * @param limit (optional) 
     * @return Success
     */
    getSafeBoxBatchJobHistory(limit: number | null | undefined): Observable<SafeBoxBatchJobSummaryResponse[]> {
        let url_ = this.baseUrl + "/api/admin/safe-box/jobs?";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSafeBoxBatchJobHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafeBoxBatchJobHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxBatchJobSummaryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxBatchJobSummaryResponse[]>;
        }));
    }

    protected processGetSafeBoxBatchJobHistory(response: HttpResponseBase): Observable<SafeBoxBatchJobSummaryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SafeBoxBatchJobSummaryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Starts a batch simulation of redeeming a list of (user_id, code) SafeBox rows from a CSV file.
    This is a read-only preview - it calls the existing SafeBoxController.GetSafeBox(precheck: true)
    for each row and does not consume any code.
     * @param request (optional) S3 key of the uploaded CSV
     * @return Success
     */
    simulateRedeemSafeBoxCodes(request: SafeBoxStartSimulationRequest | null | undefined): Observable<SafeBoxSimulationStartResponse> {
        let url_ = this.baseUrl + "/api/admin/safe-box/simulate-redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSimulateRedeemSafeBoxCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSimulateRedeemSafeBoxCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxSimulationStartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxSimulationStartResponse>;
        }));
    }

    protected processSimulateRedeemSafeBoxCodes(response: HttpResponseBase): Observable<SafeBoxSimulationStartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SafeBoxSimulationStartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the progress of a running/completed SafeBox redeem simulation.
     * @return Success
     */
    getSimulateRedeemProgress(simulationId: string): Observable<SafeBoxSimulationProgressResponse> {
        let url_ = this.baseUrl + "/api/admin/safe-box/simulate-redeem/{simulationId}/progress";
        if (simulationId === undefined || simulationId === null)
            throw new globalThis.Error("The parameter 'simulationId' must be defined.");
        url_ = url_.replace("{simulationId}", encodeURIComponent("" + simulationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimulateRedeemProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimulateRedeemProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxSimulationProgressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxSimulationProgressResponse>;
        }));
    }

    protected processGetSimulateRedeemProgress(response: HttpResponseBase): Observable<SafeBoxSimulationProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SafeBoxSimulationProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the per-row results of a completed SafeBox redeem simulation.
     * @return Success
     */
    getSimulateRedeemResults(simulationId: string): Observable<SafeBoxSimulationRowResponse[]> {
        let url_ = this.baseUrl + "/api/admin/safe-box/simulate-redeem/{simulationId}/results";
        if (simulationId === undefined || simulationId === null)
            throw new globalThis.Error("The parameter 'simulationId' must be defined.");
        url_ = url_.replace("{simulationId}", encodeURIComponent("" + simulationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimulateRedeemResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimulateRedeemResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxSimulationRowResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxSimulationRowResponse[]>;
        }));
    }

    protected processGetSimulateRedeemResults(response: HttpResponseBase): Observable<SafeBoxSimulationRowResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SafeBoxSimulationRowResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirms and starts the real redemption of the selected rows from a completed simulation.
    Calls the existing SafeBoxController.RedeemSafeBox for each row - this is the irreversible action.
     * @param request (optional) 
     * @return Success
     */
    confirmRedeemSafeBoxCodes(simulationId: string, request: SafeBoxConfirmRedeemRequest | null | undefined): Observable<SafeBoxRedeemStartResponse> {
        let url_ = this.baseUrl + "/api/admin/safe-box/simulate-redeem/{simulationId}/confirm";
        if (simulationId === undefined || simulationId === null)
            throw new globalThis.Error("The parameter 'simulationId' must be defined.");
        url_ = url_.replace("{simulationId}", encodeURIComponent("" + simulationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmRedeemSafeBoxCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmRedeemSafeBoxCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxRedeemStartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxRedeemStartResponse>;
        }));
    }

    protected processConfirmRedeemSafeBoxCodes(response: HttpResponseBase): Observable<SafeBoxRedeemStartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SafeBoxRedeemStartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the progress of a running/completed SafeBox redeem execution job.
     * @return Success
     */
    getRedeemProgress(redeemJobId: string): Observable<SafeBoxRedeemProgressResponse> {
        let url_ = this.baseUrl + "/api/admin/safe-box/redeem/{redeemJobId}/progress";
        if (redeemJobId === undefined || redeemJobId === null)
            throw new globalThis.Error("The parameter 'redeemJobId' must be defined.");
        url_ = url_.replace("{redeemJobId}", encodeURIComponent("" + redeemJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRedeemProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedeemProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxRedeemProgressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxRedeemProgressResponse>;
        }));
    }

    protected processGetRedeemProgress(response: HttpResponseBase): Observable<SafeBoxRedeemProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SafeBoxRedeemProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the per-row results of a completed SafeBox redeem execution job.
     * @return Success
     */
    getRedeemResults(redeemJobId: string): Observable<SafeBoxRedeemRowResponse[]> {
        let url_ = this.baseUrl + "/api/admin/safe-box/redeem/{redeemJobId}/results";
        if (redeemJobId === undefined || redeemJobId === null)
            throw new globalThis.Error("The parameter 'redeemJobId' must be defined.");
        url_ = url_.replace("{redeemJobId}", encodeURIComponent("" + redeemJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRedeemResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedeemResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeBoxRedeemRowResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeBoxRedeemRowResponse[]>;
        }));
    }

    protected processGetRedeemResults(response: HttpResponseBase): Observable<SafeBoxRedeemRowResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SafeBoxRedeemRowResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsSchemeLocationFilterAdminApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Save or update a campaign location filter
     * @param request (optional) 
     * @return Success
     */
    save3(request: SchemeLocationFilter | null | undefined): Observable<SchemeLocationFilter> {
        let url_ = this.baseUrl + "/api/admin/scheme-location-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchemeLocationFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchemeLocationFilter>;
        }));
    }

    protected processSave3(response: HttpResponseBase): Observable<SchemeLocationFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchemeLocationFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the campaign location filters
     * @return Success
     */
    getBySchemeId(schemeId: string): Observable<SchemeLocationFilter> {
        let url_ = this.baseUrl + "/api/admin/scheme-location-filters/{schemeId}";
        if (schemeId === undefined || schemeId === null)
            throw new globalThis.Error("The parameter 'schemeId' must be defined.");
        url_ = url_.replace("{schemeId}", encodeURIComponent("" + schemeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySchemeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySchemeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchemeLocationFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchemeLocationFilter>;
        }));
    }

    protected processGetBySchemeId(response: HttpResponseBase): Observable<SchemeLocationFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchemeLocationFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a campaign location filter
     * @return Success
     */
    delete3(schemeId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/scheme-location-filters/{schemeId}";
        if (schemeId === undefined || schemeId === null)
            throw new globalThis.Error("The parameter 'schemeId' must be defined.");
        url_ = url_.replace("{schemeId}", encodeURIComponent("" + schemeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsTestHelperApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    clearTestUserData(organizationId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/postman/TestHelper/clearOrganizationTestData/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearTestUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearTestUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearTestUserData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignsVersionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_CAMPAIGNS_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get the API version of the device management sub-domain..
     * @return Success
     */
    getVersionInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Helper method used to test exception handling.
     * @return Success
     */
    testException(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestException(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    myTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/myversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMyTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddSafeBoxProductSku implements IAddSafeBoxProductSku {
    tags?: string | undefined;
    email?: string | undefined;
    productSkuId?: string | undefined;
    productSkuName?: string | undefined;
    numberOfSafeboxToCreate?: number | undefined;
    format?: string | undefined;
    readonly numberOfCharacters?: number | undefined;
    userId?: string | undefined;
    noOfCodesGeneratedSoFar?: number | undefined;
    noOfCodesPerIteration?: number | undefined;
    safeBoxS3Link?: string | undefined;
    safeBoxS3KeyNamePrefix?: string | undefined;
    safeBoxS3KeyNames?: string[] | undefined;

    constructor(data?: IAddSafeBoxProductSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tags = _data["tags"];
            this.email = _data["email"];
            this.productSkuId = _data["productSkuId"];
            this.productSkuName = _data["productSkuName"];
            this.numberOfSafeboxToCreate = _data["numberOfSafeboxToCreate"];
            this.format = _data["format"];
            (this as any).numberOfCharacters = _data["numberOfCharacters"];
            this.userId = _data["userId"];
            this.noOfCodesGeneratedSoFar = _data["noOfCodesGeneratedSoFar"];
            this.noOfCodesPerIteration = _data["noOfCodesPerIteration"];
            this.safeBoxS3Link = _data["safeBoxS3Link"];
            this.safeBoxS3KeyNamePrefix = _data["safeBoxS3KeyNamePrefix"];
            if (Array.isArray(_data["safeBoxS3KeyNames"])) {
                this.safeBoxS3KeyNames = [] as any;
                for (let item of _data["safeBoxS3KeyNames"])
                    this.safeBoxS3KeyNames!.push(item);
            }
        }
    }

    static fromJS(data: any): AddSafeBoxProductSku {
        data = typeof data === 'object' ? data : {};
        let result = new AddSafeBoxProductSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tags"] = this.tags;
        data["email"] = this.email;
        data["productSkuId"] = this.productSkuId;
        data["productSkuName"] = this.productSkuName;
        data["numberOfSafeboxToCreate"] = this.numberOfSafeboxToCreate;
        data["format"] = this.format;
        data["numberOfCharacters"] = this.numberOfCharacters;
        data["userId"] = this.userId;
        data["noOfCodesGeneratedSoFar"] = this.noOfCodesGeneratedSoFar;
        data["noOfCodesPerIteration"] = this.noOfCodesPerIteration;
        data["safeBoxS3Link"] = this.safeBoxS3Link;
        data["safeBoxS3KeyNamePrefix"] = this.safeBoxS3KeyNamePrefix;
        if (Array.isArray(this.safeBoxS3KeyNames)) {
            data["safeBoxS3KeyNames"] = [];
            for (let item of this.safeBoxS3KeyNames)
                data["safeBoxS3KeyNames"].push(item);
        }
        return data;
    }
}

export interface IAddSafeBoxProductSku {
    tags?: string | undefined;
    email?: string | undefined;
    productSkuId?: string | undefined;
    productSkuName?: string | undefined;
    numberOfSafeboxToCreate?: number | undefined;
    format?: string | undefined;
    numberOfCharacters?: number | undefined;
    userId?: string | undefined;
    noOfCodesGeneratedSoFar?: number | undefined;
    noOfCodesPerIteration?: number | undefined;
    safeBoxS3Link?: string | undefined;
    safeBoxS3KeyNamePrefix?: string | undefined;
    safeBoxS3KeyNames?: string[] | undefined;
}

export class Advertiser implements IAdvertiser {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    appToRedirect?: string | undefined;
    organizationIds?: string[] | undefined;
    organizationNames?: string[] | undefined;
    linkedCampaigns?: LinkedCampaigns[] | undefined;
    dataConnection?: ConsumerDataConnection | undefined;
    profileFieldConfiguration?: ProfileFieldConfiguration | undefined;
    createdAt?: Date | undefined;
    outboundEventIntegrations?: OutboundEventIntegrationConfig[] | undefined;
    loginOptions?: AdvertiserLoginOptions | undefined;
    countries?: string[] | undefined;
    languages?: AdvertiserLanguage[] | undefined;
    primaryLanguage?: string | undefined;

    constructor(data?: IAdvertiser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoFull = _data["photoFull"];
            this.photoThumb = _data["photoThumb"];
            this.appToRedirect = _data["appToRedirect"];
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            if (Array.isArray(_data["organizationNames"])) {
                this.organizationNames = [] as any;
                for (let item of _data["organizationNames"])
                    this.organizationNames!.push(item);
            }
            if (Array.isArray(_data["linkedCampaigns"])) {
                this.linkedCampaigns = [] as any;
                for (let item of _data["linkedCampaigns"])
                    this.linkedCampaigns!.push(LinkedCampaigns.fromJS(item));
            }
            this.dataConnection = _data["dataConnection"] ? ConsumerDataConnection.fromJS(_data["dataConnection"]) : undefined as any;
            this.profileFieldConfiguration = _data["profileFieldConfiguration"] ? ProfileFieldConfiguration.fromJS(_data["profileFieldConfiguration"]) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["outboundEventIntegrations"])) {
                this.outboundEventIntegrations = [] as any;
                for (let item of _data["outboundEventIntegrations"])
                    this.outboundEventIntegrations!.push(OutboundEventIntegrationConfig.fromJS(item));
            }
            this.loginOptions = _data["loginOptions"] ? AdvertiserLoginOptions.fromJS(_data["loginOptions"]) : undefined as any;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(AdvertiserLanguage.fromJS(item));
            }
            this.primaryLanguage = _data["primaryLanguage"];
        }
    }

    static fromJS(data: any): Advertiser {
        data = typeof data === 'object' ? data : {};
        let result = new Advertiser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoFull"] = this.photoFull;
        data["photoThumb"] = this.photoThumb;
        data["appToRedirect"] = this.appToRedirect;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.organizationNames)) {
            data["organizationNames"] = [];
            for (let item of this.organizationNames)
                data["organizationNames"].push(item);
        }
        if (Array.isArray(this.linkedCampaigns)) {
            data["linkedCampaigns"] = [];
            for (let item of this.linkedCampaigns)
                data["linkedCampaigns"].push(item ? item.toJSON() : undefined as any);
        }
        data["dataConnection"] = this.dataConnection ? this.dataConnection.toJSON() : undefined as any;
        data["profileFieldConfiguration"] = this.profileFieldConfiguration ? this.profileFieldConfiguration.toJSON() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (Array.isArray(this.outboundEventIntegrations)) {
            data["outboundEventIntegrations"] = [];
            for (let item of this.outboundEventIntegrations)
                data["outboundEventIntegrations"].push(item ? item.toJSON() : undefined as any);
        }
        data["loginOptions"] = this.loginOptions ? this.loginOptions.toJSON() : undefined as any;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["primaryLanguage"] = this.primaryLanguage;
        return data;
    }
}

export interface IAdvertiser {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    appToRedirect?: string | undefined;
    organizationIds?: string[] | undefined;
    organizationNames?: string[] | undefined;
    linkedCampaigns?: LinkedCampaigns[] | undefined;
    dataConnection?: ConsumerDataConnection | undefined;
    profileFieldConfiguration?: ProfileFieldConfiguration | undefined;
    createdAt?: Date | undefined;
    outboundEventIntegrations?: OutboundEventIntegrationConfig[] | undefined;
    loginOptions?: AdvertiserLoginOptions | undefined;
    countries?: string[] | undefined;
    languages?: AdvertiserLanguage[] | undefined;
    primaryLanguage?: string | undefined;
}

export class AdvertiserDto implements IAdvertiserDto {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean | undefined;
    description?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    appToRedirect?: string | undefined;
    organizationIds?: string[] | undefined;
    organizationNames?: string[] | undefined;
    createdAt?: Date | undefined;
    countries?: string[] | undefined;
    languages?: AdvertiserLanguageDto[] | undefined;
    primaryLanguage?: string | undefined;

    constructor(data?: IAdvertiserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.photoFull = _data["photoFull"];
            this.photoThumb = _data["photoThumb"];
            this.appToRedirect = _data["appToRedirect"];
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            if (Array.isArray(_data["organizationNames"])) {
                this.organizationNames = [] as any;
                for (let item of _data["organizationNames"])
                    this.organizationNames!.push(item);
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(AdvertiserLanguageDto.fromJS(item));
            }
            this.primaryLanguage = _data["primaryLanguage"];
        }
    }

    static fromJS(data: any): AdvertiserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["photoFull"] = this.photoFull;
        data["photoThumb"] = this.photoThumb;
        data["appToRedirect"] = this.appToRedirect;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.organizationNames)) {
            data["organizationNames"] = [];
            for (let item of this.organizationNames)
                data["organizationNames"].push(item);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["primaryLanguage"] = this.primaryLanguage;
        return data;
    }
}

export interface IAdvertiserDto {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean | undefined;
    description?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    appToRedirect?: string | undefined;
    organizationIds?: string[] | undefined;
    organizationNames?: string[] | undefined;
    createdAt?: Date | undefined;
    countries?: string[] | undefined;
    languages?: AdvertiserLanguageDto[] | undefined;
    primaryLanguage?: string | undefined;
}

export class AdvertiserLanguage implements IAdvertiserLanguage {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAdvertiserLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvertiserLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvertiserLanguage {
    code?: string | undefined;
    name?: string | undefined;
}

export class AdvertiserLanguageDto implements IAdvertiserLanguageDto {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAdvertiserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdvertiserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdvertiserLanguageDto {
    code?: string | undefined;
    name?: string | undefined;
}

export class AdvertiserLoginOptions implements IAdvertiserLoginOptions {
    phoneOtpEnabled?: boolean | undefined;
    emailOtpEnabled?: boolean | undefined;
    emailPasswordEnabled?: boolean | undefined;
    googleEnabled?: boolean | undefined;
    appleEnabled?: boolean | undefined;
    batSsoEnabled?: boolean | undefined;
    defaultLoginMethod?: string | undefined;
    allowedCountryCodes?: string[] | undefined;

    constructor(data?: IAdvertiserLoginOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneOtpEnabled = _data["phoneOtpEnabled"];
            this.emailOtpEnabled = _data["emailOtpEnabled"];
            this.emailPasswordEnabled = _data["emailPasswordEnabled"];
            this.googleEnabled = _data["googleEnabled"];
            this.appleEnabled = _data["appleEnabled"];
            this.batSsoEnabled = _data["batSsoEnabled"];
            this.defaultLoginMethod = _data["defaultLoginMethod"];
            if (Array.isArray(_data["allowedCountryCodes"])) {
                this.allowedCountryCodes = [] as any;
                for (let item of _data["allowedCountryCodes"])
                    this.allowedCountryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): AdvertiserLoginOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserLoginOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneOtpEnabled"] = this.phoneOtpEnabled;
        data["emailOtpEnabled"] = this.emailOtpEnabled;
        data["emailPasswordEnabled"] = this.emailPasswordEnabled;
        data["googleEnabled"] = this.googleEnabled;
        data["appleEnabled"] = this.appleEnabled;
        data["batSsoEnabled"] = this.batSsoEnabled;
        data["defaultLoginMethod"] = this.defaultLoginMethod;
        if (Array.isArray(this.allowedCountryCodes)) {
            data["allowedCountryCodes"] = [];
            for (let item of this.allowedCountryCodes)
                data["allowedCountryCodes"].push(item);
        }
        return data;
    }
}

export interface IAdvertiserLoginOptions {
    phoneOtpEnabled?: boolean | undefined;
    emailOtpEnabled?: boolean | undefined;
    emailPasswordEnabled?: boolean | undefined;
    googleEnabled?: boolean | undefined;
    appleEnabled?: boolean | undefined;
    batSsoEnabled?: boolean | undefined;
    defaultLoginMethod?: string | undefined;
    allowedCountryCodes?: string[] | undefined;
}

export class AdvertiserQueryRequestDto implements IAdvertiserQueryRequestDto {
    names?: string[] | undefined;
    countries?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IAdvertiserQueryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): AdvertiserQueryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserQueryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IAdvertiserQueryRequestDto {
    names?: string[] | undefined;
    countries?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;
}

export class AdvertiserQueryResponseDto implements IAdvertiserQueryResponseDto {
    items?: AdvertiserDto[] | undefined;
    total?: number | undefined;

    constructor(data?: IAdvertiserQueryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdvertiserDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AdvertiserQueryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserQueryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IAdvertiserQueryResponseDto {
    items?: AdvertiserDto[] | undefined;
    total?: number | undefined;
}

export class AdvertiserUserRoleRequest implements IAdvertiserUserRoleRequest {
    advertiserId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAdvertiserUserRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiserId = _data["advertiserId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): AdvertiserUserRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserUserRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiserId"] = this.advertiserId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IAdvertiserUserRoleRequest {
    advertiserId?: string | undefined;
    organizationId?: string | undefined;
}

export class ApiKey implements IApiKey {
    id?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IApiKey {
    id?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;
}

export class BottleProductInfo implements IBottleProductInfo {
    id?: string | undefined;
    name?: string | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    bottleCapIds?: string[] | undefined;

    constructor(data?: IBottleProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            if (Array.isArray(_data["bottleCapIds"])) {
                this.bottleCapIds = [] as any;
                for (let item of _data["bottleCapIds"])
                    this.bottleCapIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BottleProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BottleProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        if (Array.isArray(this.bottleCapIds)) {
            data["bottleCapIds"] = [];
            for (let item of this.bottleCapIds)
                data["bottleCapIds"].push(item);
        }
        return data;
    }
}

export interface IBottleProductInfo {
    id?: string | undefined;
    name?: string | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    bottleCapIds?: string[] | undefined;
}

export enum CalculationBasedType {
    QuantityBased = "QuantityBased",
    ValueBased = "ValueBased",
}

export class Campaign implements ICampaign {
    id?: string | undefined;
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    advertiser?: Advertiser | undefined;
    userId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    detailedDescription?: string | undefined;
    detailedDescriptionJoined?: string | undefined;
    detailedDescriptionJoinedForRetailer?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    photoBannerUrl?: string | undefined;
    staffReferralBanner?: CampaignBanner | undefined;
    staffReferralThumbnailUrl?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    timeZoneInfoId?: string | undefined;
    readonly localEndDate?: Date | undefined;
    dateUpdated?: Date | undefined;
    createdAt?: Date | undefined;
    onboardingUrl?: string | undefined;
    shouldAdvertise?: boolean | undefined;
    canJoin?: boolean | undefined;
    allowDuplicates?: boolean | undefined;
    allowGiveStamps?: boolean | undefined;
    termAndConditions?: string | undefined;
    privacyPolicy?: string | undefined;
    overAge?: boolean | undefined;
    dynamicAge?: number | undefined;
    isGlobal?: boolean | undefined;
    targetUser?: CampaignTargetUser | undefined;
    synchronizationContactGLO?: boolean | undefined;
    synchronizationDataConsumerGLO?: boolean | undefined;
    countries?: string[] | undefined;
    allowedCountryCodes?: string[] | undefined;
    languages?: CampaignLanguage[] | undefined;
    primaryLanguage?: string | undefined;
    strategy?: any | undefined;
    readonly isPunchCardStrategy?: boolean | undefined;
    readonly isLuckyDrawStrategy?: boolean | undefined;
    readonly isStaffCampaignStrategy?: boolean | undefined;
    readonly isReferralCampaignStrategy?: boolean | undefined;
    readonly isConsumerReferralStrategy?: boolean | undefined;
    readonly isConsumerInformationStrategy?: boolean | undefined;
    readonly isStaffInformationStrategy?: boolean | undefined;
    readonly isStaffPointStrategy?: boolean | undefined;
    readonly isMultiCampaignStrategy?: boolean | undefined;
    readonly isOpenerStrategy?: boolean | undefined;
    status?: CampaignStatus | undefined;
    bannerDuration?: number | undefined;
    blockRedemptionOnJoin?: boolean | undefined;
    isForceUsingMobileApp?: boolean | undefined;
    shouldHideParticipatingLocations?: boolean | undefined;
    outboundEventIntegrations?: OutboundEventIntegrationConfig[] | undefined;

    constructor(data?: ICampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.advertiserId = _data["advertiserId"];
            this.campaignId = _data["campaignId"];
            this.advertiser = _data["advertiser"] ? Advertiser.fromJS(_data["advertiser"]) : undefined as any;
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.detailedDescription = _data["detailedDescription"];
            this.detailedDescriptionJoined = _data["detailedDescriptionJoined"];
            this.detailedDescriptionJoinedForRetailer = _data["detailedDescriptionJoinedForRetailer"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
            this.photoBannerUrl = _data["photoBannerUrl"];
            this.staffReferralBanner = _data["staffReferralBanner"] ? CampaignBanner.fromJS(_data["staffReferralBanner"]) : undefined as any;
            this.staffReferralThumbnailUrl = _data["staffReferralThumbnailUrl"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            (this as any).localEndDate = _data["localEndDate"] ? new Date(_data["localEndDate"].toString()) : undefined as any;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.onboardingUrl = _data["onboardingUrl"];
            this.shouldAdvertise = _data["shouldAdvertise"];
            this.canJoin = _data["canJoin"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.allowGiveStamps = _data["allowGiveStamps"];
            this.termAndConditions = _data["termAndConditions"];
            this.privacyPolicy = _data["privacyPolicy"];
            this.overAge = _data["overAge"];
            this.dynamicAge = _data["dynamicAge"];
            this.isGlobal = _data["isGlobal"];
            this.targetUser = _data["targetUser"];
            this.synchronizationContactGLO = _data["synchronizationContactGLO"];
            this.synchronizationDataConsumerGLO = _data["synchronizationDataConsumerGLO"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["allowedCountryCodes"])) {
                this.allowedCountryCodes = [] as any;
                for (let item of _data["allowedCountryCodes"])
                    this.allowedCountryCodes!.push(item);
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(CampaignLanguage.fromJS(item));
            }
            this.primaryLanguage = _data["primaryLanguage"];
            this.strategy = _data["strategy"];
            (this as any).isPunchCardStrategy = _data["isPunchCardStrategy"];
            (this as any).isLuckyDrawStrategy = _data["isLuckyDrawStrategy"];
            (this as any).isStaffCampaignStrategy = _data["isStaffCampaignStrategy"];
            (this as any).isReferralCampaignStrategy = _data["isReferralCampaignStrategy"];
            (this as any).isConsumerReferralStrategy = _data["isConsumerReferralStrategy"];
            (this as any).isConsumerInformationStrategy = _data["isConsumerInformationStrategy"];
            (this as any).isStaffInformationStrategy = _data["isStaffInformationStrategy"];
            (this as any).isStaffPointStrategy = _data["isStaffPointStrategy"];
            (this as any).isMultiCampaignStrategy = _data["isMultiCampaignStrategy"];
            (this as any).isOpenerStrategy = _data["isOpenerStrategy"];
            this.status = _data["status"];
            this.bannerDuration = _data["bannerDuration"];
            this.blockRedemptionOnJoin = _data["blockRedemptionOnJoin"];
            this.isForceUsingMobileApp = _data["isForceUsingMobileApp"];
            this.shouldHideParticipatingLocations = _data["shouldHideParticipatingLocations"];
            if (Array.isArray(_data["outboundEventIntegrations"])) {
                this.outboundEventIntegrations = [] as any;
                for (let item of _data["outboundEventIntegrations"])
                    this.outboundEventIntegrations!.push(OutboundEventIntegrationConfig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["advertiserId"] = this.advertiserId;
        data["campaignId"] = this.campaignId;
        data["advertiser"] = this.advertiser ? this.advertiser.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["detailedDescription"] = this.detailedDescription;
        data["detailedDescriptionJoined"] = this.detailedDescriptionJoined;
        data["detailedDescriptionJoinedForRetailer"] = this.detailedDescriptionJoinedForRetailer;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        data["photoBannerUrl"] = this.photoBannerUrl;
        data["staffReferralBanner"] = this.staffReferralBanner ? this.staffReferralBanner.toJSON() : undefined as any;
        data["staffReferralThumbnailUrl"] = this.staffReferralThumbnailUrl;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["localEndDate"] = this.localEndDate ? this.localEndDate.toISOString() : undefined as any;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["onboardingUrl"] = this.onboardingUrl;
        data["shouldAdvertise"] = this.shouldAdvertise;
        data["canJoin"] = this.canJoin;
        data["allowDuplicates"] = this.allowDuplicates;
        data["allowGiveStamps"] = this.allowGiveStamps;
        data["termAndConditions"] = this.termAndConditions;
        data["privacyPolicy"] = this.privacyPolicy;
        data["overAge"] = this.overAge;
        data["dynamicAge"] = this.dynamicAge;
        data["isGlobal"] = this.isGlobal;
        data["targetUser"] = this.targetUser;
        data["synchronizationContactGLO"] = this.synchronizationContactGLO;
        data["synchronizationDataConsumerGLO"] = this.synchronizationDataConsumerGLO;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.allowedCountryCodes)) {
            data["allowedCountryCodes"] = [];
            for (let item of this.allowedCountryCodes)
                data["allowedCountryCodes"].push(item);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["primaryLanguage"] = this.primaryLanguage;
        data["strategy"] = this.strategy;
        data["isPunchCardStrategy"] = this.isPunchCardStrategy;
        data["isLuckyDrawStrategy"] = this.isLuckyDrawStrategy;
        data["isStaffCampaignStrategy"] = this.isStaffCampaignStrategy;
        data["isReferralCampaignStrategy"] = this.isReferralCampaignStrategy;
        data["isConsumerReferralStrategy"] = this.isConsumerReferralStrategy;
        data["isConsumerInformationStrategy"] = this.isConsumerInformationStrategy;
        data["isStaffInformationStrategy"] = this.isStaffInformationStrategy;
        data["isStaffPointStrategy"] = this.isStaffPointStrategy;
        data["isMultiCampaignStrategy"] = this.isMultiCampaignStrategy;
        data["isOpenerStrategy"] = this.isOpenerStrategy;
        data["status"] = this.status;
        data["bannerDuration"] = this.bannerDuration;
        data["blockRedemptionOnJoin"] = this.blockRedemptionOnJoin;
        data["isForceUsingMobileApp"] = this.isForceUsingMobileApp;
        data["shouldHideParticipatingLocations"] = this.shouldHideParticipatingLocations;
        if (Array.isArray(this.outboundEventIntegrations)) {
            data["outboundEventIntegrations"] = [];
            for (let item of this.outboundEventIntegrations)
                data["outboundEventIntegrations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICampaign {
    id?: string | undefined;
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    advertiser?: Advertiser | undefined;
    userId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    detailedDescription?: string | undefined;
    detailedDescriptionJoined?: string | undefined;
    detailedDescriptionJoinedForRetailer?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    photoBannerUrl?: string | undefined;
    staffReferralBanner?: CampaignBanner | undefined;
    staffReferralThumbnailUrl?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    timeZoneInfoId?: string | undefined;
    localEndDate?: Date | undefined;
    dateUpdated?: Date | undefined;
    createdAt?: Date | undefined;
    onboardingUrl?: string | undefined;
    shouldAdvertise?: boolean | undefined;
    canJoin?: boolean | undefined;
    allowDuplicates?: boolean | undefined;
    allowGiveStamps?: boolean | undefined;
    termAndConditions?: string | undefined;
    privacyPolicy?: string | undefined;
    overAge?: boolean | undefined;
    dynamicAge?: number | undefined;
    isGlobal?: boolean | undefined;
    targetUser?: CampaignTargetUser | undefined;
    synchronizationContactGLO?: boolean | undefined;
    synchronizationDataConsumerGLO?: boolean | undefined;
    countries?: string[] | undefined;
    allowedCountryCodes?: string[] | undefined;
    languages?: CampaignLanguage[] | undefined;
    primaryLanguage?: string | undefined;
    strategy?: any | undefined;
    isPunchCardStrategy?: boolean | undefined;
    isLuckyDrawStrategy?: boolean | undefined;
    isStaffCampaignStrategy?: boolean | undefined;
    isReferralCampaignStrategy?: boolean | undefined;
    isConsumerReferralStrategy?: boolean | undefined;
    isConsumerInformationStrategy?: boolean | undefined;
    isStaffInformationStrategy?: boolean | undefined;
    isStaffPointStrategy?: boolean | undefined;
    isMultiCampaignStrategy?: boolean | undefined;
    isOpenerStrategy?: boolean | undefined;
    status?: CampaignStatus | undefined;
    bannerDuration?: number | undefined;
    blockRedemptionOnJoin?: boolean | undefined;
    isForceUsingMobileApp?: boolean | undefined;
    shouldHideParticipatingLocations?: boolean | undefined;
    outboundEventIntegrations?: OutboundEventIntegrationConfig[] | undefined;
}

/** Create a campaign by administrator */
export class CampaignAdminRequest implements ICampaignAdminRequest {
    /** Gets/Sets the title of the campaign */
    title?: string | undefined;
    /** Gets/Sets the description of the campaign. */
    description?: string | undefined;
    /** Term and Conditions for joining a campaing */
    termAndConditions?: string | undefined;
    /** Privacy Policy for joining a campaing */
    privacyPolicy?: string | undefined;
    /** Gets/Sets the description of the campaign. */
    detailedDescription?: string | undefined;
    /** Gets/Sets the description when user joined the campaign */
    detailedDescriptionJoined?: string | undefined;
    /** Gets/Sets the description when user joined the HandsahkeQR campaign */
    detailedDescriptionJoinedForRetailer?: string | undefined;
    /** Gets/Sets the campaign banner url */
    photoBannerUrl?: string | undefined;
    /** Gets/Sets the photo campaign url */
    photoFullUrl?: string | undefined;
    /** Gets/Sets the thumb campaign url */
    photoThumbUrl?: string | undefined;
    /** Gets/Sets a value indicating whether the campaign should be advertised or not */
    shouldAdvertise?: boolean | undefined;
    /** Flag to ask the user if is over 18 years when joining the campaign */
    overAge?: boolean | undefined;
    /** Dynamic Age for precondition */
    dynamicAge?: number | undefined;
    /** Gets/Sets whether customers can join the campaign themselves */
    canJoin?: boolean | undefined;
    /** Gets/Sets the value indicating whether this strategy allows for duplicate consumption events. true should be used only for testing. */
    allowDuplicates?: boolean | undefined;
    /** Default is true. Set to false to block staff from giving stamps. */
    allowGiveStamps?: boolean | undefined;
    campaignStatus?: CampaignStatus | undefined;
    /** Gets/sets the campaign id */
    campaignId?: string | undefined;
    /** Gets/Sets the advertiser id */
    advertiserId?: string | undefined;
    /** When the campaign starts */
    startDate?: Date | undefined;
    /** When the campaign ends */
    endDate?: Date | undefined;
    timeZoneInfoId?: string | undefined;
    /** Gets/sets the campaign strategy. The strategy describes how the system react for different events from this campaign. */
    strategy?: any | undefined;
    punchCardStrategy?: PunchCardStrategy | undefined;
    luckyDrawStrategy?: LuckyDrawStrategy | undefined;
    staffCampaignStrategy?: StaffCampaignStrategy | undefined;
    referralStrategy?: ReferralStrategy | undefined;
    openerStrategy?: OpenerStrategy | undefined;
    campaignLocationFilter?: CampaignLocationFilter | undefined;
    schemeLocationFilters?: SchemeLocationFilter[] | undefined;
    uploadKey?: string | undefined;
    uploadKeyBanner?: string | undefined;
    uploadKeyReward?: string | undefined;
    onboardingUrl?: string | undefined;
    isGlobal?: boolean | undefined;
    campaignTargetUser?: CampaignTargetUser | undefined;
    synchronizationContactGLO?: boolean | undefined;
    synchronizationDataConsumerGLO?: boolean | undefined;
    consumerReferralCampaigns?: Campaign[] | undefined;
    staffReferralCampaigns?: Campaign[] | undefined;
    countries?: string[] | undefined;
    /** Languages supported by this campaign */
    languages?: CampaignLanguage[] | undefined;
    /** Primary language of this campaign (ISO 639-1 code) */
    primaryLanguage?: string | undefined;
    bannerDuration?: number | undefined;
    /** Blocks redemption on join. */
    blockRedemptionOnJoin?: boolean | undefined;
    isForceUsingMobileApp?: boolean | undefined;
    /** Hide participating locations */
    shouldHideParticipatingLocations?: boolean | undefined;
    /** Allowed country codes for Phone OTP login (ISO 3166-1 alpha-2). Empty means all countries allowed. */
    allowedCountryCodes?: string[] | undefined;

    constructor(data?: ICampaignAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.termAndConditions = _data["termAndConditions"];
            this.privacyPolicy = _data["privacyPolicy"];
            this.detailedDescription = _data["detailedDescription"];
            this.detailedDescriptionJoined = _data["detailedDescriptionJoined"];
            this.detailedDescriptionJoinedForRetailer = _data["detailedDescriptionJoinedForRetailer"];
            this.photoBannerUrl = _data["photoBannerUrl"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
            this.shouldAdvertise = _data["shouldAdvertise"];
            this.overAge = _data["overAge"];
            this.dynamicAge = _data["dynamicAge"];
            this.canJoin = _data["canJoin"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.allowGiveStamps = _data["allowGiveStamps"];
            this.campaignStatus = _data["campaignStatus"];
            this.campaignId = _data["campaignId"];
            this.advertiserId = _data["advertiserId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.strategy = _data["strategy"];
            this.punchCardStrategy = _data["punchCardStrategy"] ? PunchCardStrategy.fromJS(_data["punchCardStrategy"]) : undefined as any;
            this.luckyDrawStrategy = _data["luckyDrawStrategy"] ? LuckyDrawStrategy.fromJS(_data["luckyDrawStrategy"]) : undefined as any;
            this.staffCampaignStrategy = _data["staffCampaignStrategy"] ? StaffCampaignStrategy.fromJS(_data["staffCampaignStrategy"]) : undefined as any;
            this.referralStrategy = _data["referralStrategy"] ? ReferralStrategy.fromJS(_data["referralStrategy"]) : undefined as any;
            this.openerStrategy = _data["openerStrategy"] ? OpenerStrategy.fromJS(_data["openerStrategy"]) : undefined as any;
            this.campaignLocationFilter = _data["campaignLocationFilter"] ? CampaignLocationFilter.fromJS(_data["campaignLocationFilter"]) : undefined as any;
            if (Array.isArray(_data["schemeLocationFilters"])) {
                this.schemeLocationFilters = [] as any;
                for (let item of _data["schemeLocationFilters"])
                    this.schemeLocationFilters!.push(SchemeLocationFilter.fromJS(item));
            }
            this.uploadKey = _data["uploadKey"];
            this.uploadKeyBanner = _data["uploadKeyBanner"];
            this.uploadKeyReward = _data["uploadKeyReward"];
            this.onboardingUrl = _data["onboardingUrl"];
            this.isGlobal = _data["isGlobal"];
            this.campaignTargetUser = _data["campaignTargetUser"];
            this.synchronizationContactGLO = _data["synchronizationContactGLO"];
            this.synchronizationDataConsumerGLO = _data["synchronizationDataConsumerGLO"];
            if (Array.isArray(_data["consumerReferralCampaigns"])) {
                this.consumerReferralCampaigns = [] as any;
                for (let item of _data["consumerReferralCampaigns"])
                    this.consumerReferralCampaigns!.push(Campaign.fromJS(item));
            }
            if (Array.isArray(_data["staffReferralCampaigns"])) {
                this.staffReferralCampaigns = [] as any;
                for (let item of _data["staffReferralCampaigns"])
                    this.staffReferralCampaigns!.push(Campaign.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(CampaignLanguage.fromJS(item));
            }
            this.primaryLanguage = _data["primaryLanguage"];
            this.bannerDuration = _data["bannerDuration"];
            this.blockRedemptionOnJoin = _data["blockRedemptionOnJoin"];
            this.isForceUsingMobileApp = _data["isForceUsingMobileApp"];
            this.shouldHideParticipatingLocations = _data["shouldHideParticipatingLocations"];
            if (Array.isArray(_data["allowedCountryCodes"])) {
                this.allowedCountryCodes = [] as any;
                for (let item of _data["allowedCountryCodes"])
                    this.allowedCountryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): CampaignAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["termAndConditions"] = this.termAndConditions;
        data["privacyPolicy"] = this.privacyPolicy;
        data["detailedDescription"] = this.detailedDescription;
        data["detailedDescriptionJoined"] = this.detailedDescriptionJoined;
        data["detailedDescriptionJoinedForRetailer"] = this.detailedDescriptionJoinedForRetailer;
        data["photoBannerUrl"] = this.photoBannerUrl;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        data["shouldAdvertise"] = this.shouldAdvertise;
        data["overAge"] = this.overAge;
        data["dynamicAge"] = this.dynamicAge;
        data["canJoin"] = this.canJoin;
        data["allowDuplicates"] = this.allowDuplicates;
        data["allowGiveStamps"] = this.allowGiveStamps;
        data["campaignStatus"] = this.campaignStatus;
        data["campaignId"] = this.campaignId;
        data["advertiserId"] = this.advertiserId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["strategy"] = this.strategy;
        data["punchCardStrategy"] = this.punchCardStrategy ? this.punchCardStrategy.toJSON() : undefined as any;
        data["luckyDrawStrategy"] = this.luckyDrawStrategy ? this.luckyDrawStrategy.toJSON() : undefined as any;
        data["staffCampaignStrategy"] = this.staffCampaignStrategy ? this.staffCampaignStrategy.toJSON() : undefined as any;
        data["referralStrategy"] = this.referralStrategy ? this.referralStrategy.toJSON() : undefined as any;
        data["openerStrategy"] = this.openerStrategy ? this.openerStrategy.toJSON() : undefined as any;
        data["campaignLocationFilter"] = this.campaignLocationFilter ? this.campaignLocationFilter.toJSON() : undefined as any;
        if (Array.isArray(this.schemeLocationFilters)) {
            data["schemeLocationFilters"] = [];
            for (let item of this.schemeLocationFilters)
                data["schemeLocationFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["uploadKey"] = this.uploadKey;
        data["uploadKeyBanner"] = this.uploadKeyBanner;
        data["uploadKeyReward"] = this.uploadKeyReward;
        data["onboardingUrl"] = this.onboardingUrl;
        data["isGlobal"] = this.isGlobal;
        data["campaignTargetUser"] = this.campaignTargetUser;
        data["synchronizationContactGLO"] = this.synchronizationContactGLO;
        data["synchronizationDataConsumerGLO"] = this.synchronizationDataConsumerGLO;
        if (Array.isArray(this.consumerReferralCampaigns)) {
            data["consumerReferralCampaigns"] = [];
            for (let item of this.consumerReferralCampaigns)
                data["consumerReferralCampaigns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.staffReferralCampaigns)) {
            data["staffReferralCampaigns"] = [];
            for (let item of this.staffReferralCampaigns)
                data["staffReferralCampaigns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["primaryLanguage"] = this.primaryLanguage;
        data["bannerDuration"] = this.bannerDuration;
        data["blockRedemptionOnJoin"] = this.blockRedemptionOnJoin;
        data["isForceUsingMobileApp"] = this.isForceUsingMobileApp;
        data["shouldHideParticipatingLocations"] = this.shouldHideParticipatingLocations;
        if (Array.isArray(this.allowedCountryCodes)) {
            data["allowedCountryCodes"] = [];
            for (let item of this.allowedCountryCodes)
                data["allowedCountryCodes"].push(item);
        }
        return data;
    }
}

/** Create a campaign by administrator */
export interface ICampaignAdminRequest {
    /** Gets/Sets the title of the campaign */
    title?: string | undefined;
    /** Gets/Sets the description of the campaign. */
    description?: string | undefined;
    /** Term and Conditions for joining a campaing */
    termAndConditions?: string | undefined;
    /** Privacy Policy for joining a campaing */
    privacyPolicy?: string | undefined;
    /** Gets/Sets the description of the campaign. */
    detailedDescription?: string | undefined;
    /** Gets/Sets the description when user joined the campaign */
    detailedDescriptionJoined?: string | undefined;
    /** Gets/Sets the description when user joined the HandsahkeQR campaign */
    detailedDescriptionJoinedForRetailer?: string | undefined;
    /** Gets/Sets the campaign banner url */
    photoBannerUrl?: string | undefined;
    /** Gets/Sets the photo campaign url */
    photoFullUrl?: string | undefined;
    /** Gets/Sets the thumb campaign url */
    photoThumbUrl?: string | undefined;
    /** Gets/Sets a value indicating whether the campaign should be advertised or not */
    shouldAdvertise?: boolean | undefined;
    /** Flag to ask the user if is over 18 years when joining the campaign */
    overAge?: boolean | undefined;
    /** Dynamic Age for precondition */
    dynamicAge?: number | undefined;
    /** Gets/Sets whether customers can join the campaign themselves */
    canJoin?: boolean | undefined;
    /** Gets/Sets the value indicating whether this strategy allows for duplicate consumption events. true should be used only for testing. */
    allowDuplicates?: boolean | undefined;
    /** Default is true. Set to false to block staff from giving stamps. */
    allowGiveStamps?: boolean | undefined;
    campaignStatus?: CampaignStatus | undefined;
    /** Gets/sets the campaign id */
    campaignId?: string | undefined;
    /** Gets/Sets the advertiser id */
    advertiserId?: string | undefined;
    /** When the campaign starts */
    startDate?: Date | undefined;
    /** When the campaign ends */
    endDate?: Date | undefined;
    timeZoneInfoId?: string | undefined;
    /** Gets/sets the campaign strategy. The strategy describes how the system react for different events from this campaign. */
    strategy?: any | undefined;
    punchCardStrategy?: PunchCardStrategy | undefined;
    luckyDrawStrategy?: LuckyDrawStrategy | undefined;
    staffCampaignStrategy?: StaffCampaignStrategy | undefined;
    referralStrategy?: ReferralStrategy | undefined;
    openerStrategy?: OpenerStrategy | undefined;
    campaignLocationFilter?: CampaignLocationFilter | undefined;
    schemeLocationFilters?: SchemeLocationFilter[] | undefined;
    uploadKey?: string | undefined;
    uploadKeyBanner?: string | undefined;
    uploadKeyReward?: string | undefined;
    onboardingUrl?: string | undefined;
    isGlobal?: boolean | undefined;
    campaignTargetUser?: CampaignTargetUser | undefined;
    synchronizationContactGLO?: boolean | undefined;
    synchronizationDataConsumerGLO?: boolean | undefined;
    consumerReferralCampaigns?: Campaign[] | undefined;
    staffReferralCampaigns?: Campaign[] | undefined;
    countries?: string[] | undefined;
    /** Languages supported by this campaign */
    languages?: CampaignLanguage[] | undefined;
    /** Primary language of this campaign (ISO 639-1 code) */
    primaryLanguage?: string | undefined;
    bannerDuration?: number | undefined;
    /** Blocks redemption on join. */
    blockRedemptionOnJoin?: boolean | undefined;
    isForceUsingMobileApp?: boolean | undefined;
    /** Hide participating locations */
    shouldHideParticipatingLocations?: boolean | undefined;
    /** Allowed country codes for Phone OTP login (ISO 3166-1 alpha-2). Empty means all countries allowed. */
    allowedCountryCodes?: string[] | undefined;
}

export class CampaignBanner implements ICampaignBanner {
    url1?: string | undefined;
    key1?: string | undefined;
    url2?: string | undefined;
    key2?: string | undefined;
    url3?: string | undefined;
    key3?: string | undefined;
    url4?: string | undefined;
    key4?: string | undefined;
    url5?: string | undefined;
    key5?: string | undefined;

    constructor(data?: ICampaignBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url1 = _data["url1"];
            this.key1 = _data["key1"];
            this.url2 = _data["url2"];
            this.key2 = _data["key2"];
            this.url3 = _data["url3"];
            this.key3 = _data["key3"];
            this.url4 = _data["url4"];
            this.key4 = _data["key4"];
            this.url5 = _data["url5"];
            this.key5 = _data["key5"];
        }
    }

    static fromJS(data: any): CampaignBanner {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignBanner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url1"] = this.url1;
        data["key1"] = this.key1;
        data["url2"] = this.url2;
        data["key2"] = this.key2;
        data["url3"] = this.url3;
        data["key3"] = this.key3;
        data["url4"] = this.url4;
        data["key4"] = this.key4;
        data["url5"] = this.url5;
        data["key5"] = this.key5;
        return data;
    }
}

export interface ICampaignBanner {
    url1?: string | undefined;
    key1?: string | undefined;
    url2?: string | undefined;
    key2?: string | undefined;
    url3?: string | undefined;
    key3?: string | undefined;
    url4?: string | undefined;
    key4?: string | undefined;
    url5?: string | undefined;
    key5?: string | undefined;
}

export class CampaignDto implements ICampaignDto {
    campaignId?: string | undefined;
    campaignName?: string | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    isActive?: boolean | undefined;
    readonly isExpired?: boolean | undefined;
    readonly isUpComing?: boolean | undefined;
    readonly stage?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdAt?: Date | undefined;
    isPunchCardStrategy?: boolean | undefined;
    isLuckyDrawStrategy?: boolean | undefined;
    isStaffCampaignStrategy?: boolean | undefined;
    isReferralCampaignStrategy?: boolean | undefined;
    isConsumerReferralStrategy?: boolean | undefined;
    isConsumerInformationStrategy?: boolean | undefined;
    isStaffInformationStrategy?: boolean | undefined;
    isStaffPointStrategy?: boolean | undefined;
    isMultiCampaignStrategy?: boolean | undefined;
    isOpenerStrategy?: boolean | undefined;
    photoBannerUrl?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;

    constructor(data?: ICampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            this.campaignName = _data["campaignName"];
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.isActive = _data["isActive"];
            (this as any).isExpired = _data["isExpired"];
            (this as any).isUpComing = _data["isUpComing"];
            (this as any).stage = _data["stage"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isPunchCardStrategy = _data["isPunchCardStrategy"];
            this.isLuckyDrawStrategy = _data["isLuckyDrawStrategy"];
            this.isStaffCampaignStrategy = _data["isStaffCampaignStrategy"];
            this.isReferralCampaignStrategy = _data["isReferralCampaignStrategy"];
            this.isConsumerReferralStrategy = _data["isConsumerReferralStrategy"];
            this.isConsumerInformationStrategy = _data["isConsumerInformationStrategy"];
            this.isStaffInformationStrategy = _data["isStaffInformationStrategy"];
            this.isStaffPointStrategy = _data["isStaffPointStrategy"];
            this.isMultiCampaignStrategy = _data["isMultiCampaignStrategy"];
            this.isOpenerStrategy = _data["isOpenerStrategy"];
            this.photoBannerUrl = _data["photoBannerUrl"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
        }
    }

    static fromJS(data: any): CampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["campaignName"] = this.campaignName;
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["isActive"] = this.isActive;
        data["isExpired"] = this.isExpired;
        data["isUpComing"] = this.isUpComing;
        data["stage"] = this.stage;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isPunchCardStrategy"] = this.isPunchCardStrategy;
        data["isLuckyDrawStrategy"] = this.isLuckyDrawStrategy;
        data["isStaffCampaignStrategy"] = this.isStaffCampaignStrategy;
        data["isReferralCampaignStrategy"] = this.isReferralCampaignStrategy;
        data["isConsumerReferralStrategy"] = this.isConsumerReferralStrategy;
        data["isConsumerInformationStrategy"] = this.isConsumerInformationStrategy;
        data["isStaffInformationStrategy"] = this.isStaffInformationStrategy;
        data["isStaffPointStrategy"] = this.isStaffPointStrategy;
        data["isMultiCampaignStrategy"] = this.isMultiCampaignStrategy;
        data["isOpenerStrategy"] = this.isOpenerStrategy;
        data["photoBannerUrl"] = this.photoBannerUrl;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        return data;
    }
}

export interface ICampaignDto {
    campaignId?: string | undefined;
    campaignName?: string | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    isActive?: boolean | undefined;
    isExpired?: boolean | undefined;
    isUpComing?: boolean | undefined;
    stage?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdAt?: Date | undefined;
    isPunchCardStrategy?: boolean | undefined;
    isLuckyDrawStrategy?: boolean | undefined;
    isStaffCampaignStrategy?: boolean | undefined;
    isReferralCampaignStrategy?: boolean | undefined;
    isConsumerReferralStrategy?: boolean | undefined;
    isConsumerInformationStrategy?: boolean | undefined;
    isStaffInformationStrategy?: boolean | undefined;
    isStaffPointStrategy?: boolean | undefined;
    isMultiCampaignStrategy?: boolean | undefined;
    isOpenerStrategy?: boolean | undefined;
    photoBannerUrl?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
}

export class CampaignFullConfigDto implements ICampaignFullConfigDto {
    campaignId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    detailedDescription?: string | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdAt?: Date | undefined;
    status?: string | undefined;
    isActive?: boolean | undefined;
    isGlobal?: boolean | undefined;
    countries?: string[] | undefined;
    timeZoneInfoId?: string | undefined;
    onboardingUrl?: string | undefined;
    allowDuplicates?: boolean | undefined;
    overAge?: boolean | undefined;
    dynamicAge?: number | undefined;
    blockRedemptionOnJoin?: boolean | undefined;
    isForceUsingMobileApp?: boolean | undefined;
    shouldAdvertise?: boolean | undefined;
    canJoin?: boolean | undefined;
    detailedDescriptionJoined?: string | undefined;
    detailedDescriptionJoinedForRetailer?: string | undefined;
    userId?: string | undefined;
    allowGiveStamps?: boolean | undefined;
    termAndConditions?: string | undefined;
    privacyPolicy?: string | undefined;
    shouldHideParticipatingLocations?: boolean | undefined;
    targetUser?: string | undefined;
    synchronizationContactGLO?: boolean | undefined;
    synchronizationDataConsumerGLO?: boolean | undefined;
    bannerDuration?: number | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    photoBannerUrl?: string | undefined;
    staffReferralThumbnailUrl?: string | undefined;
    outboundEventIntegrations?: OutboundEventIntegrationConfigDto[] | undefined;
    strategyType?: string | undefined;
    strategyConfig?: JsonElement | undefined;

    constructor(data?: ICampaignFullConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.detailedDescription = _data["detailedDescription"];
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isGlobal = _data["isGlobal"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.onboardingUrl = _data["onboardingUrl"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.overAge = _data["overAge"];
            this.dynamicAge = _data["dynamicAge"];
            this.blockRedemptionOnJoin = _data["blockRedemptionOnJoin"];
            this.isForceUsingMobileApp = _data["isForceUsingMobileApp"];
            this.shouldAdvertise = _data["shouldAdvertise"];
            this.canJoin = _data["canJoin"];
            this.detailedDescriptionJoined = _data["detailedDescriptionJoined"];
            this.detailedDescriptionJoinedForRetailer = _data["detailedDescriptionJoinedForRetailer"];
            this.userId = _data["userId"];
            this.allowGiveStamps = _data["allowGiveStamps"];
            this.termAndConditions = _data["termAndConditions"];
            this.privacyPolicy = _data["privacyPolicy"];
            this.shouldHideParticipatingLocations = _data["shouldHideParticipatingLocations"];
            this.targetUser = _data["targetUser"];
            this.synchronizationContactGLO = _data["synchronizationContactGLO"];
            this.synchronizationDataConsumerGLO = _data["synchronizationDataConsumerGLO"];
            this.bannerDuration = _data["bannerDuration"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
            this.photoBannerUrl = _data["photoBannerUrl"];
            this.staffReferralThumbnailUrl = _data["staffReferralThumbnailUrl"];
            if (Array.isArray(_data["outboundEventIntegrations"])) {
                this.outboundEventIntegrations = [] as any;
                for (let item of _data["outboundEventIntegrations"])
                    this.outboundEventIntegrations!.push(OutboundEventIntegrationConfigDto.fromJS(item));
            }
            this.strategyType = _data["strategyType"];
            this.strategyConfig = _data["strategyConfig"] ? JsonElement.fromJS(_data["strategyConfig"]) : undefined as any;
        }
    }

    static fromJS(data: any): CampaignFullConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignFullConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["detailedDescription"] = this.detailedDescription;
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isGlobal"] = this.isGlobal;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["onboardingUrl"] = this.onboardingUrl;
        data["allowDuplicates"] = this.allowDuplicates;
        data["overAge"] = this.overAge;
        data["dynamicAge"] = this.dynamicAge;
        data["blockRedemptionOnJoin"] = this.blockRedemptionOnJoin;
        data["isForceUsingMobileApp"] = this.isForceUsingMobileApp;
        data["shouldAdvertise"] = this.shouldAdvertise;
        data["canJoin"] = this.canJoin;
        data["detailedDescriptionJoined"] = this.detailedDescriptionJoined;
        data["detailedDescriptionJoinedForRetailer"] = this.detailedDescriptionJoinedForRetailer;
        data["userId"] = this.userId;
        data["allowGiveStamps"] = this.allowGiveStamps;
        data["termAndConditions"] = this.termAndConditions;
        data["privacyPolicy"] = this.privacyPolicy;
        data["shouldHideParticipatingLocations"] = this.shouldHideParticipatingLocations;
        data["targetUser"] = this.targetUser;
        data["synchronizationContactGLO"] = this.synchronizationContactGLO;
        data["synchronizationDataConsumerGLO"] = this.synchronizationDataConsumerGLO;
        data["bannerDuration"] = this.bannerDuration;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        data["photoBannerUrl"] = this.photoBannerUrl;
        data["staffReferralThumbnailUrl"] = this.staffReferralThumbnailUrl;
        if (Array.isArray(this.outboundEventIntegrations)) {
            data["outboundEventIntegrations"] = [];
            for (let item of this.outboundEventIntegrations)
                data["outboundEventIntegrations"].push(item ? item.toJSON() : undefined as any);
        }
        data["strategyType"] = this.strategyType;
        data["strategyConfig"] = this.strategyConfig ? this.strategyConfig.toJSON() : undefined as any;
        return data;
    }
}

export interface ICampaignFullConfigDto {
    campaignId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    detailedDescription?: string | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdAt?: Date | undefined;
    status?: string | undefined;
    isActive?: boolean | undefined;
    isGlobal?: boolean | undefined;
    countries?: string[] | undefined;
    timeZoneInfoId?: string | undefined;
    onboardingUrl?: string | undefined;
    allowDuplicates?: boolean | undefined;
    overAge?: boolean | undefined;
    dynamicAge?: number | undefined;
    blockRedemptionOnJoin?: boolean | undefined;
    isForceUsingMobileApp?: boolean | undefined;
    shouldAdvertise?: boolean | undefined;
    canJoin?: boolean | undefined;
    detailedDescriptionJoined?: string | undefined;
    detailedDescriptionJoinedForRetailer?: string | undefined;
    userId?: string | undefined;
    allowGiveStamps?: boolean | undefined;
    termAndConditions?: string | undefined;
    privacyPolicy?: string | undefined;
    shouldHideParticipatingLocations?: boolean | undefined;
    targetUser?: string | undefined;
    synchronizationContactGLO?: boolean | undefined;
    synchronizationDataConsumerGLO?: boolean | undefined;
    bannerDuration?: number | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    photoBannerUrl?: string | undefined;
    staffReferralThumbnailUrl?: string | undefined;
    outboundEventIntegrations?: OutboundEventIntegrationConfigDto[] | undefined;
    strategyType?: string | undefined;
    strategyConfig?: JsonElement | undefined;
}

export class CampaignLanguage implements ICampaignLanguage {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICampaignLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CampaignLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICampaignLanguage {
    code?: string | undefined;
    name?: string | undefined;
}

export class CampaignLocationFilter implements ICampaignLocationFilter {
    campaignId?: string | undefined;
    filters?: any[] | undefined;

    constructor(data?: ICampaignLocationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(item);
            }
        }
    }

    static fromJS(data: any): CampaignLocationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignLocationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item);
        }
        return data;
    }
}

export interface ICampaignLocationFilter {
    campaignId?: string | undefined;
    filters?: any[] | undefined;
}

export class CampaignReference implements ICampaignReference {
    campaignId?: string | undefined;
    stampCount?: number | undefined;

    constructor(data?: ICampaignReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            this.stampCount = _data["stampCount"];
        }
    }

    static fromJS(data: any): CampaignReference {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["stampCount"] = this.stampCount;
        return data;
    }
}

export interface ICampaignReference {
    campaignId?: string | undefined;
    stampCount?: number | undefined;
}

export enum CampaignStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class CampaignStrategyBase implements ICampaignStrategyBase {
    readonly name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: ICampaignStrategyBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): CampaignStrategyBase {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignStrategyBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface ICampaignStrategyBase {
    name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum CampaignTargetUser {
    Staff = "Staff",
    Consumer = "Consumer",
}

export class Card implements ICard {
    id?: string | undefined;
    campaign?: Campaign | undefined;
    customerId?: string | undefined;
    customer?: CustomerInfo | undefined;
    staffId?: string | undefined;
    documentVersion?: number | undefined;
    cardState?: string | undefined;
    isDelivery?: boolean | undefined;
    createdAt?: Date | undefined;
    consumerReferralCampaignId?: string | undefined;
    redeemedCode?: string | undefined;
    safeboxCode?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    parentActivityId?: string | undefined;
    birthDayRewardedOnDate?: Date | undefined;
    entryCampaignId?: string | undefined;
    linkedCampaignIds?: string[] | undefined;
    isRetailer?: boolean | undefined;
    handshakeQrLimit?: HandshakeQrLimitRule | undefined;

    constructor(data?: ICard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : undefined as any;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerInfo.fromJS(_data["customer"]) : undefined as any;
            this.staffId = _data["staffId"];
            this.documentVersion = _data["documentVersion"];
            this.cardState = _data["cardState"];
            this.isDelivery = _data["isDelivery"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.consumerReferralCampaignId = _data["consumerReferralCampaignId"];
            this.redeemedCode = _data["redeemedCode"];
            this.safeboxCode = _data["safeboxCode"];
            this.docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.parentActivityId = _data["parentActivityId"];
            this.birthDayRewardedOnDate = _data["birthDayRewardedOnDate"] ? new Date(_data["birthDayRewardedOnDate"].toString()) : undefined as any;
            this.entryCampaignId = _data["entryCampaignId"];
            if (Array.isArray(_data["linkedCampaignIds"])) {
                this.linkedCampaignIds = [] as any;
                for (let item of _data["linkedCampaignIds"])
                    this.linkedCampaignIds!.push(item);
            }
            this.isRetailer = _data["isRetailer"];
            this.handshakeQrLimit = _data["handshakeQrLimit"] ? HandshakeQrLimitRule.fromJS(_data["handshakeQrLimit"]) : undefined as any;
        }
    }

    static fromJS(data: any): Card {
        data = typeof data === 'object' ? data : {};
        let result = new Card();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : undefined as any;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["staffId"] = this.staffId;
        data["documentVersion"] = this.documentVersion;
        data["cardState"] = this.cardState;
        data["isDelivery"] = this.isDelivery;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["consumerReferralCampaignId"] = this.consumerReferralCampaignId;
        data["redeemedCode"] = this.redeemedCode;
        data["safeboxCode"] = this.safeboxCode;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["parentActivityId"] = this.parentActivityId;
        data["birthDayRewardedOnDate"] = this.birthDayRewardedOnDate ? this.birthDayRewardedOnDate.toISOString() : undefined as any;
        data["entryCampaignId"] = this.entryCampaignId;
        if (Array.isArray(this.linkedCampaignIds)) {
            data["linkedCampaignIds"] = [];
            for (let item of this.linkedCampaignIds)
                data["linkedCampaignIds"].push(item);
        }
        data["isRetailer"] = this.isRetailer;
        data["handshakeQrLimit"] = this.handshakeQrLimit ? this.handshakeQrLimit.toJSON() : undefined as any;
        return data;
    }
}

export interface ICard {
    id?: string | undefined;
    campaign?: Campaign | undefined;
    customerId?: string | undefined;
    customer?: CustomerInfo | undefined;
    staffId?: string | undefined;
    documentVersion?: number | undefined;
    cardState?: string | undefined;
    isDelivery?: boolean | undefined;
    createdAt?: Date | undefined;
    consumerReferralCampaignId?: string | undefined;
    redeemedCode?: string | undefined;
    safeboxCode?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    parentActivityId?: string | undefined;
    birthDayRewardedOnDate?: Date | undefined;
    entryCampaignId?: string | undefined;
    linkedCampaignIds?: string[] | undefined;
    isRetailer?: boolean | undefined;
    handshakeQrLimit?: HandshakeQrLimitRule | undefined;
}

export class CoinReward implements ICoinReward {
    coins?: number | undefined;

    constructor(data?: ICoinReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coins = _data["coins"];
        }
    }

    static fromJS(data: any): CoinReward {
        data = typeof data === 'object' ? data : {};
        let result = new CoinReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coins"] = this.coins;
        return data;
    }
}

export interface ICoinReward {
    coins?: number | undefined;
}

export class ConsumerDataConnection implements IConsumerDataConnection {
    connectionTemplate?: string | undefined;
    status?: DataConnectionStatus | undefined;
    data?: { [key: string]: any; } | undefined;
    consumptionAuthorization?: ConsumptionAuthorization | undefined;
    type?: DataConnectionType | undefined;
    url?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IConsumerDataConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionTemplate = _data["connectionTemplate"];
            this.status = _data["status"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = _data["data"][key];
                }
            }
            this.consumptionAuthorization = _data["consumptionAuthorization"] ? ConsumptionAuthorization.fromJS(_data["consumptionAuthorization"]) : undefined as any;
            this.type = _data["type"];
            this.url = _data["url"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ConsumerDataConnection {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDataConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionTemplate"] = this.connectionTemplate;
        data["status"] = this.status;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = (this.data as any)[key];
            }
        }
        data["consumptionAuthorization"] = this.consumptionAuthorization ? this.consumptionAuthorization.toJSON() : undefined as any;
        data["type"] = this.type;
        data["url"] = this.url;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IConsumerDataConnection {
    connectionTemplate?: string | undefined;
    status?: DataConnectionStatus | undefined;
    data?: { [key: string]: any; } | undefined;
    consumptionAuthorization?: ConsumptionAuthorization | undefined;
    type?: DataConnectionType | undefined;
    url?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export class ConsumerInformationStrategy implements IConsumerInformationStrategy {
    readonly name?: string | undefined;
    joinReward?: RewardData | undefined;
    rewardsReceivedCount?: number | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IConsumerInformationStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.joinReward = _data["joinReward"] ? RewardData.fromJS(_data["joinReward"]) : undefined as any;
            this.rewardsReceivedCount = _data["rewardsReceivedCount"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): ConsumerInformationStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerInformationStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["joinReward"] = this.joinReward ? this.joinReward.toJSON() : undefined as any;
        data["rewardsReceivedCount"] = this.rewardsReceivedCount;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IConsumerInformationStrategy {
    name?: string | undefined;
    joinReward?: RewardData | undefined;
    rewardsReceivedCount?: number | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class ConsumerReferralData implements IConsumerReferralData {
    inviteCode?: string | undefined;
    senderId?: string | undefined;
    createdByCode?: string | undefined;
    referralCampaignId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IConsumerReferralData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteCode = _data["inviteCode"];
            this.senderId = _data["senderId"];
            this.createdByCode = _data["createdByCode"];
            this.referralCampaignId = _data["referralCampaignId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ConsumerReferralData {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerReferralData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteCode"] = this.inviteCode;
        data["senderId"] = this.senderId;
        data["createdByCode"] = this.createdByCode;
        data["referralCampaignId"] = this.referralCampaignId;
        data["message"] = this.message;
        return data;
    }
}

export interface IConsumerReferralData {
    inviteCode?: string | undefined;
    senderId?: string | undefined;
    createdByCode?: string | undefined;
    referralCampaignId?: string | undefined;
    message?: string | undefined;
}

export class ConsumerReferralStrategy implements IConsumerReferralStrategy {
    finished?: boolean | undefined;
    readonly name?: string | undefined;
    allowDuplicates?: boolean | undefined;
    refCampaignId?: string | undefined;
    inviteCode?: string | undefined;
    channel?: string | undefined;
    isDefaultChannel?: boolean | undefined;
    hasReferralLinkSettings?: boolean | undefined;
    referralLinkSettings?: ReferralLinkSettings | undefined;
    joinRewardSender?: RewardData | undefined;
    joinRewardReceiver?: RewardData | undefined;
    firstConsRewardSender?: RewardData | undefined;
    firstConsRewardReceiver?: RewardData | undefined;
    completeRewardSender?: RewardData | undefined;
    completeRewardReceiver?: RewardData | undefined;
    repeatable?: boolean | undefined;
    totalReferrals?: number | undefined;
    flow?: PunchCardFlow | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IConsumerReferralStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finished = _data["finished"];
            (this as any).name = _data["name"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.refCampaignId = _data["refCampaignId"];
            this.inviteCode = _data["inviteCode"];
            this.channel = _data["channel"];
            this.isDefaultChannel = _data["isDefaultChannel"];
            this.hasReferralLinkSettings = _data["hasReferralLinkSettings"];
            this.referralLinkSettings = _data["referralLinkSettings"] ? ReferralLinkSettings.fromJS(_data["referralLinkSettings"]) : undefined as any;
            this.joinRewardSender = _data["joinRewardSender"] ? RewardData.fromJS(_data["joinRewardSender"]) : undefined as any;
            this.joinRewardReceiver = _data["joinRewardReceiver"] ? RewardData.fromJS(_data["joinRewardReceiver"]) : undefined as any;
            this.firstConsRewardSender = _data["firstConsRewardSender"] ? RewardData.fromJS(_data["firstConsRewardSender"]) : undefined as any;
            this.firstConsRewardReceiver = _data["firstConsRewardReceiver"] ? RewardData.fromJS(_data["firstConsRewardReceiver"]) : undefined as any;
            this.completeRewardSender = _data["completeRewardSender"] ? RewardData.fromJS(_data["completeRewardSender"]) : undefined as any;
            this.completeRewardReceiver = _data["completeRewardReceiver"] ? RewardData.fromJS(_data["completeRewardReceiver"]) : undefined as any;
            this.repeatable = _data["repeatable"];
            this.totalReferrals = _data["totalReferrals"];
            this.flow = _data["flow"] ? PunchCardFlow.fromJS(_data["flow"]) : undefined as any;
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): ConsumerReferralStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerReferralStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finished"] = this.finished;
        data["name"] = this.name;
        data["allowDuplicates"] = this.allowDuplicates;
        data["refCampaignId"] = this.refCampaignId;
        data["inviteCode"] = this.inviteCode;
        data["channel"] = this.channel;
        data["isDefaultChannel"] = this.isDefaultChannel;
        data["hasReferralLinkSettings"] = this.hasReferralLinkSettings;
        data["referralLinkSettings"] = this.referralLinkSettings ? this.referralLinkSettings.toJSON() : undefined as any;
        data["joinRewardSender"] = this.joinRewardSender ? this.joinRewardSender.toJSON() : undefined as any;
        data["joinRewardReceiver"] = this.joinRewardReceiver ? this.joinRewardReceiver.toJSON() : undefined as any;
        data["firstConsRewardSender"] = this.firstConsRewardSender ? this.firstConsRewardSender.toJSON() : undefined as any;
        data["firstConsRewardReceiver"] = this.firstConsRewardReceiver ? this.firstConsRewardReceiver.toJSON() : undefined as any;
        data["completeRewardSender"] = this.completeRewardSender ? this.completeRewardSender.toJSON() : undefined as any;
        data["completeRewardReceiver"] = this.completeRewardReceiver ? this.completeRewardReceiver.toJSON() : undefined as any;
        data["repeatable"] = this.repeatable;
        data["totalReferrals"] = this.totalReferrals;
        data["flow"] = this.flow ? this.flow.toJSON() : undefined as any;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IConsumerReferralStrategy {
    finished?: boolean | undefined;
    name?: string | undefined;
    allowDuplicates?: boolean | undefined;
    refCampaignId?: string | undefined;
    inviteCode?: string | undefined;
    channel?: string | undefined;
    isDefaultChannel?: boolean | undefined;
    hasReferralLinkSettings?: boolean | undefined;
    referralLinkSettings?: ReferralLinkSettings | undefined;
    joinRewardSender?: RewardData | undefined;
    joinRewardReceiver?: RewardData | undefined;
    firstConsRewardSender?: RewardData | undefined;
    firstConsRewardReceiver?: RewardData | undefined;
    completeRewardSender?: RewardData | undefined;
    completeRewardReceiver?: RewardData | undefined;
    repeatable?: boolean | undefined;
    totalReferrals?: number | undefined;
    flow?: PunchCardFlow | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class ConsumptionAuthorization implements IConsumptionAuthorization {
    consumptionApiKey?: string | undefined;
    consumptionApiSecret?: string | undefined;

    constructor(data?: IConsumptionAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumptionApiKey = _data["consumptionApiKey"];
            this.consumptionApiSecret = _data["consumptionApiSecret"];
        }
    }

    static fromJS(data: any): ConsumptionAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumptionApiKey"] = this.consumptionApiKey;
        data["consumptionApiSecret"] = this.consumptionApiSecret;
        return data;
    }
}

export interface IConsumptionAuthorization {
    consumptionApiKey?: string | undefined;
    consumptionApiSecret?: string | undefined;
}

export class ConsumptionFilterStrategy implements IConsumptionFilterStrategy {
    wildCard?: string | undefined;
    score?: number | undefined;
    description?: string | undefined;
    algorithm?: MatchAlgorithm | undefined;
    fuzzyTreshold?: number | undefined;

    constructor(data?: IConsumptionFilterStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wildCard = _data["wildCard"];
            this.score = _data["score"];
            this.description = _data["description"];
            this.algorithm = _data["algorithm"];
            this.fuzzyTreshold = _data["fuzzyTreshold"];
        }
    }

    static fromJS(data: any): ConsumptionFilterStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionFilterStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wildCard"] = this.wildCard;
        data["score"] = this.score;
        data["description"] = this.description;
        data["algorithm"] = this.algorithm;
        data["fuzzyTreshold"] = this.fuzzyTreshold;
        return data;
    }
}

export interface IConsumptionFilterStrategy {
    wildCard?: string | undefined;
    score?: number | undefined;
    description?: string | undefined;
    algorithm?: MatchAlgorithm | undefined;
    fuzzyTreshold?: number | undefined;
}

export class ConsumptionLimitRule implements IConsumptionLimitRule {
    maxLimit?: number | undefined;
    interval?: string | undefined;
    dateStart?: Date | undefined;
    currrent?: number | undefined;

    constructor(data?: IConsumptionLimitRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxLimit = _data["maxLimit"];
            this.interval = _data["interval"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : undefined as any;
            this.currrent = _data["currrent"];
        }
    }

    static fromJS(data: any): ConsumptionLimitRule {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionLimitRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxLimit"] = this.maxLimit;
        data["interval"] = this.interval;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : undefined as any;
        data["currrent"] = this.currrent;
        return data;
    }
}

export interface IConsumptionLimitRule {
    maxLimit?: number | undefined;
    interval?: string | undefined;
    dateStart?: Date | undefined;
    currrent?: number | undefined;
}

export class ConsumptionValidationFilter implements IConsumptionValidationFilter {
    id?: string | undefined;
    visible?: boolean | undefined;
    wildCard?: string | undefined;
    algorithm?: string | undefined;
    fuzzyTreshold?: number | undefined;
    displayOrder?: number | undefined;

    constructor(data?: IConsumptionValidationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.visible = _data["visible"];
            this.wildCard = _data["wildCard"];
            this.algorithm = _data["algorithm"];
            this.fuzzyTreshold = _data["fuzzyTreshold"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ConsumptionValidationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionValidationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["visible"] = this.visible;
        data["wildCard"] = this.wildCard;
        data["algorithm"] = this.algorithm;
        data["fuzzyTreshold"] = this.fuzzyTreshold;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IConsumptionValidationFilter {
    id?: string | undefined;
    visible?: boolean | undefined;
    wildCard?: string | undefined;
    algorithm?: string | undefined;
    fuzzyTreshold?: number | undefined;
    displayOrder?: number | undefined;
}

export class ConsumptionValidationTool implements IConsumptionValidationTool {
    id?: string | undefined;
    validationToolEnum?: string | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    apiKeys?: ApiKey[] | undefined;
    description?: string | undefined;
    consumptionValidationFilters?: ConsumptionValidationFilter[] | undefined;

    constructor(data?: IConsumptionValidationTool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationToolEnum = _data["validationToolEnum"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["apiKeys"])) {
                this.apiKeys = [] as any;
                for (let item of _data["apiKeys"])
                    this.apiKeys!.push(ApiKey.fromJS(item));
            }
            this.description = _data["description"];
            if (Array.isArray(_data["consumptionValidationFilters"])) {
                this.consumptionValidationFilters = [] as any;
                for (let item of _data["consumptionValidationFilters"])
                    this.consumptionValidationFilters!.push(ConsumptionValidationFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsumptionValidationTool {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionValidationTool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationToolEnum"] = this.validationToolEnum;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.apiKeys)) {
            data["apiKeys"] = [];
            for (let item of this.apiKeys)
                data["apiKeys"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description;
        if (Array.isArray(this.consumptionValidationFilters)) {
            data["consumptionValidationFilters"] = [];
            for (let item of this.consumptionValidationFilters)
                data["consumptionValidationFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConsumptionValidationTool {
    id?: string | undefined;
    validationToolEnum?: string | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    apiKeys?: ApiKey[] | undefined;
    description?: string | undefined;
    consumptionValidationFilters?: ConsumptionValidationFilter[] | undefined;
}

export enum ConsumptionValidationToolEnum {
    OCR = "OCR",
    FiscalQR = "FiscalQR",
    UniqueQR = "UniqueQR",
    Opener = "Opener",
    External = "External",
    JsonQR = "JsonQR",
    SecretCode = "SecretCode",
    GLOIntegration = "GLOIntegration",
    AdvertiserCampaign = "AdvertiserCampaign",
    HandshakeQR = "HandshakeQR",
}

export class Coordinates implements ICoordinates {
    lat?: number | undefined;
    lon?: number | undefined;

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface ICoordinates {
    lat?: number | undefined;
    lon?: number | undefined;
}

export class Counter implements ICounter {
    readonly name?: string | undefined;
    stampCount?: number | undefined;
    maxStampCount?: number | undefined;
    canReuseCode?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: ICounter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.stampCount = _data["stampCount"];
            this.maxStampCount = _data["maxStampCount"];
            this.canReuseCode = _data["canReuseCode"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): Counter {
        data = typeof data === 'object' ? data : {};
        let result = new Counter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stampCount"] = this.stampCount;
        data["maxStampCount"] = this.maxStampCount;
        data["canReuseCode"] = this.canReuseCode;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface ICounter {
    name?: string | undefined;
    stampCount?: number | undefined;
    maxStampCount?: number | undefined;
    canReuseCode?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class CreateAdvertiserRequestDto implements ICreateAdvertiserRequestDto {
    advertiser?: AdvertiserDto | undefined;
    uploadKey?: string | undefined;

    constructor(data?: ICreateAdvertiserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertiser = _data["advertiser"] ? AdvertiserDto.fromJS(_data["advertiser"]) : undefined as any;
            this.uploadKey = _data["uploadKey"];
        }
    }

    static fromJS(data: any): CreateAdvertiserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdvertiserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertiser"] = this.advertiser ? this.advertiser.toJSON() : undefined as any;
        data["uploadKey"] = this.uploadKey;
        return data;
    }
}

export interface ICreateAdvertiserRequestDto {
    advertiser?: AdvertiserDto | undefined;
    uploadKey?: string | undefined;
}

export class CustomerInfo implements ICustomerInfo {
    userId?: string | undefined;
    userName?: string | undefined;
    mobilePhone?: string | undefined;
    countryCode?: string | undefined;
    languageCode?: string | undefined;
    email?: string | undefined;
    termAndConditionsUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    birthday?: Date | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: ICustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.mobilePhone = _data["mobilePhone"];
            this.countryCode = _data["countryCode"];
            this.languageCode = _data["languageCode"];
            this.email = _data["email"];
            this.termAndConditionsUrl = _data["termAndConditionsUrl"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : undefined as any;
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): CustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["mobilePhone"] = this.mobilePhone;
        data["countryCode"] = this.countryCode;
        data["languageCode"] = this.languageCode;
        data["email"] = this.email;
        data["termAndConditionsUrl"] = this.termAndConditionsUrl;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : undefined as any;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface ICustomerInfo {
    userId?: string | undefined;
    userName?: string | undefined;
    mobilePhone?: string | undefined;
    countryCode?: string | undefined;
    languageCode?: string | undefined;
    email?: string | undefined;
    termAndConditionsUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    birthday?: Date | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export enum DataConnectionStatus {
    Verified = "Verified",
    NotVerified = "NotVerified",
}

export class DataConnectionTest implements IDataConnectionTest {
    result?: boolean | undefined;

    constructor(data?: IDataConnectionTest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): DataConnectionTest {
        data = typeof data === 'object' ? data : {};
        let result = new DataConnectionTest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface IDataConnectionTest {
    result?: boolean | undefined;
}

export enum DataConnectionType {
    Salesforce = "Salesforce",
}

export class DateOfBirthFieldSettings implements IDateOfBirthFieldSettings {
    format?: DateOfBirthFormat | undefined;
    isVisible?: boolean | undefined;
    isRequired?: boolean | undefined;

    constructor(data?: IDateOfBirthFieldSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
            this.isVisible = _data["isVisible"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): DateOfBirthFieldSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DateOfBirthFieldSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        data["isVisible"] = this.isVisible;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IDateOfBirthFieldSettings {
    format?: DateOfBirthFormat | undefined;
    isVisible?: boolean | undefined;
    isRequired?: boolean | undefined;
}

export enum DateOfBirthFormat {
    FullDate = "FullDate",
    DayAndMonth = "DayAndMonth",
    MonthAndYear = "MonthAndYear",
    YearOnly = "YearOnly",
}

export class Delay implements IDelay {
    duration?: string | undefined;
    skipFirstTime?: boolean | undefined;
    nextStrategy?: any | undefined;
    readonly name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IDelay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.skipFirstTime = _data["skipFirstTime"];
            this.nextStrategy = _data["nextStrategy"];
            (this as any).name = _data["name"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): Delay {
        data = typeof data === 'object' ? data : {};
        let result = new Delay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["skipFirstTime"] = this.skipFirstTime;
        data["nextStrategy"] = this.nextStrategy;
        data["name"] = this.name;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IDelay {
    duration?: string | undefined;
    skipFirstTime?: boolean | undefined;
    nextStrategy?: any | undefined;
    name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class EventCardReceived implements IEventCardReceived {
    card?: Card | undefined;
    givenByStaffId?: string | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    userMobilePhone?: string | undefined;
    refererId?: string | undefined;
    consumerReferralCampaignId?: string | undefined;
    termAndConditionsUrl?: string | undefined;
    landingPageUrl?: string | undefined;
    brandTermAndCondition?: string | undefined;
    brandPrivacyPolicy?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userEmail?: string | undefined;
    userLanguageCode?: string | undefined;
    userCountryCode?: string | undefined;
    entryCampaignId?: string | undefined;
    linkedCampaignIds?: string[] | undefined;
    safeBoxCode?: string | undefined;
    safeBoxUrl?: string | undefined;
    redeemedCode?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventCardReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            this.givenByStaffId = _data["givenByStaffId"];
            this.campaignStartDate = _data["campaignStartDate"] ? new Date(_data["campaignStartDate"].toString()) : undefined as any;
            this.campaignEndDate = _data["campaignEndDate"] ? new Date(_data["campaignEndDate"].toString()) : undefined as any;
            this.userMobilePhone = _data["userMobilePhone"];
            this.refererId = _data["refererId"];
            this.consumerReferralCampaignId = _data["consumerReferralCampaignId"];
            this.termAndConditionsUrl = _data["termAndConditionsUrl"];
            this.landingPageUrl = _data["landingPageUrl"];
            this.brandTermAndCondition = _data["brandTermAndCondition"];
            this.brandPrivacyPolicy = _data["brandPrivacyPolicy"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            this.userEmail = _data["userEmail"];
            this.userLanguageCode = _data["userLanguageCode"];
            this.userCountryCode = _data["userCountryCode"];
            this.entryCampaignId = _data["entryCampaignId"];
            if (Array.isArray(_data["linkedCampaignIds"])) {
                this.linkedCampaignIds = [] as any;
                for (let item of _data["linkedCampaignIds"])
                    this.linkedCampaignIds!.push(item);
            }
            this.safeBoxCode = _data["safeBoxCode"];
            this.safeBoxUrl = _data["safeBoxUrl"];
            this.redeemedCode = _data["redeemedCode"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventCardReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventCardReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["givenByStaffId"] = this.givenByStaffId;
        data["campaignStartDate"] = this.campaignStartDate ? this.campaignStartDate.toISOString() : undefined as any;
        data["campaignEndDate"] = this.campaignEndDate ? this.campaignEndDate.toISOString() : undefined as any;
        data["userMobilePhone"] = this.userMobilePhone;
        data["refererId"] = this.refererId;
        data["consumerReferralCampaignId"] = this.consumerReferralCampaignId;
        data["termAndConditionsUrl"] = this.termAndConditionsUrl;
        data["landingPageUrl"] = this.landingPageUrl;
        data["brandTermAndCondition"] = this.brandTermAndCondition;
        data["brandPrivacyPolicy"] = this.brandPrivacyPolicy;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        data["userEmail"] = this.userEmail;
        data["userLanguageCode"] = this.userLanguageCode;
        data["userCountryCode"] = this.userCountryCode;
        data["entryCampaignId"] = this.entryCampaignId;
        if (Array.isArray(this.linkedCampaignIds)) {
            data["linkedCampaignIds"] = [];
            for (let item of this.linkedCampaignIds)
                data["linkedCampaignIds"].push(item);
        }
        data["safeBoxCode"] = this.safeBoxCode;
        data["safeBoxUrl"] = this.safeBoxUrl;
        data["redeemedCode"] = this.redeemedCode;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventCardReceived {
    card?: Card | undefined;
    givenByStaffId?: string | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    userMobilePhone?: string | undefined;
    refererId?: string | undefined;
    consumerReferralCampaignId?: string | undefined;
    termAndConditionsUrl?: string | undefined;
    landingPageUrl?: string | undefined;
    brandTermAndCondition?: string | undefined;
    brandPrivacyPolicy?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userEmail?: string | undefined;
    userLanguageCode?: string | undefined;
    userCountryCode?: string | undefined;
    entryCampaignId?: string | undefined;
    linkedCampaignIds?: string[] | undefined;
    safeBoxCode?: string | undefined;
    safeBoxUrl?: string | undefined;
    redeemedCode?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventConsumption implements IEventConsumption {
    id?: string | undefined;
    items?: EventConsumption_Item[] | undefined;
    receiptUrl?: string | undefined;
    receiptId?: string | undefined;
    isDuplicate?: boolean | undefined;
    rawResponse?: string | undefined;
    createdDate?: Date | undefined;
    vendorName?: string | undefined;
    vendorAddress?: string | undefined;
    vendorType?: string | undefined;
    total?: number | undefined;
    currencyCode?: string | undefined;
    paymentType?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    referenceNumber?: string | undefined;
    subtotal?: number | undefined;
    tax?: number | undefined;
    staffKey?: string | undefined;
    staffUserId?: string | undefined;
    brands?: string[] | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    campaignName?: string | undefined;
    username?: string | undefined;
    userMobilePhone?: string | undefined;
    cardId?: string | undefined;
    contextCardDocumentVersion?: number | undefined;
    long?: number | undefined;
    lat?: number | undefined;
    email?: string | undefined;
    timeConstraint?: boolean | undefined;
    externalId?: string | undefined;
    manualAccepted?: boolean | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventConsumption_Item.fromJS(item));
            }
            this.receiptUrl = _data["receiptUrl"];
            this.receiptId = _data["receiptId"];
            this.isDuplicate = _data["isDuplicate"];
            this.rawResponse = _data["rawResponse"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.vendorName = _data["vendorName"];
            this.vendorAddress = _data["vendorAddress"];
            this.vendorType = _data["vendorType"];
            this.total = _data["total"];
            this.currencyCode = _data["currencyCode"];
            this.paymentType = _data["paymentType"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.subtotal = _data["subtotal"];
            this.tax = _data["tax"];
            this.staffKey = _data["staffKey"];
            this.staffUserId = _data["staffUserId"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            this.campaignStartDate = _data["campaignStartDate"] ? new Date(_data["campaignStartDate"].toString()) : undefined as any;
            this.campaignEndDate = _data["campaignEndDate"] ? new Date(_data["campaignEndDate"].toString()) : undefined as any;
            this.campaignName = _data["campaignName"];
            this.username = _data["username"];
            this.userMobilePhone = _data["userMobilePhone"];
            this.cardId = _data["cardId"];
            this.contextCardDocumentVersion = _data["contextCardDocumentVersion"];
            this.long = _data["long"];
            this.lat = _data["lat"];
            this.email = _data["email"];
            this.timeConstraint = _data["timeConstraint"];
            this.externalId = _data["externalId"];
            this.manualAccepted = _data["manualAccepted"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new EventConsumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["receiptUrl"] = this.receiptUrl;
        data["receiptId"] = this.receiptId;
        data["isDuplicate"] = this.isDuplicate;
        data["rawResponse"] = this.rawResponse;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["vendorName"] = this.vendorName;
        data["vendorAddress"] = this.vendorAddress;
        data["vendorType"] = this.vendorType;
        data["total"] = this.total;
        data["currencyCode"] = this.currencyCode;
        data["paymentType"] = this.paymentType;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["subtotal"] = this.subtotal;
        data["tax"] = this.tax;
        data["staffKey"] = this.staffKey;
        data["staffUserId"] = this.staffUserId;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        data["campaignStartDate"] = this.campaignStartDate ? this.campaignStartDate.toISOString() : undefined as any;
        data["campaignEndDate"] = this.campaignEndDate ? this.campaignEndDate.toISOString() : undefined as any;
        data["campaignName"] = this.campaignName;
        data["username"] = this.username;
        data["userMobilePhone"] = this.userMobilePhone;
        data["cardId"] = this.cardId;
        data["contextCardDocumentVersion"] = this.contextCardDocumentVersion;
        data["long"] = this.long;
        data["lat"] = this.lat;
        data["email"] = this.email;
        data["timeConstraint"] = this.timeConstraint;
        data["externalId"] = this.externalId;
        data["manualAccepted"] = this.manualAccepted;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventConsumption {
    id?: string | undefined;
    items?: EventConsumption_Item[] | undefined;
    receiptUrl?: string | undefined;
    receiptId?: string | undefined;
    isDuplicate?: boolean | undefined;
    rawResponse?: string | undefined;
    createdDate?: Date | undefined;
    vendorName?: string | undefined;
    vendorAddress?: string | undefined;
    vendorType?: string | undefined;
    total?: number | undefined;
    currencyCode?: string | undefined;
    paymentType?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    referenceNumber?: string | undefined;
    subtotal?: number | undefined;
    tax?: number | undefined;
    staffKey?: string | undefined;
    staffUserId?: string | undefined;
    brands?: string[] | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    campaignName?: string | undefined;
    username?: string | undefined;
    userMobilePhone?: string | undefined;
    cardId?: string | undefined;
    contextCardDocumentVersion?: number | undefined;
    long?: number | undefined;
    lat?: number | undefined;
    email?: string | undefined;
    timeConstraint?: boolean | undefined;
    externalId?: string | undefined;
    manualAccepted?: boolean | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventConsumption_Item implements IEventConsumption_Item {
    name?: string | undefined;
    code?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    total?: number | undefined;
    discount?: number | undefined;
    type?: string | undefined;

    constructor(data?: IEventConsumption_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.price = _data["price"];
            this.total = _data["total"];
            this.discount = _data["discount"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EventConsumption_Item {
        data = typeof data === 'object' ? data : {};
        let result = new EventConsumption_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["price"] = this.price;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["type"] = this.type;
        return data;
    }
}

export interface IEventConsumption_Item {
    name?: string | undefined;
    code?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    total?: number | undefined;
    discount?: number | undefined;
    type?: string | undefined;
}

export class EventConsumptionMatch implements IEventConsumptionMatch {
    items?: EventConsumptionMatch_Item[] | undefined;
    receiptId?: string | undefined;
    totalPrice?: number | undefined;
    totalScore?: number | undefined;
    totalScoreValueBased?: number | undefined;
    externalId?: string | undefined;
    brands?: string[] | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventConsumptionMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventConsumptionMatch_Item.fromJS(item));
            }
            this.receiptId = _data["receiptId"];
            this.totalPrice = _data["totalPrice"];
            this.totalScore = _data["totalScore"];
            this.totalScoreValueBased = _data["totalScoreValueBased"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventConsumptionMatch {
        data = typeof data === 'object' ? data : {};
        let result = new EventConsumptionMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["receiptId"] = this.receiptId;
        data["totalPrice"] = this.totalPrice;
        data["totalScore"] = this.totalScore;
        data["totalScoreValueBased"] = this.totalScoreValueBased;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventConsumptionMatch {
    items?: EventConsumptionMatch_Item[] | undefined;
    receiptId?: string | undefined;
    totalPrice?: number | undefined;
    totalScore?: number | undefined;
    totalScoreValueBased?: number | undefined;
    externalId?: string | undefined;
    brands?: string[] | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventConsumptionMatch_Item implements IEventConsumptionMatch_Item {
    name?: string | undefined;
    code?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    total?: number | undefined;
    score?: number | undefined;
    readonly filter?: string | undefined;

    constructor(data?: IEventConsumptionMatch_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.price = _data["price"];
            this.total = _data["total"];
            this.score = _data["score"];
            (this as any).filter = _data["filter"];
        }
    }

    static fromJS(data: any): EventConsumptionMatch_Item {
        data = typeof data === 'object' ? data : {};
        let result = new EventConsumptionMatch_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["price"] = this.price;
        data["total"] = this.total;
        data["score"] = this.score;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IEventConsumptionMatch_Item {
    name?: string | undefined;
    code?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    total?: number | undefined;
    score?: number | undefined;
    filter?: string | undefined;
}

export class EventContext implements IEventContext {
    card?: Card | undefined;
    createTime?: Date | undefined;
    activityTitle?: string | undefined;
    activityId?: string | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    receiptManualVerification?: boolean | undefined;

    constructor(data?: IEventContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined as any;
            this.activityTitle = _data["activityTitle"];
            this.activityId = _data["activityId"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.receiptManualVerification = _data["receiptManualVerification"];
        }
    }

    static fromJS(data: any): EventContext {
        data = typeof data === 'object' ? data : {};
        let result = new EventContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined as any;
        data["activityTitle"] = this.activityTitle;
        data["activityId"] = this.activityId;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["receiptManualVerification"] = this.receiptManualVerification;
        return data;
    }
}

export interface IEventContext {
    card?: Card | undefined;
    createTime?: Date | undefined;
    activityTitle?: string | undefined;
    activityId?: string | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    receiptManualVerification?: boolean | undefined;
}

export class EventGameCreated implements IEventGameCreated {
    game?: Game | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventGameCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.game = _data["game"] ? Game.fromJS(_data["game"]) : undefined as any;
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventGameCreated {
        data = typeof data === 'object' ? data : {};
        let result = new EventGameCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["game"] = this.game ? this.game.toJSON() : undefined as any;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventGameCreated {
    game?: Game | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventGameTriggered implements IEventGameTriggered {
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventGameTriggered) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventGameTriggered {
        data = typeof data === 'object' ? data : {};
        let result = new EventGameTriggered();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventGameTriggered {
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventHandshakeQRInValid implements IEventHandshakeQRInValid {
    generatorId?: string | undefined;
    safeboxCode?: string | undefined;
    advertiserId?: string | undefined;
    scanerId?: string | undefined;
    campaignId?: string | undefined;
    generatorPointReceived?: number | undefined;
    scannerPointReceived?: number | undefined;
    reason?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventHandshakeQRInValid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatorId = _data["generatorId"];
            this.safeboxCode = _data["safeboxCode"];
            this.advertiserId = _data["advertiserId"];
            this.scanerId = _data["scanerId"];
            this.campaignId = _data["campaignId"];
            this.generatorPointReceived = _data["generatorPointReceived"];
            this.scannerPointReceived = _data["scannerPointReceived"];
            this.reason = _data["reason"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventHandshakeQRInValid {
        data = typeof data === 'object' ? data : {};
        let result = new EventHandshakeQRInValid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorId"] = this.generatorId;
        data["safeboxCode"] = this.safeboxCode;
        data["advertiserId"] = this.advertiserId;
        data["scanerId"] = this.scanerId;
        data["campaignId"] = this.campaignId;
        data["generatorPointReceived"] = this.generatorPointReceived;
        data["scannerPointReceived"] = this.scannerPointReceived;
        data["reason"] = this.reason;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventHandshakeQRInValid {
    generatorId?: string | undefined;
    safeboxCode?: string | undefined;
    advertiserId?: string | undefined;
    scanerId?: string | undefined;
    campaignId?: string | undefined;
    generatorPointReceived?: number | undefined;
    scannerPointReceived?: number | undefined;
    reason?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventHandshakeQRValid implements IEventHandshakeQRValid {
    generatorId?: string | undefined;
    safeboxCode?: string | undefined;
    advertiserId?: string | undefined;
    scanerId?: string | undefined;
    campaignId?: string | undefined;
    generatorPointReceived?: number | undefined;
    scannerPointReceived?: number | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventHandshakeQRValid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatorId = _data["generatorId"];
            this.safeboxCode = _data["safeboxCode"];
            this.advertiserId = _data["advertiserId"];
            this.scanerId = _data["scanerId"];
            this.campaignId = _data["campaignId"];
            this.generatorPointReceived = _data["generatorPointReceived"];
            this.scannerPointReceived = _data["scannerPointReceived"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventHandshakeQRValid {
        data = typeof data === 'object' ? data : {};
        let result = new EventHandshakeQRValid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorId"] = this.generatorId;
        data["safeboxCode"] = this.safeboxCode;
        data["advertiserId"] = this.advertiserId;
        data["scanerId"] = this.scanerId;
        data["campaignId"] = this.campaignId;
        data["generatorPointReceived"] = this.generatorPointReceived;
        data["scannerPointReceived"] = this.scannerPointReceived;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventHandshakeQRValid {
    generatorId?: string | undefined;
    safeboxCode?: string | undefined;
    advertiserId?: string | undefined;
    scanerId?: string | undefined;
    campaignId?: string | undefined;
    generatorPointReceived?: number | undefined;
    scannerPointReceived?: number | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventLevelUnlocked implements IEventLevelUnlocked {
    level?: number | undefined;
    userMobilePhone?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventLevelUnlocked) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.userMobilePhone = _data["userMobilePhone"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventLevelUnlocked {
        data = typeof data === 'object' ? data : {};
        let result = new EventLevelUnlocked();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["userMobilePhone"] = this.userMobilePhone;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventLevelUnlocked {
    level?: number | undefined;
    userMobilePhone?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventLevelUnlockRewardReceived implements IEventLevelUnlockRewardReceived {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    levelTitle?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventLevelUnlockRewardReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productReward = _data["productReward"] ? ProductReward.fromJS(_data["productReward"]) : undefined as any;
            this.coinReward = _data["coinReward"] ? CoinReward.fromJS(_data["coinReward"]) : undefined as any;
            this.levelTitle = _data["levelTitle"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventLevelUnlockRewardReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventLevelUnlockRewardReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productReward"] = this.productReward ? this.productReward.toJSON() : undefined as any;
        data["coinReward"] = this.coinReward ? this.coinReward.toJSON() : undefined as any;
        data["levelTitle"] = this.levelTitle;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventLevelUnlockRewardReceived {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    levelTitle?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventLuckyDrawNotReceived implements IEventLuckyDrawNotReceived {
    totalScore?: number | undefined;
    neededScore?: number | undefined;
    notEnoughWait?: boolean | undefined;
    timeLimitWait?: boolean | undefined;
    consumptionLimitWait?: boolean | undefined;
    isDuplicate?: boolean | undefined;
    reason?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventLuckyDrawNotReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalScore = _data["totalScore"];
            this.neededScore = _data["neededScore"];
            this.notEnoughWait = _data["notEnoughWait"];
            this.timeLimitWait = _data["timeLimitWait"];
            this.consumptionLimitWait = _data["consumptionLimitWait"];
            this.isDuplicate = _data["isDuplicate"];
            this.reason = _data["reason"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventLuckyDrawNotReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventLuckyDrawNotReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalScore"] = this.totalScore;
        data["neededScore"] = this.neededScore;
        data["notEnoughWait"] = this.notEnoughWait;
        data["timeLimitWait"] = this.timeLimitWait;
        data["consumptionLimitWait"] = this.consumptionLimitWait;
        data["isDuplicate"] = this.isDuplicate;
        data["reason"] = this.reason;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventLuckyDrawNotReceived {
    totalScore?: number | undefined;
    neededScore?: number | undefined;
    notEnoughWait?: boolean | undefined;
    timeLimitWait?: boolean | undefined;
    consumptionLimitWait?: boolean | undefined;
    isDuplicate?: boolean | undefined;
    reason?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventLuckyDrawReceived implements IEventLuckyDrawReceived {
    totalScore?: number | undefined;
    givenTicketCount?: number | undefined;
    currentTicketCount?: number | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventLuckyDrawReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalScore = _data["totalScore"];
            this.givenTicketCount = _data["givenTicketCount"];
            this.currentTicketCount = _data["currentTicketCount"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventLuckyDrawReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventLuckyDrawReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalScore"] = this.totalScore;
        data["givenTicketCount"] = this.givenTicketCount;
        data["currentTicketCount"] = this.currentTicketCount;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventLuckyDrawReceived {
    totalScore?: number | undefined;
    givenTicketCount?: number | undefined;
    currentTicketCount?: number | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventManualVerificationRequested implements IEventManualVerificationRequested {
    receiptId?: string | undefined;
    lng?: number | undefined;
    lat?: number | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    receiptManualVerification?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventManualVerificationRequested) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.receiptManualVerification = _data["receiptManualVerification"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventManualVerificationRequested {
        data = typeof data === 'object' ? data : {};
        let result = new EventManualVerificationRequested();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["receiptManualVerification"] = this.receiptManualVerification;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventManualVerificationRequested {
    receiptId?: string | undefined;
    lng?: number | undefined;
    lat?: number | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    receiptManualVerification?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventNoPointReceived implements IEventNoPointReceived {
    reason?: NoPointReceivedReason | undefined;
    receiptCode?: ReceiptCode | undefined;
    userMobilePhone?: string | undefined;
    drinkMomentId?: string | undefined;
    drinkMomentOpenerId?: string | undefined;
    points?: number | undefined;
    activityTitle?: string | undefined;
    receiptId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventNoPointReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.receiptCode = _data["receiptCode"] ? ReceiptCode.fromJS(_data["receiptCode"]) : undefined as any;
            this.userMobilePhone = _data["userMobilePhone"];
            this.drinkMomentId = _data["drinkMomentId"];
            this.drinkMomentOpenerId = _data["drinkMomentOpenerId"];
            this.points = _data["points"];
            this.activityTitle = _data["activityTitle"];
            this.receiptId = _data["receiptId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventNoPointReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventNoPointReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["receiptCode"] = this.receiptCode ? this.receiptCode.toJSON() : undefined as any;
        data["userMobilePhone"] = this.userMobilePhone;
        data["drinkMomentId"] = this.drinkMomentId;
        data["drinkMomentOpenerId"] = this.drinkMomentOpenerId;
        data["points"] = this.points;
        data["activityTitle"] = this.activityTitle;
        data["receiptId"] = this.receiptId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventNoPointReceived {
    reason?: NoPointReceivedReason | undefined;
    receiptCode?: ReceiptCode | undefined;
    userMobilePhone?: string | undefined;
    drinkMomentId?: string | undefined;
    drinkMomentOpenerId?: string | undefined;
    points?: number | undefined;
    activityTitle?: string | undefined;
    receiptId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventPointsReceived implements IEventPointsReceived {
    points?: number | undefined;
    baselineThresholdRatio?: number | undefined;
    productsLimitRatio?: number | undefined;
    productsLimitOnBaselineThresholdRatio?: number | undefined;
    activityTitle?: string | undefined;
    schemaId?: string | undefined;
    date?: Date | undefined;
    receiptCode?: ReceiptCode | undefined;
    userMobilePhone?: string | undefined;
    cardId?: string | undefined;
    drinkMomentId?: string | undefined;
    drinkMomentOpenerId?: string | undefined;
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    description?: string | undefined;
    receiptId?: string | undefined;
    productName?: string | undefined;
    campaignName?: string | undefined;
    externalId?: string | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventPointsReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.points = _data["points"];
            this.baselineThresholdRatio = _data["baselineThresholdRatio"];
            this.productsLimitRatio = _data["productsLimitRatio"];
            this.productsLimitOnBaselineThresholdRatio = _data["productsLimitOnBaselineThresholdRatio"];
            this.activityTitle = _data["activityTitle"];
            this.schemaId = _data["schemaId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.receiptCode = _data["receiptCode"] ? ReceiptCode.fromJS(_data["receiptCode"]) : undefined as any;
            this.userMobilePhone = _data["userMobilePhone"];
            this.cardId = _data["cardId"];
            this.drinkMomentId = _data["drinkMomentId"];
            this.drinkMomentOpenerId = _data["drinkMomentOpenerId"];
            this.advertiserId = _data["advertiserId"];
            this.campaignId = _data["campaignId"];
            this.description = _data["description"];
            this.receiptId = _data["receiptId"];
            this.productName = _data["productName"];
            this.campaignName = _data["campaignName"];
            this.externalId = _data["externalId"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventPointsReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventPointsReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["points"] = this.points;
        data["baselineThresholdRatio"] = this.baselineThresholdRatio;
        data["productsLimitRatio"] = this.productsLimitRatio;
        data["productsLimitOnBaselineThresholdRatio"] = this.productsLimitOnBaselineThresholdRatio;
        data["activityTitle"] = this.activityTitle;
        data["schemaId"] = this.schemaId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["receiptCode"] = this.receiptCode ? this.receiptCode.toJSON() : undefined as any;
        data["userMobilePhone"] = this.userMobilePhone;
        data["cardId"] = this.cardId;
        data["drinkMomentId"] = this.drinkMomentId;
        data["drinkMomentOpenerId"] = this.drinkMomentOpenerId;
        data["advertiserId"] = this.advertiserId;
        data["campaignId"] = this.campaignId;
        data["description"] = this.description;
        data["receiptId"] = this.receiptId;
        data["productName"] = this.productName;
        data["campaignName"] = this.campaignName;
        data["externalId"] = this.externalId;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventPointsReceived {
    points?: number | undefined;
    baselineThresholdRatio?: number | undefined;
    productsLimitRatio?: number | undefined;
    productsLimitOnBaselineThresholdRatio?: number | undefined;
    activityTitle?: string | undefined;
    schemaId?: string | undefined;
    date?: Date | undefined;
    receiptCode?: ReceiptCode | undefined;
    userMobilePhone?: string | undefined;
    cardId?: string | undefined;
    drinkMomentId?: string | undefined;
    drinkMomentOpenerId?: string | undefined;
    advertiserId?: string | undefined;
    campaignId?: string | undefined;
    description?: string | undefined;
    receiptId?: string | undefined;
    productName?: string | undefined;
    campaignName?: string | undefined;
    externalId?: string | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventProductsLimitReached implements IEventProductsLimitReached {
    userMobilePhone?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventProductsLimitReached) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userMobilePhone = _data["userMobilePhone"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventProductsLimitReached {
        data = typeof data === 'object' ? data : {};
        let result = new EventProductsLimitReached();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userMobilePhone"] = this.userMobilePhone;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventProductsLimitReached {
    userMobilePhone?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventPunchcardCompleted implements IEventPunchcardCompleted {
    externalRewardId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventPunchcardCompleted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalRewardId = _data["externalRewardId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventPunchcardCompleted {
        data = typeof data === 'object' ? data : {};
        let result = new EventPunchcardCompleted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalRewardId"] = this.externalRewardId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventPunchcardCompleted {
    externalRewardId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventPunchcardStampsReceived implements IEventPunchcardStampsReceived {
    previousStamps?: number | undefined;
    currentStamps?: number | undefined;
    givenStamps?: number | undefined;
    maxStamps?: number | undefined;
    isDelivery?: boolean | undefined;
    receiptId?: string | undefined;
    staffId?: string | undefined;
    isFromQRCode?: boolean | undefined;
    campaignId?: string | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    campaignStatus?: string | undefined;
    totalStamps?: number | undefined;
    safeboxCode?: string | undefined;
    externalRewardId?: string | undefined;
    campaignName?: string | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventPunchcardStampsReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousStamps = _data["previousStamps"];
            this.currentStamps = _data["currentStamps"];
            this.givenStamps = _data["givenStamps"];
            this.maxStamps = _data["maxStamps"];
            this.isDelivery = _data["isDelivery"];
            this.receiptId = _data["receiptId"];
            this.staffId = _data["staffId"];
            this.isFromQRCode = _data["isFromQRCode"];
            this.campaignId = _data["campaignId"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.campaignStatus = _data["campaignStatus"];
            this.totalStamps = _data["totalStamps"];
            this.safeboxCode = _data["safeboxCode"];
            this.externalRewardId = _data["externalRewardId"];
            this.campaignName = _data["campaignName"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventPunchcardStampsReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventPunchcardStampsReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousStamps"] = this.previousStamps;
        data["currentStamps"] = this.currentStamps;
        data["givenStamps"] = this.givenStamps;
        data["maxStamps"] = this.maxStamps;
        data["isDelivery"] = this.isDelivery;
        data["receiptId"] = this.receiptId;
        data["staffId"] = this.staffId;
        data["isFromQRCode"] = this.isFromQRCode;
        data["campaignId"] = this.campaignId;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["campaignStatus"] = this.campaignStatus;
        data["totalStamps"] = this.totalStamps;
        data["safeboxCode"] = this.safeboxCode;
        data["externalRewardId"] = this.externalRewardId;
        data["campaignName"] = this.campaignName;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventPunchcardStampsReceived {
    previousStamps?: number | undefined;
    currentStamps?: number | undefined;
    givenStamps?: number | undefined;
    maxStamps?: number | undefined;
    isDelivery?: boolean | undefined;
    receiptId?: string | undefined;
    staffId?: string | undefined;
    isFromQRCode?: boolean | undefined;
    campaignId?: string | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    campaignStatus?: string | undefined;
    totalStamps?: number | undefined;
    safeboxCode?: string | undefined;
    externalRewardId?: string | undefined;
    campaignName?: string | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventPunchcardStepCompleted implements IEventPunchcardStepCompleted {
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventPunchcardStepCompleted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventPunchcardStepCompleted {
        data = typeof data === 'object' ? data : {};
        let result = new EventPunchcardStepCompleted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventPunchcardStepCompleted {
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventReceiptFailed implements IEventReceiptFailed {
    errorMessage?: string | undefined;
    isCode?: boolean | undefined;
    errorType?: EventReceiptFailedType | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventReceiptFailed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isCode = _data["isCode"];
            this.errorType = _data["errorType"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventReceiptFailed {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptFailed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isCode"] = this.isCode;
        data["errorType"] = this.errorType;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventReceiptFailed {
    errorMessage?: string | undefined;
    isCode?: boolean | undefined;
    errorType?: EventReceiptFailedType | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export enum EventReceiptFailedType {
    IncorrectCode = "IncorrectCode",
    BadRequestError = "BadRequestError",
    ThirdPartyError = "ThirdPartyError",
}

export class EventReceiptFraud implements IEventReceiptFraud {
    fraudResult?: ReceiptFraudResult | undefined;
    isCode?: boolean | undefined;
    receiptId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventReceiptFraud) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fraudResult = _data["fraudResult"] ? ReceiptFraudResult.fromJS(_data["fraudResult"]) : undefined as any;
            this.isCode = _data["isCode"];
            this.receiptId = _data["receiptId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventReceiptFraud {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptFraud();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraudResult"] = this.fraudResult ? this.fraudResult.toJSON() : undefined as any;
        data["isCode"] = this.isCode;
        data["receiptId"] = this.receiptId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventReceiptFraud {
    fraudResult?: ReceiptFraudResult | undefined;
    isCode?: boolean | undefined;
    receiptId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventReceiptIncomplete implements IEventReceiptIncomplete {
    receiptId?: string | undefined;
    manualVerification?: boolean | undefined;
    notRecognisable?: boolean | undefined;
    isCode?: boolean | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventReceiptIncomplete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.manualVerification = _data["manualVerification"];
            this.notRecognisable = _data["notRecognisable"];
            this.isCode = _data["isCode"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventReceiptIncomplete {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptIncomplete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["manualVerification"] = this.manualVerification;
        data["notRecognisable"] = this.notRecognisable;
        data["isCode"] = this.isCode;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventReceiptIncomplete {
    receiptId?: string | undefined;
    manualVerification?: boolean | undefined;
    notRecognisable?: boolean | undefined;
    isCode?: boolean | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventReceiptNoReward implements IEventReceiptNoReward {
    receiptId?: string | undefined;
    isFromQRCode?: boolean | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventReceiptNoReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.isFromQRCode = _data["isFromQRCode"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventReceiptNoReward {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptNoReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["isFromQRCode"] = this.isFromQRCode;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventReceiptNoReward {
    receiptId?: string | undefined;
    isFromQRCode?: boolean | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventReceiptNotEligible implements IEventReceiptNotEligible {
    obsolete?: boolean | undefined;
    wrogAccount?: boolean | undefined;
    isCode?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventReceiptNotEligible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.obsolete = _data["obsolete"];
            this.wrogAccount = _data["wrogAccount"];
            this.isCode = _data["isCode"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventReceiptNotEligible {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptNotEligible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["obsolete"] = this.obsolete;
        data["wrogAccount"] = this.wrogAccount;
        data["isCode"] = this.isCode;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventReceiptNotEligible {
    obsolete?: boolean | undefined;
    wrogAccount?: boolean | undefined;
    isCode?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventReceiptScanned implements IEventReceiptScanned {
    readonly id?: string | undefined;
    userPhoneNo?: string | undefined;
    luckyDrawReceived?: EventLuckyDrawReceived | undefined;
    luckyDrawNotReceived?: EventLuckyDrawNotReceived | undefined;
    scanResult?: ReceiptScanResult | undefined;

    constructor(data?: IEventReceiptScanned) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).id = _data["id"];
            this.userPhoneNo = _data["userPhoneNo"];
            this.luckyDrawReceived = _data["luckyDrawReceived"] ? EventLuckyDrawReceived.fromJS(_data["luckyDrawReceived"]) : undefined as any;
            this.luckyDrawNotReceived = _data["luckyDrawNotReceived"] ? EventLuckyDrawNotReceived.fromJS(_data["luckyDrawNotReceived"]) : undefined as any;
            this.scanResult = _data["scanResult"] ? ReceiptScanResult.fromJS(_data["scanResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): EventReceiptScanned {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptScanned();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userPhoneNo"] = this.userPhoneNo;
        data["luckyDrawReceived"] = this.luckyDrawReceived ? this.luckyDrawReceived.toJSON() : undefined as any;
        data["luckyDrawNotReceived"] = this.luckyDrawNotReceived ? this.luckyDrawNotReceived.toJSON() : undefined as any;
        data["scanResult"] = this.scanResult ? this.scanResult.toJSON() : undefined as any;
        return data;
    }
}

export interface IEventReceiptScanned {
    id?: string | undefined;
    userPhoneNo?: string | undefined;
    luckyDrawReceived?: EventLuckyDrawReceived | undefined;
    luckyDrawNotReceived?: EventLuckyDrawNotReceived | undefined;
    scanResult?: ReceiptScanResult | undefined;
}

export class EventReceiptTriaged implements IEventReceiptTriaged {
    uploadDate?: Date | undefined;
    reprocessingCount?: number | undefined;
    result?: ReceiptTriageResult | undefined;
    receiptId?: string | undefined;
    ocrDocId?: string | undefined;
    receiptUrl?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventReceiptTriaged) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : undefined as any;
            this.reprocessingCount = _data["reprocessingCount"];
            this.result = _data["result"] ? ReceiptTriageResult.fromJS(_data["result"]) : undefined as any;
            this.receiptId = _data["receiptId"];
            this.ocrDocId = _data["ocrDocId"];
            this.receiptUrl = _data["receiptUrl"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventReceiptTriaged {
        data = typeof data === 'object' ? data : {};
        let result = new EventReceiptTriaged();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : undefined as any;
        data["reprocessingCount"] = this.reprocessingCount;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["receiptId"] = this.receiptId;
        data["ocrDocId"] = this.ocrDocId;
        data["receiptUrl"] = this.receiptUrl;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventReceiptTriaged {
    uploadDate?: Date | undefined;
    reprocessingCount?: number | undefined;
    result?: ReceiptTriageResult | undefined;
    receiptId?: string | undefined;
    ocrDocId?: string | undefined;
    receiptUrl?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventRewardReceived implements IEventRewardReceived {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    stampReward?: ExtraStampReward | undefined;
    rewardInfo?: RewardInfo | undefined;
    lat?: number | undefined;
    long?: number | undefined;
    campaignStatus?: string | undefined;
    journalId?: string | undefined;
    description?: string | undefined;
    reason?: RewardReason | undefined;
    isVoucherOutOfStock?: boolean | undefined;
    externalRewardId?: string | undefined;
    parentActivityId?: string | undefined;
    readonly docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventRewardReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productReward = _data["productReward"] ? ProductReward.fromJS(_data["productReward"]) : undefined as any;
            this.coinReward = _data["coinReward"] ? CoinReward.fromJS(_data["coinReward"]) : undefined as any;
            this.stampReward = _data["stampReward"] ? ExtraStampReward.fromJS(_data["stampReward"]) : undefined as any;
            this.rewardInfo = _data["rewardInfo"] ? RewardInfo.fromJS(_data["rewardInfo"]) : undefined as any;
            this.lat = _data["lat"];
            this.long = _data["long"];
            this.campaignStatus = _data["campaignStatus"];
            this.journalId = _data["journalId"];
            this.description = _data["description"];
            this.reason = _data["reason"];
            this.isVoucherOutOfStock = _data["isVoucherOutOfStock"];
            this.externalRewardId = _data["externalRewardId"];
            this.parentActivityId = _data["parentActivityId"];
            (this as any).docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventRewardReceived {
        data = typeof data === 'object' ? data : {};
        let result = new EventRewardReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productReward"] = this.productReward ? this.productReward.toJSON() : undefined as any;
        data["coinReward"] = this.coinReward ? this.coinReward.toJSON() : undefined as any;
        data["stampReward"] = this.stampReward ? this.stampReward.toJSON() : undefined as any;
        data["rewardInfo"] = this.rewardInfo ? this.rewardInfo.toJSON() : undefined as any;
        data["lat"] = this.lat;
        data["long"] = this.long;
        data["campaignStatus"] = this.campaignStatus;
        data["journalId"] = this.journalId;
        data["description"] = this.description;
        data["reason"] = this.reason;
        data["isVoucherOutOfStock"] = this.isVoucherOutOfStock;
        data["externalRewardId"] = this.externalRewardId;
        data["parentActivityId"] = this.parentActivityId;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventRewardReceived {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    stampReward?: ExtraStampReward | undefined;
    rewardInfo?: RewardInfo | undefined;
    lat?: number | undefined;
    long?: number | undefined;
    campaignStatus?: string | undefined;
    journalId?: string | undefined;
    description?: string | undefined;
    reason?: RewardReason | undefined;
    isVoucherOutOfStock?: boolean | undefined;
    externalRewardId?: string | undefined;
    parentActivityId?: string | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventService implements IEventService {
    consumption?: EventConsumption | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumption = _data["consumption"] ? EventConsumption.fromJS(_data["consumption"]) : undefined as any;
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventService {
        data = typeof data === 'object' ? data : {};
        let result = new EventService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumption"] = this.consumption ? this.consumption.toJSON() : undefined as any;
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventService {
    consumption?: EventConsumption | undefined;
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class EventStampsLimitReached implements IEventStampsLimitReached {
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    readonly type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;

    constructor(data?: IEventStampsLimitReached) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.error = _data["error"];
            (this as any).type = _data["type"];
            this.userId = _data["userId"];
            this.gpsCoordinateLat = _data["gpsCoordinateLat"];
            this.gpsCoordinateLong = _data["gpsCoordinateLong"];
        }
    }

    static fromJS(data: any): EventStampsLimitReached {
        data = typeof data === 'object' ? data : {};
        let result = new EventStampsLimitReached();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["error"] = this.error;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["gpsCoordinateLat"] = this.gpsCoordinateLat;
        data["gpsCoordinateLong"] = this.gpsCoordinateLong;
        return data;
    }
}

export interface IEventStampsLimitReached {
    isSuccessful?: boolean | undefined;
    error?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    gpsCoordinateLat?: number | undefined;
    gpsCoordinateLong?: number | undefined;
}

export class ExtraStampReward implements IExtraStampReward {
    forConsumptionGivenStamps?: number | undefined;
    stamps?: number | undefined;

    constructor(data?: IExtraStampReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forConsumptionGivenStamps = _data["forConsumptionGivenStamps"];
            this.stamps = _data["stamps"];
        }
    }

    static fromJS(data: any): ExtraStampReward {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraStampReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forConsumptionGivenStamps"] = this.forConsumptionGivenStamps;
        data["stamps"] = this.stamps;
        return data;
    }
}

export interface IExtraStampReward {
    forConsumptionGivenStamps?: number | undefined;
    stamps?: number | undefined;
}

export class Filter implements IFilter {
    readonly name?: string | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    maxScore?: number | undefined;
    nextStrategy?: any | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (Array.isArray(_data["consumptionFilters"])) {
                this.consumptionFilters = [] as any;
                for (let item of _data["consumptionFilters"])
                    this.consumptionFilters!.push(ConsumptionFilterStrategy.fromJS(item));
            }
            this.maxScore = _data["maxScore"];
            this.nextStrategy = _data["nextStrategy"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.consumptionFilters)) {
            data["consumptionFilters"] = [];
            for (let item of this.consumptionFilters)
                data["consumptionFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxScore"] = this.maxScore;
        data["nextStrategy"] = this.nextStrategy;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IFilter {
    name?: string | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    maxScore?: number | undefined;
    nextStrategy?: any | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum FilterValidationToolOperatorEnum {
    Contains = "Contains",
    ContainsAll = "ContainsAll",
}

export class Fraud implements IFraud {
    attribution?: string | undefined;
    decision?: string | undefined;
    color?: string | undefined;
    customTypes?: string[] | undefined;
    types?: string[] | undefined;

    constructor(data?: IFraud) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribution = _data["attribution"];
            this.decision = _data["decision"];
            this.color = _data["color"];
            if (Array.isArray(_data["customTypes"])) {
                this.customTypes = [] as any;
                for (let item of _data["customTypes"])
                    this.customTypes!.push(item);
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): Fraud {
        data = typeof data === 'object' ? data : {};
        let result = new Fraud();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribution"] = this.attribution;
        data["decision"] = this.decision;
        data["color"] = this.color;
        if (Array.isArray(this.customTypes)) {
            data["customTypes"] = [];
            for (let item of this.customTypes)
                data["customTypes"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IFraud {
    attribution?: string | undefined;
    decision?: string | undefined;
    color?: string | undefined;
    customTypes?: string[] | undefined;
    types?: string[] | undefined;
}

export class FuzzyTestRequest implements IFuzzyTestRequest {
    text1?: string | undefined;
    text2?: string | undefined;

    constructor(data?: IFuzzyTestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text1 = _data["text1"];
            this.text2 = _data["text2"];
        }
    }

    static fromJS(data: any): FuzzyTestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FuzzyTestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text1"] = this.text1;
        data["text2"] = this.text2;
        return data;
    }
}

export interface IFuzzyTestRequest {
    text1?: string | undefined;
    text2?: string | undefined;
}

export class FuzzyTestResponse implements IFuzzyTestResponse {
    scoreByAlgorithm?: { [key: string]: number; } | undefined;

    constructor(data?: IFuzzyTestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["scoreByAlgorithm"]) {
                this.scoreByAlgorithm = {} as any;
                for (let key in _data["scoreByAlgorithm"]) {
                    if (_data["scoreByAlgorithm"].hasOwnProperty(key))
                        (this.scoreByAlgorithm as any)![key] = _data["scoreByAlgorithm"][key];
                }
            }
        }
    }

    static fromJS(data: any): FuzzyTestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FuzzyTestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.scoreByAlgorithm) {
            data["scoreByAlgorithm"] = {};
            for (let key in this.scoreByAlgorithm) {
                if (this.scoreByAlgorithm.hasOwnProperty(key))
                    (data["scoreByAlgorithm"] as any)[key] = (this.scoreByAlgorithm as any)[key];
            }
        }
        return data;
    }
}

export interface IFuzzyTestResponse {
    scoreByAlgorithm?: { [key: string]: number; } | undefined;
}

export class Game implements IGame {
    id?: string | undefined;
    encryptionKey?: string | undefined;
    algorithm?: string | undefined;
    gameUrl?: string | undefined;
    gameSlug?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    userName?: string | undefined;
    userCountryCode?: string | undefined;
    userPhone?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    ipAddress?: string | undefined;
    chances?: GameChance[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;
    orderIdsRewarded?: string[] | undefined;
    orderRewards?: RewardInfo[] | undefined;
    rewardEvents?: EventRewardReceived[] | undefined;
    customization?: GameCustomization | undefined;
    campaignId?: string | undefined;
    cardId?: string | undefined;
    isSaveGameResult?: boolean | undefined;

    constructor(data?: IGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.encryptionKey = _data["encryptionKey"];
            this.algorithm = _data["algorithm"];
            this.gameUrl = _data["gameUrl"];
            this.gameSlug = _data["gameSlug"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.userName = _data["userName"];
            this.userCountryCode = _data["userCountryCode"];
            this.userPhone = _data["userPhone"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.ipAddress = _data["ipAddress"];
            if (Array.isArray(_data["chances"])) {
                this.chances = [] as any;
                for (let item of _data["chances"])
                    this.chances!.push(GameChance.fromJS(item));
            }
            this.calculateWinningChanceServerside = _data["calculateWinningChanceServerside"];
            if (Array.isArray(_data["orderIdsRewarded"])) {
                this.orderIdsRewarded = [] as any;
                for (let item of _data["orderIdsRewarded"])
                    this.orderIdsRewarded!.push(item);
            }
            if (Array.isArray(_data["orderRewards"])) {
                this.orderRewards = [] as any;
                for (let item of _data["orderRewards"])
                    this.orderRewards!.push(RewardInfo.fromJS(item));
            }
            if (Array.isArray(_data["rewardEvents"])) {
                this.rewardEvents = [] as any;
                for (let item of _data["rewardEvents"])
                    this.rewardEvents!.push(EventRewardReceived.fromJS(item));
            }
            this.customization = _data["customization"] ? GameCustomization.fromJS(_data["customization"]) : undefined as any;
            this.campaignId = _data["campaignId"];
            this.cardId = _data["cardId"];
            this.isSaveGameResult = _data["isSaveGameResult"];
        }
    }

    static fromJS(data: any): Game {
        data = typeof data === 'object' ? data : {};
        let result = new Game();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["encryptionKey"] = this.encryptionKey;
        data["algorithm"] = this.algorithm;
        data["gameUrl"] = this.gameUrl;
        data["gameSlug"] = this.gameSlug;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["userName"] = this.userName;
        data["userCountryCode"] = this.userCountryCode;
        data["userPhone"] = this.userPhone;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["ipAddress"] = this.ipAddress;
        if (Array.isArray(this.chances)) {
            data["chances"] = [];
            for (let item of this.chances)
                data["chances"].push(item ? item.toJSON() : undefined as any);
        }
        data["calculateWinningChanceServerside"] = this.calculateWinningChanceServerside;
        if (Array.isArray(this.orderIdsRewarded)) {
            data["orderIdsRewarded"] = [];
            for (let item of this.orderIdsRewarded)
                data["orderIdsRewarded"].push(item);
        }
        if (Array.isArray(this.orderRewards)) {
            data["orderRewards"] = [];
            for (let item of this.orderRewards)
                data["orderRewards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rewardEvents)) {
            data["rewardEvents"] = [];
            for (let item of this.rewardEvents)
                data["rewardEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["customization"] = this.customization ? this.customization.toJSON() : undefined as any;
        data["campaignId"] = this.campaignId;
        data["cardId"] = this.cardId;
        data["isSaveGameResult"] = this.isSaveGameResult;
        return data;
    }
}

export interface IGame {
    id?: string | undefined;
    encryptionKey?: string | undefined;
    algorithm?: string | undefined;
    gameUrl?: string | undefined;
    gameSlug?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    userName?: string | undefined;
    userCountryCode?: string | undefined;
    userPhone?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    ipAddress?: string | undefined;
    chances?: GameChance[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;
    orderIdsRewarded?: string[] | undefined;
    orderRewards?: RewardInfo[] | undefined;
    rewardEvents?: EventRewardReceived[] | undefined;
    customization?: GameCustomization | undefined;
    campaignId?: string | undefined;
    cardId?: string | undefined;
    isSaveGameResult?: boolean | undefined;
}

export class GameChance implements IGameChance {
    chance?: number | undefined;
    product?: ProductInfo | undefined;

    constructor(data?: IGameChance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chance = _data["chance"];
            this.product = _data["product"] ? ProductInfo.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): GameChance {
        data = typeof data === 'object' ? data : {};
        let result = new GameChance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chance"] = this.chance;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface IGameChance {
    chance?: number | undefined;
    product?: ProductInfo | undefined;
}

export class GameCustomization implements IGameCustomization {
    animationUrl?: string | undefined;
    coverUrl?: string | undefined;
    backgroundUrl?: string | undefined;
    fontUrl?: string | undefined;
    brandStyle?: string | undefined;

    constructor(data?: IGameCustomization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animationUrl = _data["animationUrl"];
            this.coverUrl = _data["coverUrl"];
            this.backgroundUrl = _data["backgroundUrl"];
            this.fontUrl = _data["fontUrl"];
            this.brandStyle = _data["brandStyle"];
        }
    }

    static fromJS(data: any): GameCustomization {
        data = typeof data === 'object' ? data : {};
        let result = new GameCustomization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animationUrl"] = this.animationUrl;
        data["coverUrl"] = this.coverUrl;
        data["backgroundUrl"] = this.backgroundUrl;
        data["fontUrl"] = this.fontUrl;
        data["brandStyle"] = this.brandStyle;
        return data;
    }
}

export interface IGameCustomization {
    animationUrl?: string | undefined;
    coverUrl?: string | undefined;
    backgroundUrl?: string | undefined;
    fontUrl?: string | undefined;
    brandStyle?: string | undefined;
}

export class GenerateSampleRequest implements IGenerateSampleRequest {
    customerCode?: string | undefined;
    invoiceNumber?: string | undefined;
    totalQuantity?: number | undefined;
    receiptDate?: string | undefined;

    constructor(data?: IGenerateSampleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalQuantity = _data["totalQuantity"];
            this.receiptDate = _data["receiptDate"];
        }
    }

    static fromJS(data: any): GenerateSampleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSampleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalQuantity"] = this.totalQuantity;
        data["receiptDate"] = this.receiptDate;
        return data;
    }
}

export interface IGenerateSampleRequest {
    customerCode?: string | undefined;
    invoiceNumber?: string | undefined;
    totalQuantity?: number | undefined;
    receiptDate?: string | undefined;
}

export class GenerateSampleResponse implements IGenerateSampleResponse {
    sample?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IGenerateSampleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sample = _data["sample"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): GenerateSampleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSampleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sample"] = this.sample;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IGenerateSampleResponse {
    sample?: string | undefined;
    errorMessage?: string | undefined;
}

export class GpsCoordinates implements IGpsCoordinates {
    lat?: number | undefined;
    lng?: number | undefined;

    constructor(data?: IGpsCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): GpsCoordinates {
        data = typeof data === 'object' ? data : {};
        let result = new GpsCoordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }
}

export interface IGpsCoordinates {
    lat?: number | undefined;
    lng?: number | undefined;
}

export class HandshakeQrContext implements IHandshakeQrContext {
    gpsCoordinates?: GpsCoordinates | undefined;
    period?: string | undefined;

    constructor(data?: IHandshakeQrContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gpsCoordinates = _data["gpsCoordinates"] ? GpsCoordinates.fromJS(_data["gpsCoordinates"]) : undefined as any;
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): HandshakeQrContext {
        data = typeof data === 'object' ? data : {};
        let result = new HandshakeQrContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpsCoordinates"] = this.gpsCoordinates ? this.gpsCoordinates.toJSON() : undefined as any;
        data["period"] = this.period;
        return data;
    }
}

export interface IHandshakeQrContext {
    gpsCoordinates?: GpsCoordinates | undefined;
    period?: string | undefined;
}

export class HandshakeQrLimitRule implements IHandshakeQrLimitRule {
    maxPointsGenerator?: number | undefined;
    maxPointsScanner?: number | undefined;
    maxQRGenerations?: number | undefined;
    maxQRScans?: number | undefined;
    pointsInterval?: string | undefined;
    generationInterval?: string | undefined;
    scanInterval?: string | undefined;
    pointsIntervalStart?: Date | undefined;
    generationIntervalStart?: Date | undefined;
    scanIntervalStart?: Date | undefined;
    currentGeneratorPoints?: number | undefined;
    currentScannerPoints?: number | undefined;
    currentGenerations?: number | undefined;
    currentScans?: number | undefined;

    constructor(data?: IHandshakeQrLimitRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxPointsGenerator = _data["maxPointsGenerator"];
            this.maxPointsScanner = _data["maxPointsScanner"];
            this.maxQRGenerations = _data["maxQRGenerations"];
            this.maxQRScans = _data["maxQRScans"];
            this.pointsInterval = _data["pointsInterval"];
            this.generationInterval = _data["generationInterval"];
            this.scanInterval = _data["scanInterval"];
            this.pointsIntervalStart = _data["pointsIntervalStart"] ? new Date(_data["pointsIntervalStart"].toString()) : undefined as any;
            this.generationIntervalStart = _data["generationIntervalStart"] ? new Date(_data["generationIntervalStart"].toString()) : undefined as any;
            this.scanIntervalStart = _data["scanIntervalStart"] ? new Date(_data["scanIntervalStart"].toString()) : undefined as any;
            this.currentGeneratorPoints = _data["currentGeneratorPoints"];
            this.currentScannerPoints = _data["currentScannerPoints"];
            this.currentGenerations = _data["currentGenerations"];
            this.currentScans = _data["currentScans"];
        }
    }

    static fromJS(data: any): HandshakeQrLimitRule {
        data = typeof data === 'object' ? data : {};
        let result = new HandshakeQrLimitRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxPointsGenerator"] = this.maxPointsGenerator;
        data["maxPointsScanner"] = this.maxPointsScanner;
        data["maxQRGenerations"] = this.maxQRGenerations;
        data["maxQRScans"] = this.maxQRScans;
        data["pointsInterval"] = this.pointsInterval;
        data["generationInterval"] = this.generationInterval;
        data["scanInterval"] = this.scanInterval;
        data["pointsIntervalStart"] = this.pointsIntervalStart ? this.pointsIntervalStart.toISOString() : undefined as any;
        data["generationIntervalStart"] = this.generationIntervalStart ? this.generationIntervalStart.toISOString() : undefined as any;
        data["scanIntervalStart"] = this.scanIntervalStart ? this.scanIntervalStart.toISOString() : undefined as any;
        data["currentGeneratorPoints"] = this.currentGeneratorPoints;
        data["currentScannerPoints"] = this.currentScannerPoints;
        data["currentGenerations"] = this.currentGenerations;
        data["currentScans"] = this.currentScans;
        return data;
    }
}

export interface IHandshakeQrLimitRule {
    maxPointsGenerator?: number | undefined;
    maxPointsScanner?: number | undefined;
    maxQRGenerations?: number | undefined;
    maxQRScans?: number | undefined;
    pointsInterval?: string | undefined;
    generationInterval?: string | undefined;
    scanInterval?: string | undefined;
    pointsIntervalStart?: Date | undefined;
    generationIntervalStart?: Date | undefined;
    scanIntervalStart?: Date | undefined;
    currentGeneratorPoints?: number | undefined;
    currentScannerPoints?: number | undefined;
    currentGenerations?: number | undefined;
    currentScans?: number | undefined;
}

export class HistoryPoints implements IHistoryPoints {
    points?: number | undefined;
    schemaId?: string | undefined;
    userId?: string | undefined;
    openerId?: string | undefined;
    captureTime?: Date | undefined;

    constructor(data?: IHistoryPoints) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.points = _data["points"];
            this.schemaId = _data["schemaId"];
            this.userId = _data["userId"];
            this.openerId = _data["openerId"];
            this.captureTime = _data["captureTime"] ? new Date(_data["captureTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HistoryPoints {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryPoints();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["points"] = this.points;
        data["schemaId"] = this.schemaId;
        data["userId"] = this.userId;
        data["openerId"] = this.openerId;
        data["captureTime"] = this.captureTime ? this.captureTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IHistoryPoints {
    points?: number | undefined;
    schemaId?: string | undefined;
    userId?: string | undefined;
    openerId?: string | undefined;
    captureTime?: Date | undefined;
}

export class ImportSafeBoxProductSku implements IImportSafeBoxProductSku {
    fileName?: string | undefined;
    uploadKey?: string | undefined;
    email?: string | undefined;
    isSuccess?: boolean | undefined;
    totalStepElapsedSeconds?: number | undefined;
    nextStep?: string | undefined;
    productSkuId?: string | undefined;
    productSkuName?: string | undefined;
    numberOfSafeboxToCreate?: number | undefined;
    format?: string | undefined;
    readonly numberOfCharacters?: number | undefined;
    userId?: string | undefined;
    noOfCodesGeneratedSoFar?: number | undefined;
    noOfCodesPerIteration?: number | undefined;
    safeBoxS3Link?: string | undefined;
    safeBoxS3KeyNamePrefix?: string | undefined;
    safeBoxS3KeyNames?: string[] | undefined;

    constructor(data?: IImportSafeBoxProductSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.uploadKey = _data["uploadKey"];
            this.email = _data["email"];
            this.isSuccess = _data["isSuccess"];
            this.totalStepElapsedSeconds = _data["totalStepElapsedSeconds"];
            this.nextStep = _data["nextStep"];
            this.productSkuId = _data["productSkuId"];
            this.productSkuName = _data["productSkuName"];
            this.numberOfSafeboxToCreate = _data["numberOfSafeboxToCreate"];
            this.format = _data["format"];
            (this as any).numberOfCharacters = _data["numberOfCharacters"];
            this.userId = _data["userId"];
            this.noOfCodesGeneratedSoFar = _data["noOfCodesGeneratedSoFar"];
            this.noOfCodesPerIteration = _data["noOfCodesPerIteration"];
            this.safeBoxS3Link = _data["safeBoxS3Link"];
            this.safeBoxS3KeyNamePrefix = _data["safeBoxS3KeyNamePrefix"];
            if (Array.isArray(_data["safeBoxS3KeyNames"])) {
                this.safeBoxS3KeyNames = [] as any;
                for (let item of _data["safeBoxS3KeyNames"])
                    this.safeBoxS3KeyNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportSafeBoxProductSku {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSafeBoxProductSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["uploadKey"] = this.uploadKey;
        data["email"] = this.email;
        data["isSuccess"] = this.isSuccess;
        data["totalStepElapsedSeconds"] = this.totalStepElapsedSeconds;
        data["nextStep"] = this.nextStep;
        data["productSkuId"] = this.productSkuId;
        data["productSkuName"] = this.productSkuName;
        data["numberOfSafeboxToCreate"] = this.numberOfSafeboxToCreate;
        data["format"] = this.format;
        data["numberOfCharacters"] = this.numberOfCharacters;
        data["userId"] = this.userId;
        data["noOfCodesGeneratedSoFar"] = this.noOfCodesGeneratedSoFar;
        data["noOfCodesPerIteration"] = this.noOfCodesPerIteration;
        data["safeBoxS3Link"] = this.safeBoxS3Link;
        data["safeBoxS3KeyNamePrefix"] = this.safeBoxS3KeyNamePrefix;
        if (Array.isArray(this.safeBoxS3KeyNames)) {
            data["safeBoxS3KeyNames"] = [];
            for (let item of this.safeBoxS3KeyNames)
                data["safeBoxS3KeyNames"].push(item);
        }
        return data;
    }
}

export interface IImportSafeBoxProductSku {
    fileName?: string | undefined;
    uploadKey?: string | undefined;
    email?: string | undefined;
    isSuccess?: boolean | undefined;
    totalStepElapsedSeconds?: number | undefined;
    nextStep?: string | undefined;
    productSkuId?: string | undefined;
    productSkuName?: string | undefined;
    numberOfSafeboxToCreate?: number | undefined;
    format?: string | undefined;
    numberOfCharacters?: number | undefined;
    userId?: string | undefined;
    noOfCodesGeneratedSoFar?: number | undefined;
    noOfCodesPerIteration?: number | undefined;
    safeBoxS3Link?: string | undefined;
    safeBoxS3KeyNamePrefix?: string | undefined;
    safeBoxS3KeyNames?: string[] | undefined;
}

export class ImportUserConsumption implements IImportUserConsumption {
    fileName?: string | undefined;
    uploadKey?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    campaignId?: string | undefined;
    noOfCodesGeneratedSoFar?: number | undefined;
    noOfCodesPerIteration?: number | undefined;
    numberOfSafeboxToCreate?: number | undefined;
    isSuccess?: boolean | undefined;
    totalStepElapsedSeconds?: number | undefined;
    nextStep?: string | undefined;
    safeBoxS3Link?: string | undefined;
    safeBoxS3KeyNamePrefix?: string | undefined;
    safeBoxS3KeyNames?: string[] | undefined;

    constructor(data?: IImportUserConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.uploadKey = _data["uploadKey"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.campaignId = _data["campaignId"];
            this.noOfCodesGeneratedSoFar = _data["noOfCodesGeneratedSoFar"];
            this.noOfCodesPerIteration = _data["noOfCodesPerIteration"];
            this.numberOfSafeboxToCreate = _data["numberOfSafeboxToCreate"];
            this.isSuccess = _data["isSuccess"];
            this.totalStepElapsedSeconds = _data["totalStepElapsedSeconds"];
            this.nextStep = _data["nextStep"];
            this.safeBoxS3Link = _data["safeBoxS3Link"];
            this.safeBoxS3KeyNamePrefix = _data["safeBoxS3KeyNamePrefix"];
            if (Array.isArray(_data["safeBoxS3KeyNames"])) {
                this.safeBoxS3KeyNames = [] as any;
                for (let item of _data["safeBoxS3KeyNames"])
                    this.safeBoxS3KeyNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportUserConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new ImportUserConsumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["uploadKey"] = this.uploadKey;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["campaignId"] = this.campaignId;
        data["noOfCodesGeneratedSoFar"] = this.noOfCodesGeneratedSoFar;
        data["noOfCodesPerIteration"] = this.noOfCodesPerIteration;
        data["numberOfSafeboxToCreate"] = this.numberOfSafeboxToCreate;
        data["isSuccess"] = this.isSuccess;
        data["totalStepElapsedSeconds"] = this.totalStepElapsedSeconds;
        data["nextStep"] = this.nextStep;
        data["safeBoxS3Link"] = this.safeBoxS3Link;
        data["safeBoxS3KeyNamePrefix"] = this.safeBoxS3KeyNamePrefix;
        if (Array.isArray(this.safeBoxS3KeyNames)) {
            data["safeBoxS3KeyNames"] = [];
            for (let item of this.safeBoxS3KeyNames)
                data["safeBoxS3KeyNames"].push(item);
        }
        return data;
    }
}

export interface IImportUserConsumption {
    fileName?: string | undefined;
    uploadKey?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    campaignId?: string | undefined;
    noOfCodesGeneratedSoFar?: number | undefined;
    noOfCodesPerIteration?: number | undefined;
    numberOfSafeboxToCreate?: number | undefined;
    isSuccess?: boolean | undefined;
    totalStepElapsedSeconds?: number | undefined;
    nextStep?: string | undefined;
    safeBoxS3Link?: string | undefined;
    safeBoxS3KeyNamePrefix?: string | undefined;
    safeBoxS3KeyNames?: string[] | undefined;
}

export class JsonElement implements IJsonElement {
    valueKind?: JsonValueKind | undefined;

    constructor(data?: IJsonElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueKind = _data["valueKind"];
        }
    }

    static fromJS(data: any): JsonElement {
        data = typeof data === 'object' ? data : {};
        let result = new JsonElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueKind"] = this.valueKind;
        return data;
    }
}

export interface IJsonElement {
    valueKind?: JsonValueKind | undefined;
}

export enum JsonValueKind {
    Undefined = "Undefined",
    Object = "Object",
    Array = "Array",
    String = "String",
    Number = "Number",
    True = "True",
    False = "False",
    Null = "Null",
}

export class LineItem implements ILineItem {
    name?: string | undefined;
    code?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    total?: number | undefined;
    discount?: number | undefined;
    type?: string | undefined;

    constructor(data?: ILineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.price = _data["price"];
            this.total = _data["total"];
            this.discount = _data["discount"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LineItem {
        data = typeof data === 'object' ? data : {};
        let result = new LineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["price"] = this.price;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["type"] = this.type;
        return data;
    }
}

export interface ILineItem {
    name?: string | undefined;
    code?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    total?: number | undefined;
    discount?: number | undefined;
    type?: string | undefined;
}

export class LinkedCampaignDto implements ILinkedCampaignDto {
    name?: string | undefined;
    type?: LinkedCampaignType | undefined;
    campaigns?: Campaign[] | undefined;

    constructor(data?: ILinkedCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(Campaign.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkedCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILinkedCampaignDto {
    name?: string | undefined;
    type?: LinkedCampaignType | undefined;
    campaigns?: Campaign[] | undefined;
}

export class LinkedCampaigns implements ILinkedCampaigns {
    name?: string | undefined;
    type?: LinkedCampaignType | undefined;
    campaignIds?: string[] | undefined;

    constructor(data?: ILinkedCampaigns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["campaignIds"])) {
                this.campaignIds = [] as any;
                for (let item of _data["campaignIds"])
                    this.campaignIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkedCampaigns {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedCampaigns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.campaignIds)) {
            data["campaignIds"] = [];
            for (let item of this.campaignIds)
                data["campaignIds"].push(item);
        }
        return data;
    }
}

export interface ILinkedCampaigns {
    name?: string | undefined;
    type?: LinkedCampaignType | undefined;
    campaignIds?: string[] | undefined;
}

export enum LinkedCampaignType {
    Linked = "Linked",
    Consecutive = "Consecutive",
}

export class LocationFilterByOrganizationId implements ILocationFilterByOrganizationId {
    readonly type?: string | undefined;
    organizationIds?: string[] | undefined;

    constructor(data?: ILocationFilterByOrganizationId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).type = _data["type"];
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LocationFilterByOrganizationId {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFilterByOrganizationId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        return data;
    }
}

export interface ILocationFilterByOrganizationId {
    type?: string | undefined;
    organizationIds?: string[] | undefined;
}

export class LocationFilterByOrganizationTag implements ILocationFilterByOrganizationTag {
    readonly type?: string | undefined;
    tags?: TagItem[] | undefined;

    constructor(data?: ILocationFilterByOrganizationTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).type = _data["type"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationFilterByOrganizationTag {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFilterByOrganizationTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocationFilterByOrganizationTag {
    type?: string | undefined;
    tags?: TagItem[] | undefined;
}

export class LocationFilterByOutlet implements ILocationFilterByOutlet {
    readonly type?: string | undefined;
    outletIds?: string[] | undefined;

    constructor(data?: ILocationFilterByOutlet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).type = _data["type"];
            if (Array.isArray(_data["outletIds"])) {
                this.outletIds = [] as any;
                for (let item of _data["outletIds"])
                    this.outletIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LocationFilterByOutlet {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFilterByOutlet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.outletIds)) {
            data["outletIds"] = [];
            for (let item of this.outletIds)
                data["outletIds"].push(item);
        }
        return data;
    }
}

export interface ILocationFilterByOutlet {
    type?: string | undefined;
    outletIds?: string[] | undefined;
}

export class LocationFilterByOutletProperty implements ILocationFilterByOutletProperty {
    readonly type?: string | undefined;
    outletPropertyItems?: OutletPropertyItem[] | undefined;

    constructor(data?: ILocationFilterByOutletProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).type = _data["type"];
            if (Array.isArray(_data["outletPropertyItems"])) {
                this.outletPropertyItems = [] as any;
                for (let item of _data["outletPropertyItems"])
                    this.outletPropertyItems!.push(OutletPropertyItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationFilterByOutletProperty {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFilterByOutletProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.outletPropertyItems)) {
            data["outletPropertyItems"] = [];
            for (let item of this.outletPropertyItems)
                data["outletPropertyItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocationFilterByOutletProperty {
    type?: string | undefined;
    outletPropertyItems?: OutletPropertyItem[] | undefined;
}

export class LuckyDrawStrategy implements ILuckyDrawStrategy {
    readonly name?: string | undefined;
    rewardChances?: RewardChance[] | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    joinReward?: RewardData | undefined;
    firstConsumptionReward?: RewardData | undefined;
    firstConsumptionRewarded?: boolean | undefined;
    consumptionReward?: RewardData | undefined;
    scorePerChance?: number | undefined;
    maxChancesPerConsumptionEvent?: number | undefined;
    chanceCount?: number | undefined;
    initialChanceCount?: number | undefined;
    allowDuplicates?: boolean | undefined;
    lastChanceGivenTime?: Date | undefined;
    secondsBetweenChances?: number | undefined;
    receiptCheck?: ReceiptCheckOptions | undefined;
    isUnderReview?: boolean | undefined;
    receiptManualValidationRule?: ReceiptManualValidationRule | undefined;
    gameSlug?: string | undefined;
    algorithm?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: ILuckyDrawStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (Array.isArray(_data["rewardChances"])) {
                this.rewardChances = [] as any;
                for (let item of _data["rewardChances"])
                    this.rewardChances!.push(RewardChance.fromJS(item));
            }
            if (Array.isArray(_data["consumptionFilters"])) {
                this.consumptionFilters = [] as any;
                for (let item of _data["consumptionFilters"])
                    this.consumptionFilters!.push(ConsumptionFilterStrategy.fromJS(item));
            }
            this.joinReward = _data["joinReward"] ? RewardData.fromJS(_data["joinReward"]) : undefined as any;
            this.firstConsumptionReward = _data["firstConsumptionReward"] ? RewardData.fromJS(_data["firstConsumptionReward"]) : undefined as any;
            this.firstConsumptionRewarded = _data["firstConsumptionRewarded"];
            this.consumptionReward = _data["consumptionReward"] ? RewardData.fromJS(_data["consumptionReward"]) : undefined as any;
            this.scorePerChance = _data["scorePerChance"];
            this.maxChancesPerConsumptionEvent = _data["maxChancesPerConsumptionEvent"];
            this.chanceCount = _data["chanceCount"];
            this.initialChanceCount = _data["initialChanceCount"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.lastChanceGivenTime = _data["lastChanceGivenTime"] ? new Date(_data["lastChanceGivenTime"].toString()) : undefined as any;
            this.secondsBetweenChances = _data["secondsBetweenChances"];
            this.receiptCheck = _data["receiptCheck"] ? ReceiptCheckOptions.fromJS(_data["receiptCheck"]) : undefined as any;
            this.isUnderReview = _data["isUnderReview"];
            this.receiptManualValidationRule = _data["receiptManualValidationRule"] ? ReceiptManualValidationRule.fromJS(_data["receiptManualValidationRule"]) : undefined as any;
            this.gameSlug = _data["gameSlug"];
            this.algorithm = _data["algorithm"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): LuckyDrawStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new LuckyDrawStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.rewardChances)) {
            data["rewardChances"] = [];
            for (let item of this.rewardChances)
                data["rewardChances"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.consumptionFilters)) {
            data["consumptionFilters"] = [];
            for (let item of this.consumptionFilters)
                data["consumptionFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["joinReward"] = this.joinReward ? this.joinReward.toJSON() : undefined as any;
        data["firstConsumptionReward"] = this.firstConsumptionReward ? this.firstConsumptionReward.toJSON() : undefined as any;
        data["firstConsumptionRewarded"] = this.firstConsumptionRewarded;
        data["consumptionReward"] = this.consumptionReward ? this.consumptionReward.toJSON() : undefined as any;
        data["scorePerChance"] = this.scorePerChance;
        data["maxChancesPerConsumptionEvent"] = this.maxChancesPerConsumptionEvent;
        data["chanceCount"] = this.chanceCount;
        data["initialChanceCount"] = this.initialChanceCount;
        data["allowDuplicates"] = this.allowDuplicates;
        data["lastChanceGivenTime"] = this.lastChanceGivenTime ? this.lastChanceGivenTime.toISOString() : undefined as any;
        data["secondsBetweenChances"] = this.secondsBetweenChances;
        data["receiptCheck"] = this.receiptCheck ? this.receiptCheck.toJSON() : undefined as any;
        data["isUnderReview"] = this.isUnderReview;
        data["receiptManualValidationRule"] = this.receiptManualValidationRule ? this.receiptManualValidationRule.toJSON() : undefined as any;
        data["gameSlug"] = this.gameSlug;
        data["algorithm"] = this.algorithm;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface ILuckyDrawStrategy {
    name?: string | undefined;
    rewardChances?: RewardChance[] | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    joinReward?: RewardData | undefined;
    firstConsumptionReward?: RewardData | undefined;
    firstConsumptionRewarded?: boolean | undefined;
    consumptionReward?: RewardData | undefined;
    scorePerChance?: number | undefined;
    maxChancesPerConsumptionEvent?: number | undefined;
    chanceCount?: number | undefined;
    initialChanceCount?: number | undefined;
    allowDuplicates?: boolean | undefined;
    lastChanceGivenTime?: Date | undefined;
    secondsBetweenChances?: number | undefined;
    receiptCheck?: ReceiptCheckOptions | undefined;
    isUnderReview?: boolean | undefined;
    receiptManualValidationRule?: ReceiptManualValidationRule | undefined;
    gameSlug?: string | undefined;
    algorithm?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum MatchAlgorithm {
    Ratio = "Ratio",
    PartialRatio = "PartialRatio",
    TokenSortPartialRatio = "TokenSortPartialRatio",
    TokenSortRatio = "TokenSortRatio",
    TokenSetPartialRatio = "TokenSetPartialRatio",
    TokenSetRatio = "TokenSetRatio",
    WeightedRatio = "WeightedRatio",
}

export class MediaObject implements IMediaObject {
    key?: string | undefined;
    url?: string | undefined;
    lastModified?: Date | undefined;

    constructor(data?: IMediaObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.url = _data["url"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MediaObject {
        data = typeof data === 'object' ? data : {};
        let result = new MediaObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["url"] = this.url;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IMediaObject {
    key?: string | undefined;
    url?: string | undefined;
    lastModified?: Date | undefined;
}

export class MetaInfo implements IMetaInfo {
    fraud?: Fraud | undefined;
    warnings?: Warning[] | undefined;

    constructor(data?: IMetaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fraud = _data["fraud"] ? Fraud.fromJS(_data["fraud"]) : undefined as any;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MetaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraud"] = this.fraud ? this.fraud.toJSON() : undefined as any;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMetaInfo {
    fraud?: Fraud | undefined;
    warnings?: Warning[] | undefined;
}

export class MigrateUsersRequest implements IMigrateUsersRequest {
    migrationId?: string | undefined;
    csvS3Url?: string | undefined;
    isRevoke?: boolean | undefined;
    isCreditPoint?: boolean | undefined;
    isDebitPoint?: boolean | undefined;
    isAddCard?: boolean | undefined;
    isAddTags?: boolean | undefined;
    customTags?: { [key: string]: string; }[] | undefined;

    constructor(data?: IMigrateUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.migrationId = _data["migrationId"];
            this.csvS3Url = _data["csvS3Url"];
            this.isRevoke = _data["isRevoke"];
            this.isCreditPoint = _data["isCreditPoint"];
            this.isDebitPoint = _data["isDebitPoint"];
            this.isAddCard = _data["isAddCard"];
            this.isAddTags = _data["isAddTags"];
            if (Array.isArray(_data["customTags"])) {
                this.customTags = [] as any;
                for (let item of _data["customTags"])
                    this.customTags!.push(item);
            }
        }
    }

    static fromJS(data: any): MigrateUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["migrationId"] = this.migrationId;
        data["csvS3Url"] = this.csvS3Url;
        data["isRevoke"] = this.isRevoke;
        data["isCreditPoint"] = this.isCreditPoint;
        data["isDebitPoint"] = this.isDebitPoint;
        data["isAddCard"] = this.isAddCard;
        data["isAddTags"] = this.isAddTags;
        if (Array.isArray(this.customTags)) {
            data["customTags"] = [];
            for (let item of this.customTags)
                data["customTags"].push(item);
        }
        return data;
    }
}

export interface IMigrateUsersRequest {
    migrationId?: string | undefined;
    csvS3Url?: string | undefined;
    isRevoke?: boolean | undefined;
    isCreditPoint?: boolean | undefined;
    isDebitPoint?: boolean | undefined;
    isAddCard?: boolean | undefined;
    isAddTags?: boolean | undefined;
    customTags?: { [key: string]: string; }[] | undefined;
}

export class MigrationProgressResponse implements IMigrationProgressResponse {
    migrationId?: string | undefined;
    userId?: string | undefined;
    totalUsers?: number | undefined;
    processedUsers?: number | undefined;
    successfulUsers?: number | undefined;
    failedUsers?: number | undefined;
    progressPercentage?: number | undefined;
    status?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    duration?: string | undefined;
    message?: string | undefined;
    csvS3Url?: string | undefined;
    targetCampaignIds?: string[] | undefined;
    revokedCampaignIds?: string[] | undefined;
    resultsFileS3Url?: string | undefined;
    errorReportS3Url?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    readonly successRate?: number | undefined;
    readonly isRunning?: boolean | undefined;
    readonly isCompleted?: boolean | undefined;
    readonly isFailed?: boolean | undefined;
    readonly formattedDuration?: string | undefined;
    readonly estimatedTimeRemaining?: string | undefined;

    constructor(data?: IMigrationProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.migrationId = _data["migrationId"];
            this.userId = _data["userId"];
            this.totalUsers = _data["totalUsers"];
            this.processedUsers = _data["processedUsers"];
            this.successfulUsers = _data["successfulUsers"];
            this.failedUsers = _data["failedUsers"];
            this.progressPercentage = _data["progressPercentage"];
            this.status = _data["status"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.message = _data["message"];
            this.csvS3Url = _data["csvS3Url"];
            if (Array.isArray(_data["targetCampaignIds"])) {
                this.targetCampaignIds = [] as any;
                for (let item of _data["targetCampaignIds"])
                    this.targetCampaignIds!.push(item);
            }
            if (Array.isArray(_data["revokedCampaignIds"])) {
                this.revokedCampaignIds = [] as any;
                for (let item of _data["revokedCampaignIds"])
                    this.revokedCampaignIds!.push(item);
            }
            this.resultsFileS3Url = _data["resultsFileS3Url"];
            this.errorReportS3Url = _data["errorReportS3Url"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            (this as any).successRate = _data["successRate"];
            (this as any).isRunning = _data["isRunning"];
            (this as any).isCompleted = _data["isCompleted"];
            (this as any).isFailed = _data["isFailed"];
            (this as any).formattedDuration = _data["formattedDuration"];
            (this as any).estimatedTimeRemaining = _data["estimatedTimeRemaining"];
        }
    }

    static fromJS(data: any): MigrationProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["migrationId"] = this.migrationId;
        data["userId"] = this.userId;
        data["totalUsers"] = this.totalUsers;
        data["processedUsers"] = this.processedUsers;
        data["successfulUsers"] = this.successfulUsers;
        data["failedUsers"] = this.failedUsers;
        data["progressPercentage"] = this.progressPercentage;
        data["status"] = this.status;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["message"] = this.message;
        data["csvS3Url"] = this.csvS3Url;
        if (Array.isArray(this.targetCampaignIds)) {
            data["targetCampaignIds"] = [];
            for (let item of this.targetCampaignIds)
                data["targetCampaignIds"].push(item);
        }
        if (Array.isArray(this.revokedCampaignIds)) {
            data["revokedCampaignIds"] = [];
            for (let item of this.revokedCampaignIds)
                data["revokedCampaignIds"].push(item);
        }
        data["resultsFileS3Url"] = this.resultsFileS3Url;
        data["errorReportS3Url"] = this.errorReportS3Url;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["successRate"] = this.successRate;
        data["isRunning"] = this.isRunning;
        data["isCompleted"] = this.isCompleted;
        data["isFailed"] = this.isFailed;
        data["formattedDuration"] = this.formattedDuration;
        data["estimatedTimeRemaining"] = this.estimatedTimeRemaining;
        return data;
    }
}

export interface IMigrationProgressResponse {
    migrationId?: string | undefined;
    userId?: string | undefined;
    totalUsers?: number | undefined;
    processedUsers?: number | undefined;
    successfulUsers?: number | undefined;
    failedUsers?: number | undefined;
    progressPercentage?: number | undefined;
    status?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    duration?: string | undefined;
    message?: string | undefined;
    csvS3Url?: string | undefined;
    targetCampaignIds?: string[] | undefined;
    revokedCampaignIds?: string[] | undefined;
    resultsFileS3Url?: string | undefined;
    errorReportS3Url?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    successRate?: number | undefined;
    isRunning?: boolean | undefined;
    isCompleted?: boolean | undefined;
    isFailed?: boolean | undefined;
    formattedDuration?: string | undefined;
    estimatedTimeRemaining?: string | undefined;
}

export class MigrationStartResponse implements IMigrationStartResponse {
    message?: string | undefined;
    migrationId?: string | undefined;
    executionReference?: string | undefined;

    constructor(data?: IMigrationStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.migrationId = _data["migrationId"];
            this.executionReference = _data["executionReference"];
        }
    }

    static fromJS(data: any): MigrationStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["migrationId"] = this.migrationId;
        data["executionReference"] = this.executionReference;
        return data;
    }
}

export interface IMigrationStartResponse {
    message?: string | undefined;
    migrationId?: string | undefined;
    executionReference?: string | undefined;
}

export enum NoPointReceivedReason {
    MaximumProductsInTimeIntervalReached = "MaximumProductsInTimeIntervalReached",
    NoPointsGiven = "NoPointsGiven",
    UnsupportedCaptureToolType = "UnsupportedCaptureToolType",
}

export class OpenerConstraint implements IOpenerConstraint {
    userDailyPoints?: number | undefined;
    userTotalPoints?: number | undefined;
    openerDailyPoints?: number | undefined;
    openerTotalPoints?: number | undefined;

    constructor(data?: IOpenerConstraint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDailyPoints = _data["userDailyPoints"];
            this.userTotalPoints = _data["userTotalPoints"];
            this.openerDailyPoints = _data["openerDailyPoints"];
            this.openerTotalPoints = _data["openerTotalPoints"];
        }
    }

    static fromJS(data: any): OpenerConstraint {
        data = typeof data === 'object' ? data : {};
        let result = new OpenerConstraint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDailyPoints"] = this.userDailyPoints;
        data["userTotalPoints"] = this.userTotalPoints;
        data["openerDailyPoints"] = this.openerDailyPoints;
        data["openerTotalPoints"] = this.openerTotalPoints;
        return data;
    }
}

export interface IOpenerConstraint {
    userDailyPoints?: number | undefined;
    userTotalPoints?: number | undefined;
    openerDailyPoints?: number | undefined;
    openerTotalPoints?: number | undefined;
}

export class OpenerScheme implements IOpenerScheme {
    id?: string | undefined;
    name?: string | undefined;
    banner?: CampaignBanner | undefined;
    status?: OpenerSchemeStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    rewardRules?: OpenerSchemeRewardRule[] | undefined;
    constraint?: OpenerConstraint | undefined;
    priority?: number | undefined;

    constructor(data?: IOpenerScheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["rewardRules"])) {
                this.rewardRules = [] as any;
                for (let item of _data["rewardRules"])
                    this.rewardRules!.push(OpenerSchemeRewardRule.fromJS(item));
            }
            this.constraint = _data["constraint"] ? OpenerConstraint.fromJS(_data["constraint"]) : undefined as any;
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): OpenerScheme {
        data = typeof data === 'object' ? data : {};
        let result = new OpenerScheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.rewardRules)) {
            data["rewardRules"] = [];
            for (let item of this.rewardRules)
                data["rewardRules"].push(item ? item.toJSON() : undefined as any);
        }
        data["constraint"] = this.constraint ? this.constraint.toJSON() : undefined as any;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IOpenerScheme {
    id?: string | undefined;
    name?: string | undefined;
    banner?: CampaignBanner | undefined;
    status?: OpenerSchemeStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    rewardRules?: OpenerSchemeRewardRule[] | undefined;
    constraint?: OpenerConstraint | undefined;
    priority?: number | undefined;
}

export class OpenerSchemeRewardRule implements IOpenerSchemeRewardRule {
    bottleProducts?: BottleProductInfo[] | undefined;
    pointsPerBottle?: number | undefined;

    constructor(data?: IOpenerSchemeRewardRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bottleProducts"])) {
                this.bottleProducts = [] as any;
                for (let item of _data["bottleProducts"])
                    this.bottleProducts!.push(BottleProductInfo.fromJS(item));
            }
            this.pointsPerBottle = _data["pointsPerBottle"];
        }
    }

    static fromJS(data: any): OpenerSchemeRewardRule {
        data = typeof data === 'object' ? data : {};
        let result = new OpenerSchemeRewardRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bottleProducts)) {
            data["bottleProducts"] = [];
            for (let item of this.bottleProducts)
                data["bottleProducts"].push(item ? item.toJSON() : undefined as any);
        }
        data["pointsPerBottle"] = this.pointsPerBottle;
        return data;
    }
}

export interface IOpenerSchemeRewardRule {
    bottleProducts?: BottleProductInfo[] | undefined;
    pointsPerBottle?: number | undefined;
}

export enum OpenerSchemeStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class OpenerStrategy implements IOpenerStrategy {
    readonly name?: string | undefined;
    schemes?: OpenerScheme[] | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IOpenerStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (Array.isArray(_data["schemes"])) {
                this.schemes = [] as any;
                for (let item of _data["schemes"])
                    this.schemes!.push(OpenerScheme.fromJS(item));
            }
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): OpenerStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new OpenerStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.schemes)) {
            data["schemes"] = [];
            for (let item of this.schemes)
                data["schemes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IOpenerStrategy {
    name?: string | undefined;
    schemes?: OpenerScheme[] | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class OutboundEventIntegrationConfig implements IOutboundEventIntegrationConfig {
    provider?: OutboundEventProvider | undefined;
    credentials?: { [key: string]: string; } | undefined;
    subscribedEventTypes?: OutboundEvents[] | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IOutboundEventIntegrationConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            if (_data["credentials"]) {
                this.credentials = {} as any;
                for (let key in _data["credentials"]) {
                    if (_data["credentials"].hasOwnProperty(key))
                        (this.credentials as any)![key] = _data["credentials"][key];
                }
            }
            if (Array.isArray(_data["subscribedEventTypes"])) {
                this.subscribedEventTypes = [] as any;
                for (let item of _data["subscribedEventTypes"])
                    this.subscribedEventTypes!.push(item);
            }
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): OutboundEventIntegrationConfig {
        data = typeof data === 'object' ? data : {};
        let result = new OutboundEventIntegrationConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        if (this.credentials) {
            data["credentials"] = {};
            for (let key in this.credentials) {
                if (this.credentials.hasOwnProperty(key))
                    (data["credentials"] as any)[key] = (this.credentials as any)[key];
            }
        }
        if (Array.isArray(this.subscribedEventTypes)) {
            data["subscribedEventTypes"] = [];
            for (let item of this.subscribedEventTypes)
                data["subscribedEventTypes"].push(item);
        }
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IOutboundEventIntegrationConfig {
    provider?: OutboundEventProvider | undefined;
    credentials?: { [key: string]: string; } | undefined;
    subscribedEventTypes?: OutboundEvents[] | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class OutboundEventIntegrationConfigDto implements IOutboundEventIntegrationConfigDto {
    provider?: OutboundEventProvider | undefined;
    credentials?: { [key: string]: string; } | undefined;
    subscribedEventTypes?: OutboundEvents[] | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IOutboundEventIntegrationConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            if (_data["credentials"]) {
                this.credentials = {} as any;
                for (let key in _data["credentials"]) {
                    if (_data["credentials"].hasOwnProperty(key))
                        (this.credentials as any)![key] = _data["credentials"][key];
                }
            }
            if (Array.isArray(_data["subscribedEventTypes"])) {
                this.subscribedEventTypes = [] as any;
                for (let item of _data["subscribedEventTypes"])
                    this.subscribedEventTypes!.push(item);
            }
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): OutboundEventIntegrationConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutboundEventIntegrationConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        if (this.credentials) {
            data["credentials"] = {};
            for (let key in this.credentials) {
                if (this.credentials.hasOwnProperty(key))
                    (data["credentials"] as any)[key] = (this.credentials as any)[key];
            }
        }
        if (Array.isArray(this.subscribedEventTypes)) {
            data["subscribedEventTypes"] = [];
            for (let item of this.subscribedEventTypes)
                data["subscribedEventTypes"].push(item);
        }
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IOutboundEventIntegrationConfigDto {
    provider?: OutboundEventProvider | undefined;
    credentials?: { [key: string]: string; } | undefined;
    subscribedEventTypes?: OutboundEvents[] | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export enum OutboundEventProvider {
    None = "None",
    Segment = "Segment",
    Webhook = "Webhook",
}

export enum OutboundEvents {
    CardReceived = "CardReceived",
    CardGiven = "CardGiven",
    FirstConsumption = "FirstConsumption",
    AnyConsumption = "AnyConsumption",
    AnyConsumptionGiven = "AnyConsumptionGiven",
    ScanReceipt = "ScanReceipt",
    ReceiptTriaged = "ReceiptTriaged",
    ReceiptFraud = "ReceiptFraud",
    ReceiptIncomplete = "ReceiptIncomplete",
    ReceiptNoReward = "ReceiptNoReward",
    ReceiptManualReviewLimitExceeded = "ReceiptManualReviewLimitExceeded",
    PunchcardStampsReceived = "PunchcardStampsReceived",
    StampsLimitReached = "StampsLimitReached",
    StampsOverflow = "StampsOverflow",
    PunchcardStepCompleted = "PunchcardStepCompleted",
    PunchcardAlreadyCompleted = "PunchcardAlreadyCompleted",
    ValidateReward = "ValidateReward",
    RewardValidated = "RewardValidated",
    PointsReceived = "PointsReceived",
    NoPointReceived = "NoPointReceived",
    SafeBoxGenerated = "SafeBoxGenerated",
    SafeBoxRead = "SafeBoxRead",
    SafeBoxRedeemed = "SafeBoxRedeemed",
    ManualVerificationRequested = "ManualVerificationRequested",
    ManualVerificationApproved = "ManualVerificationApproved",
    ManualVerificationRejected = "ManualVerificationRejected",
    ConsumerReferralInviteGenerated = "ConsumerReferralInviteGenerated",
    StaffReferralInviteGenerated = "StaffReferralInviteGenerated",
    HandshakeQRValid = "HandshakeQRValid",
    HandshakeQRInvalid = "HandshakeQRInvalid",
    AcquisitionLinkCreated = "AcquisitionLinkCreated",
    AcquisitionShortLinkRequested = "AcquisitionShortLinkRequested",
    AcquisitionLinkRedirected = "AcquisitionLinkRedirected",
    AcquisitionLinkDeleted = "AcquisitionLinkDeleted",
    AdvertiserConsumptionTransaction = "AdvertiserConsumptionTransaction",
    ConsumptionItem = "ConsumptionItem",
    ConsumptionMatchItem = "ConsumptionMatchItem",
    ForcedCheckout = "ForcedCheckout",
    CheercoinsUpdated = "CheercoinsUpdated",
    GLODeviceIDRead = "GLODeviceIDRead",
    GLODeviceIDRedeemed = "GLODeviceIDRedeemed",
    GLODeviceIDInvalid = "GLODeviceIDInvalid",
    RewardCompleted = "RewardCompleted",
}

export enum OutletProperty {
    AdministrativeAreaL1 = "AdministrativeAreaL1",
    AdministrativeAreaL2 = "AdministrativeAreaL2",
}

export class OutletPropertyItem implements IOutletPropertyItem {
    outletProperty?: OutletProperty | undefined;
    value?: string | undefined;

    constructor(data?: IOutletPropertyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outletProperty = _data["outletProperty"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OutletPropertyItem {
        data = typeof data === 'object' ? data : {};
        let result = new OutletPropertyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletProperty"] = this.outletProperty;
        data["value"] = this.value;
        return data;
    }
}

export interface IOutletPropertyItem {
    outletProperty?: OutletProperty | undefined;
    value?: string | undefined;
}

export class PaginatedCampaignResponse implements IPaginatedCampaignResponse {
    items?: CampaignDto[] | undefined;
    totalCount?: number | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    totalPages?: number | undefined;
    hasPreviousPage?: boolean | undefined;
    hasNextPage?: boolean | undefined;

    constructor(data?: IPaginatedCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CampaignDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedCampaignResponse {
    items?: CampaignDto[] | undefined;
    totalCount?: number | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    totalPages?: number | undefined;
    hasPreviousPage?: boolean | undefined;
    hasNextPage?: boolean | undefined;
}

export class Parallel implements IParallel {
    children?: any[] | undefined;
    readonly name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IParallel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(item);
            }
            (this as any).name = _data["name"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): Parallel {
        data = typeof data === 'object' ? data : {};
        let result = new Parallel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item);
        }
        data["name"] = this.name;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IParallel {
    children?: any[] | undefined;
    name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum PeriodUnit {
    Day = "Day",
    Month = "Month",
    Year = "Year",
}

export class PointBaseline implements IPointBaseline {
    isRequired?: boolean | undefined;
    belowThresholdMultiplier?: number | undefined;
    threshold?: number | undefined;
    aboveThresholdMultiplier?: number | undefined;

    constructor(data?: IPointBaseline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRequired = _data["isRequired"];
            this.belowThresholdMultiplier = _data["belowThresholdMultiplier"];
            this.threshold = _data["threshold"];
            this.aboveThresholdMultiplier = _data["aboveThresholdMultiplier"];
        }
    }

    static fromJS(data: any): PointBaseline {
        data = typeof data === 'object' ? data : {};
        let result = new PointBaseline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRequired"] = this.isRequired;
        data["belowThresholdMultiplier"] = this.belowThresholdMultiplier;
        data["threshold"] = this.threshold;
        data["aboveThresholdMultiplier"] = this.aboveThresholdMultiplier;
        return data;
    }
}

export interface IPointBaseline {
    isRequired?: boolean | undefined;
    belowThresholdMultiplier?: number | undefined;
    threshold?: number | undefined;
    aboveThresholdMultiplier?: number | undefined;
}

export class Product implements IProduct {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    advertiserId?: string | undefined;
    image?: string | undefined;
    manufacturer?: ProductManufacturer | undefined;
    skus?: ProductSku[] | undefined;
    isDeleted?: boolean | undefined;
    productSlug?: string | undefined;
    externalProductId?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.advertiserId = _data["advertiserId"];
            this.image = _data["image"];
            this.manufacturer = _data["manufacturer"] ? ProductManufacturer.fromJS(_data["manufacturer"]) : undefined as any;
            if (Array.isArray(_data["skus"])) {
                this.skus = [] as any;
                for (let item of _data["skus"])
                    this.skus!.push(ProductSku.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.productSlug = _data["productSlug"];
            this.externalProductId = _data["externalProductId"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["advertiserId"] = this.advertiserId;
        data["image"] = this.image;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : undefined as any;
        if (Array.isArray(this.skus)) {
            data["skus"] = [];
            for (let item of this.skus)
                data["skus"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["productSlug"] = this.productSlug;
        data["externalProductId"] = this.externalProductId;
        return data;
    }
}

export interface IProduct {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    advertiserId?: string | undefined;
    image?: string | undefined;
    manufacturer?: ProductManufacturer | undefined;
    skus?: ProductSku[] | undefined;
    isDeleted?: boolean | undefined;
    productSlug?: string | undefined;
    externalProductId?: string | undefined;
}

export class ProductInfo implements IProductInfo {
    id?: number | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    price?: number | undefined;
    endDate?: Date | undefined;
    isPopular?: boolean | undefined;
    advertiserId?: string | undefined;
    doNotCreateDummyVoucher?: boolean | undefined;
    metaData?: ProductMeta[] | undefined;

    constructor(data?: IProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoUrl = _data["photoUrl"];
            this.isVoucher = _data["isVoucher"];
            this.price = _data["price"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.isPopular = _data["isPopular"];
            this.advertiserId = _data["advertiserId"];
            this.doNotCreateDummyVoucher = _data["doNotCreateDummyVoucher"];
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(ProductMeta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoUrl"] = this.photoUrl;
        data["isVoucher"] = this.isVoucher;
        data["price"] = this.price;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["isPopular"] = this.isPopular;
        data["advertiserId"] = this.advertiserId;
        data["doNotCreateDummyVoucher"] = this.doNotCreateDummyVoucher;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductInfo {
    id?: number | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    price?: number | undefined;
    endDate?: Date | undefined;
    isPopular?: boolean | undefined;
    advertiserId?: string | undefined;
    doNotCreateDummyVoucher?: boolean | undefined;
    metaData?: ProductMeta[] | undefined;
}

export class ProductManufacturer implements IProductManufacturer {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    country?: string | undefined;

    constructor(data?: IProductManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): ProductManufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new ProductManufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["country"] = this.country;
        return data;
    }
}

export interface IProductManufacturer {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    country?: string | undefined;
}

export class ProductMeta implements IProductMeta {
    id?: number | undefined;
    key?: string | undefined;
    value?: any | undefined;

    constructor(data?: IProductMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IProductMeta {
    id?: number | undefined;
    key?: string | undefined;
    value?: any | undefined;
}

export class ProductReward implements IProductReward {
    productSlug?: string | undefined;
    rewardTitle?: string | undefined;
    rewardPhotoUrl?: string | undefined;
    rewardThumbUrl?: string | undefined;
    rewardDescription?: string | undefined;
    uploadKey?: string | undefined;

    constructor(data?: IProductReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productSlug = _data["productSlug"];
            this.rewardTitle = _data["rewardTitle"];
            this.rewardPhotoUrl = _data["rewardPhotoUrl"];
            this.rewardThumbUrl = _data["rewardThumbUrl"];
            this.rewardDescription = _data["rewardDescription"];
            this.uploadKey = _data["uploadKey"];
        }
    }

    static fromJS(data: any): ProductReward {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSlug"] = this.productSlug;
        data["rewardTitle"] = this.rewardTitle;
        data["rewardPhotoUrl"] = this.rewardPhotoUrl;
        data["rewardThumbUrl"] = this.rewardThumbUrl;
        data["rewardDescription"] = this.rewardDescription;
        data["uploadKey"] = this.uploadKey;
        return data;
    }
}

export interface IProductReward {
    productSlug?: string | undefined;
    rewardTitle?: string | undefined;
    rewardPhotoUrl?: string | undefined;
    rewardThumbUrl?: string | undefined;
    rewardDescription?: string | undefined;
    uploadKey?: string | undefined;
}

export class ProductRuleDetailStrategy implements IProductRuleDetailStrategy {
    productId?: string | undefined;
    productName?: string | undefined;
    skuConsumptionFilters?: ConsumptionFilterStrategy[] | undefined;

    constructor(data?: IProductRuleDetailStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["skuConsumptionFilters"])) {
                this.skuConsumptionFilters = [] as any;
                for (let item of _data["skuConsumptionFilters"])
                    this.skuConsumptionFilters!.push(ConsumptionFilterStrategy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductRuleDetailStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRuleDetailStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        if (Array.isArray(this.skuConsumptionFilters)) {
            data["skuConsumptionFilters"] = [];
            for (let item of this.skuConsumptionFilters)
                data["skuConsumptionFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductRuleDetailStrategy {
    productId?: string | undefined;
    productName?: string | undefined;
    skuConsumptionFilters?: ConsumptionFilterStrategy[] | undefined;
}

export class ProductRuleStrategy implements IProductRuleStrategy {
    products?: ProductRuleDetailStrategy[] | undefined;
    score?: number | undefined;

    constructor(data?: IProductRuleStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductRuleDetailStrategy.fromJS(item));
            }
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): ProductRuleStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRuleStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["score"] = this.score;
        return data;
    }
}

export interface IProductRuleStrategy {
    products?: ProductRuleDetailStrategy[] | undefined;
    score?: number | undefined;
}

export class ProductSku implements IProductSku {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    advertiserId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    consumptionValidationTools?: ConsumptionValidationTool[] | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IProductSku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.advertiserId = _data["advertiserId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["consumptionValidationTools"])) {
                this.consumptionValidationTools = [] as any;
                for (let item of _data["consumptionValidationTools"])
                    this.consumptionValidationTools!.push(ConsumptionValidationTool.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProductSku {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSku();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["advertiserId"] = this.advertiserId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        if (Array.isArray(this.consumptionValidationTools)) {
            data["consumptionValidationTools"] = [];
            for (let item of this.consumptionValidationTools)
                data["consumptionValidationTools"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IProductSku {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    advertiserId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    consumptionValidationTools?: ConsumptionValidationTool[] | undefined;
    isDeleted?: boolean | undefined;
}

export class ProfileFieldConfiguration implements IProfileFieldConfiguration {
    firstName?: ProfileFieldSettings | undefined;
    lastName?: ProfileFieldSettings | undefined;
    email?: ProfileFieldSettings | undefined;
    gender?: ProfileFieldSettings | undefined;
    dateOfBirth?: DateOfBirthFieldSettings | undefined;

    constructor(data?: IProfileFieldConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] ? ProfileFieldSettings.fromJS(_data["firstName"]) : undefined as any;
            this.lastName = _data["lastName"] ? ProfileFieldSettings.fromJS(_data["lastName"]) : undefined as any;
            this.email = _data["email"] ? ProfileFieldSettings.fromJS(_data["email"]) : undefined as any;
            this.gender = _data["gender"] ? ProfileFieldSettings.fromJS(_data["gender"]) : undefined as any;
            this.dateOfBirth = _data["dateOfBirth"] ? DateOfBirthFieldSettings.fromJS(_data["dateOfBirth"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileFieldConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFieldConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName ? this.firstName.toJSON() : undefined as any;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["gender"] = this.gender ? this.gender.toJSON() : undefined as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileFieldConfiguration {
    firstName?: ProfileFieldSettings | undefined;
    lastName?: ProfileFieldSettings | undefined;
    email?: ProfileFieldSettings | undefined;
    gender?: ProfileFieldSettings | undefined;
    dateOfBirth?: DateOfBirthFieldSettings | undefined;
}

export class ProfileFieldSettings implements IProfileFieldSettings {
    isVisible?: boolean | undefined;
    isRequired?: boolean | undefined;

    constructor(data?: IProfileFieldSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): ProfileFieldSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFieldSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IProfileFieldSettings {
    isVisible?: boolean | undefined;
    isRequired?: boolean | undefined;
}

export class PunchCardFlow implements IPunchCardFlow {
    steps?: PunchCardStep[] | undefined;
    readonly name?: string | undefined;
    currentExecutingIndex?: number | undefined;
    currentStep?: PunchCardStep | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IPunchCardFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(PunchCardStep.fromJS(item));
            }
            (this as any).name = _data["name"];
            this.currentExecutingIndex = _data["currentExecutingIndex"];
            this.currentStep = _data["currentStep"] ? PunchCardStep.fromJS(_data["currentStep"]) : undefined as any;
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): PunchCardFlow {
        data = typeof data === 'object' ? data : {};
        let result = new PunchCardFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["currentExecutingIndex"] = this.currentExecutingIndex;
        data["currentStep"] = this.currentStep ? this.currentStep.toJSON() : undefined as any;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IPunchCardFlow {
    steps?: PunchCardStep[] | undefined;
    name?: string | undefined;
    currentExecutingIndex?: number | undefined;
    currentStep?: PunchCardStep | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum PunchCardReceiptToolType {
    None = "None",
    UniqueSafebox = "UniqueSafebox",
    OCR = "OCR",
    FiscalQRSephaz = "FiscalQRSephaz",
    SecretCode = "SecretCode",
    UniqueQRCode = "UniqueQRCode",
    GLOIntegration = "GLOIntegration",
    External = "External",
    AdvertiserCampaign = "AdvertiserCampaign",
    HandshakeQR = "HandshakeQR",
}

export class PunchCardSchema implements IPunchCardSchema {
    id?: string | undefined;
    campaignId?: string | undefined;
    name?: string | undefined;
    scorePerChance?: number | undefined;
    maxChancesPerConsumptionEvent?: number | undefined;
    secondsBetweenChances?: number | undefined;
    timeLimit?: TimeLimitRule | undefined;
    consumptionLimit?: ConsumptionLimitRule | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    productRules?: ProductRuleStrategy[] | undefined;
    periodDurationQrCode?: string | undefined;
    distanceAllowed?: number | undefined;
    senderPoints?: number | undefined;
    receiverPoints?: number | undefined;
    senderPointsLimit?: number | undefined;
    senderPointsInterval?: string | undefined;
    receiverPointsLimit?: number | undefined;
    receiverPointsInterval?: string | undefined;
    maxQrGenerationsLimit?: number | undefined;
    qrGenerationInterval?: string | undefined;
    maxScannerLimit?: number | undefined;
    scannerInterval?: string | undefined;
    enableQrDuration?: boolean | undefined;
    enableDistanceLimit?: boolean | undefined;

    constructor(data?: IPunchCardSchema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campaignId = _data["campaignId"];
            this.name = _data["name"];
            this.scorePerChance = _data["scorePerChance"];
            this.maxChancesPerConsumptionEvent = _data["maxChancesPerConsumptionEvent"];
            this.secondsBetweenChances = _data["secondsBetweenChances"];
            this.timeLimit = _data["timeLimit"] ? TimeLimitRule.fromJS(_data["timeLimit"]) : undefined as any;
            this.consumptionLimit = _data["consumptionLimit"] ? ConsumptionLimitRule.fromJS(_data["consumptionLimit"]) : undefined as any;
            if (Array.isArray(_data["consumptionFilters"])) {
                this.consumptionFilters = [] as any;
                for (let item of _data["consumptionFilters"])
                    this.consumptionFilters!.push(ConsumptionFilterStrategy.fromJS(item));
            }
            if (Array.isArray(_data["productRules"])) {
                this.productRules = [] as any;
                for (let item of _data["productRules"])
                    this.productRules!.push(ProductRuleStrategy.fromJS(item));
            }
            this.periodDurationQrCode = _data["periodDurationQrCode"];
            this.distanceAllowed = _data["distanceAllowed"];
            this.senderPoints = _data["senderPoints"];
            this.receiverPoints = _data["receiverPoints"];
            this.senderPointsLimit = _data["senderPointsLimit"];
            this.senderPointsInterval = _data["senderPointsInterval"];
            this.receiverPointsLimit = _data["receiverPointsLimit"];
            this.receiverPointsInterval = _data["receiverPointsInterval"];
            this.maxQrGenerationsLimit = _data["maxQrGenerationsLimit"];
            this.qrGenerationInterval = _data["qrGenerationInterval"];
            this.maxScannerLimit = _data["maxScannerLimit"];
            this.scannerInterval = _data["scannerInterval"];
            this.enableQrDuration = _data["enableQrDuration"];
            this.enableDistanceLimit = _data["enableDistanceLimit"];
        }
    }

    static fromJS(data: any): PunchCardSchema {
        data = typeof data === 'object' ? data : {};
        let result = new PunchCardSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campaignId"] = this.campaignId;
        data["name"] = this.name;
        data["scorePerChance"] = this.scorePerChance;
        data["maxChancesPerConsumptionEvent"] = this.maxChancesPerConsumptionEvent;
        data["secondsBetweenChances"] = this.secondsBetweenChances;
        data["timeLimit"] = this.timeLimit ? this.timeLimit.toJSON() : undefined as any;
        data["consumptionLimit"] = this.consumptionLimit ? this.consumptionLimit.toJSON() : undefined as any;
        if (Array.isArray(this.consumptionFilters)) {
            data["consumptionFilters"] = [];
            for (let item of this.consumptionFilters)
                data["consumptionFilters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productRules)) {
            data["productRules"] = [];
            for (let item of this.productRules)
                data["productRules"].push(item ? item.toJSON() : undefined as any);
        }
        data["periodDurationQrCode"] = this.periodDurationQrCode;
        data["distanceAllowed"] = this.distanceAllowed;
        data["senderPoints"] = this.senderPoints;
        data["receiverPoints"] = this.receiverPoints;
        data["senderPointsLimit"] = this.senderPointsLimit;
        data["senderPointsInterval"] = this.senderPointsInterval;
        data["receiverPointsLimit"] = this.receiverPointsLimit;
        data["receiverPointsInterval"] = this.receiverPointsInterval;
        data["maxQrGenerationsLimit"] = this.maxQrGenerationsLimit;
        data["qrGenerationInterval"] = this.qrGenerationInterval;
        data["maxScannerLimit"] = this.maxScannerLimit;
        data["scannerInterval"] = this.scannerInterval;
        data["enableQrDuration"] = this.enableQrDuration;
        data["enableDistanceLimit"] = this.enableDistanceLimit;
        return data;
    }
}

export interface IPunchCardSchema {
    id?: string | undefined;
    campaignId?: string | undefined;
    name?: string | undefined;
    scorePerChance?: number | undefined;
    maxChancesPerConsumptionEvent?: number | undefined;
    secondsBetweenChances?: number | undefined;
    timeLimit?: TimeLimitRule | undefined;
    consumptionLimit?: ConsumptionLimitRule | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    productRules?: ProductRuleStrategy[] | undefined;
    periodDurationQrCode?: string | undefined;
    distanceAllowed?: number | undefined;
    senderPoints?: number | undefined;
    receiverPoints?: number | undefined;
    senderPointsLimit?: number | undefined;
    senderPointsInterval?: string | undefined;
    receiverPointsLimit?: number | undefined;
    receiverPointsInterval?: string | undefined;
    maxQrGenerationsLimit?: number | undefined;
    qrGenerationInterval?: string | undefined;
    maxScannerLimit?: number | undefined;
    scannerInterval?: string | undefined;
    enableQrDuration?: boolean | undefined;
    enableDistanceLimit?: boolean | undefined;
}

export class PunchCardStep implements IPunchCardStep {
    readonly name?: string | undefined;
    stampCount?: number | undefined;
    maxStampCount?: number | undefined;
    completeReward?: RewardData | undefined;
    levelUnlockReward?: RewardData | undefined;
    levelUnlockRewarded?: boolean | undefined;
    title?: string | undefined;
    schemaId?: string | undefined;
    photoBannerUrl?: string | undefined;
    photoBannerUploadKey?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IPunchCardStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.stampCount = _data["stampCount"];
            this.maxStampCount = _data["maxStampCount"];
            this.completeReward = _data["completeReward"] ? RewardData.fromJS(_data["completeReward"]) : undefined as any;
            this.levelUnlockReward = _data["levelUnlockReward"] ? RewardData.fromJS(_data["levelUnlockReward"]) : undefined as any;
            this.levelUnlockRewarded = _data["levelUnlockRewarded"];
            this.title = _data["title"];
            this.schemaId = _data["schemaId"];
            this.photoBannerUrl = _data["photoBannerUrl"];
            this.photoBannerUploadKey = _data["photoBannerUploadKey"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): PunchCardStep {
        data = typeof data === 'object' ? data : {};
        let result = new PunchCardStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stampCount"] = this.stampCount;
        data["maxStampCount"] = this.maxStampCount;
        data["completeReward"] = this.completeReward ? this.completeReward.toJSON() : undefined as any;
        data["levelUnlockReward"] = this.levelUnlockReward ? this.levelUnlockReward.toJSON() : undefined as any;
        data["levelUnlockRewarded"] = this.levelUnlockRewarded;
        data["title"] = this.title;
        data["schemaId"] = this.schemaId;
        data["photoBannerUrl"] = this.photoBannerUrl;
        data["photoBannerUploadKey"] = this.photoBannerUploadKey;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IPunchCardStep {
    name?: string | undefined;
    stampCount?: number | undefined;
    maxStampCount?: number | undefined;
    completeReward?: RewardData | undefined;
    levelUnlockReward?: RewardData | undefined;
    levelUnlockRewarded?: boolean | undefined;
    title?: string | undefined;
    schemaId?: string | undefined;
    photoBannerUrl?: string | undefined;
    photoBannerUploadKey?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class PunchCardStrategy implements IPunchCardStrategy {
    readonly name?: string | undefined;
    productSlug?: string | undefined;
    rewardTitle?: string | undefined;
    rewardPhotoUrl?: string | undefined;
    rewardThumbUrl?: string | undefined;
    rewardDescription?: string | undefined;
    stampCount?: number | undefined;
    allStampReceived?: number | undefined;
    initialStampCount?: number | undefined;
    maxStampCount?: number | undefined;
    timeLimit?: TimeLimitRule | undefined;
    consumptionLimit?: ConsumptionLimitRule | undefined;
    rewardsReceivedCount?: number | undefined;
    canReuseCode?: boolean | undefined;
    joinReward?: RewardData | undefined;
    firstConsumptionReward?: RewardData | undefined;
    consumptionReward?: RewardData | undefined;
    birthdayReward?: RewardData | undefined;
    firstConsumptionRewarded?: boolean | undefined;
    schemes?: PunchCardSchema[] | undefined;
    isDelivery?: boolean | undefined;
    flow?: PunchCardFlow | undefined;
    initialRewardStampGiven?: number | undefined;
    initialRewardPointGiven?: number | undefined;
    strategyType?: PunchCardStrategyType | undefined;
    points?: number | undefined;
    milestone?: number | undefined;
    secretCodeGuildlineVisuals?: SecretCodeGuildlineVisual[] | undefined;
    allowScanning?: boolean | undefined;
    receiptCheck?: ReceiptCheckOptions | undefined;
    receiptLocationCheck?: ReceiptLocationCheckOptions | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    fingerprintRegex?: string | undefined;
    secondsBetweenChances?: number | undefined;
    allowDuplicates?: boolean | undefined;
    receiptManualVerification?: boolean | undefined;
    gloOrderSync?: boolean | undefined;
    lastChanceGivenTime?: Date | undefined;
    scorePerChance?: number | undefined;
    maxChancesPerConsumptionEvent?: number | undefined;
    isUnderReview?: boolean | undefined;
    receiptToolTypeId?: PunchCardReceiptToolType | undefined;
    calculationBaseType?: CalculationBasedType | undefined;
    currencyCode?: string | undefined;
    readonly isMultipleCaptureToolEnabled?: boolean | undefined;
    receiptToolTypeIds?: PunchCardReceiptToolType[] | undefined;
    previousStamp?: number | undefined;
    receiptManualValidationRule?: ReceiptManualValidationRule | undefined;
    readonly isFinished?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IPunchCardStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.productSlug = _data["productSlug"];
            this.rewardTitle = _data["rewardTitle"];
            this.rewardPhotoUrl = _data["rewardPhotoUrl"];
            this.rewardThumbUrl = _data["rewardThumbUrl"];
            this.rewardDescription = _data["rewardDescription"];
            this.stampCount = _data["stampCount"];
            this.allStampReceived = _data["allStampReceived"];
            this.initialStampCount = _data["initialStampCount"];
            this.maxStampCount = _data["maxStampCount"];
            this.timeLimit = _data["timeLimit"] ? TimeLimitRule.fromJS(_data["timeLimit"]) : undefined as any;
            this.consumptionLimit = _data["consumptionLimit"] ? ConsumptionLimitRule.fromJS(_data["consumptionLimit"]) : undefined as any;
            this.rewardsReceivedCount = _data["rewardsReceivedCount"];
            this.canReuseCode = _data["canReuseCode"];
            this.joinReward = _data["joinReward"] ? RewardData.fromJS(_data["joinReward"]) : undefined as any;
            this.firstConsumptionReward = _data["firstConsumptionReward"] ? RewardData.fromJS(_data["firstConsumptionReward"]) : undefined as any;
            this.consumptionReward = _data["consumptionReward"] ? RewardData.fromJS(_data["consumptionReward"]) : undefined as any;
            this.birthdayReward = _data["birthdayReward"] ? RewardData.fromJS(_data["birthdayReward"]) : undefined as any;
            this.firstConsumptionRewarded = _data["firstConsumptionRewarded"];
            if (Array.isArray(_data["schemes"])) {
                this.schemes = [] as any;
                for (let item of _data["schemes"])
                    this.schemes!.push(PunchCardSchema.fromJS(item));
            }
            this.isDelivery = _data["isDelivery"];
            this.flow = _data["flow"] ? PunchCardFlow.fromJS(_data["flow"]) : undefined as any;
            this.initialRewardStampGiven = _data["initialRewardStampGiven"];
            this.initialRewardPointGiven = _data["initialRewardPointGiven"];
            this.strategyType = _data["strategyType"];
            this.points = _data["points"];
            this.milestone = _data["milestone"];
            if (Array.isArray(_data["secretCodeGuildlineVisuals"])) {
                this.secretCodeGuildlineVisuals = [] as any;
                for (let item of _data["secretCodeGuildlineVisuals"])
                    this.secretCodeGuildlineVisuals!.push(SecretCodeGuildlineVisual.fromJS(item));
            }
            this.allowScanning = _data["allowScanning"];
            this.receiptCheck = _data["receiptCheck"] ? ReceiptCheckOptions.fromJS(_data["receiptCheck"]) : undefined as any;
            this.receiptLocationCheck = _data["receiptLocationCheck"] ? ReceiptLocationCheckOptions.fromJS(_data["receiptLocationCheck"]) : undefined as any;
            if (Array.isArray(_data["consumptionFilters"])) {
                this.consumptionFilters = [] as any;
                for (let item of _data["consumptionFilters"])
                    this.consumptionFilters!.push(ConsumptionFilterStrategy.fromJS(item));
            }
            this.fingerprintRegex = _data["fingerprintRegex"];
            this.secondsBetweenChances = _data["secondsBetweenChances"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.receiptManualVerification = _data["receiptManualVerification"];
            this.gloOrderSync = _data["gloOrderSync"];
            this.lastChanceGivenTime = _data["lastChanceGivenTime"] ? new Date(_data["lastChanceGivenTime"].toString()) : undefined as any;
            this.scorePerChance = _data["scorePerChance"];
            this.maxChancesPerConsumptionEvent = _data["maxChancesPerConsumptionEvent"];
            this.isUnderReview = _data["isUnderReview"];
            this.receiptToolTypeId = _data["receiptToolTypeId"];
            this.calculationBaseType = _data["calculationBaseType"];
            this.currencyCode = _data["currencyCode"];
            (this as any).isMultipleCaptureToolEnabled = _data["isMultipleCaptureToolEnabled"];
            if (Array.isArray(_data["receiptToolTypeIds"])) {
                this.receiptToolTypeIds = [] as any;
                for (let item of _data["receiptToolTypeIds"])
                    this.receiptToolTypeIds!.push(item);
            }
            this.previousStamp = _data["previousStamp"];
            this.receiptManualValidationRule = _data["receiptManualValidationRule"] ? ReceiptManualValidationRule.fromJS(_data["receiptManualValidationRule"]) : undefined as any;
            (this as any).isFinished = _data["isFinished"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): PunchCardStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new PunchCardStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productSlug"] = this.productSlug;
        data["rewardTitle"] = this.rewardTitle;
        data["rewardPhotoUrl"] = this.rewardPhotoUrl;
        data["rewardThumbUrl"] = this.rewardThumbUrl;
        data["rewardDescription"] = this.rewardDescription;
        data["stampCount"] = this.stampCount;
        data["allStampReceived"] = this.allStampReceived;
        data["initialStampCount"] = this.initialStampCount;
        data["maxStampCount"] = this.maxStampCount;
        data["timeLimit"] = this.timeLimit ? this.timeLimit.toJSON() : undefined as any;
        data["consumptionLimit"] = this.consumptionLimit ? this.consumptionLimit.toJSON() : undefined as any;
        data["rewardsReceivedCount"] = this.rewardsReceivedCount;
        data["canReuseCode"] = this.canReuseCode;
        data["joinReward"] = this.joinReward ? this.joinReward.toJSON() : undefined as any;
        data["firstConsumptionReward"] = this.firstConsumptionReward ? this.firstConsumptionReward.toJSON() : undefined as any;
        data["consumptionReward"] = this.consumptionReward ? this.consumptionReward.toJSON() : undefined as any;
        data["birthdayReward"] = this.birthdayReward ? this.birthdayReward.toJSON() : undefined as any;
        data["firstConsumptionRewarded"] = this.firstConsumptionRewarded;
        if (Array.isArray(this.schemes)) {
            data["schemes"] = [];
            for (let item of this.schemes)
                data["schemes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDelivery"] = this.isDelivery;
        data["flow"] = this.flow ? this.flow.toJSON() : undefined as any;
        data["initialRewardStampGiven"] = this.initialRewardStampGiven;
        data["initialRewardPointGiven"] = this.initialRewardPointGiven;
        data["strategyType"] = this.strategyType;
        data["points"] = this.points;
        data["milestone"] = this.milestone;
        if (Array.isArray(this.secretCodeGuildlineVisuals)) {
            data["secretCodeGuildlineVisuals"] = [];
            for (let item of this.secretCodeGuildlineVisuals)
                data["secretCodeGuildlineVisuals"].push(item ? item.toJSON() : undefined as any);
        }
        data["allowScanning"] = this.allowScanning;
        data["receiptCheck"] = this.receiptCheck ? this.receiptCheck.toJSON() : undefined as any;
        data["receiptLocationCheck"] = this.receiptLocationCheck ? this.receiptLocationCheck.toJSON() : undefined as any;
        if (Array.isArray(this.consumptionFilters)) {
            data["consumptionFilters"] = [];
            for (let item of this.consumptionFilters)
                data["consumptionFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["fingerprintRegex"] = this.fingerprintRegex;
        data["secondsBetweenChances"] = this.secondsBetweenChances;
        data["allowDuplicates"] = this.allowDuplicates;
        data["receiptManualVerification"] = this.receiptManualVerification;
        data["gloOrderSync"] = this.gloOrderSync;
        data["lastChanceGivenTime"] = this.lastChanceGivenTime ? this.lastChanceGivenTime.toISOString() : undefined as any;
        data["scorePerChance"] = this.scorePerChance;
        data["maxChancesPerConsumptionEvent"] = this.maxChancesPerConsumptionEvent;
        data["isUnderReview"] = this.isUnderReview;
        data["receiptToolTypeId"] = this.receiptToolTypeId;
        data["calculationBaseType"] = this.calculationBaseType;
        data["currencyCode"] = this.currencyCode;
        data["isMultipleCaptureToolEnabled"] = this.isMultipleCaptureToolEnabled;
        if (Array.isArray(this.receiptToolTypeIds)) {
            data["receiptToolTypeIds"] = [];
            for (let item of this.receiptToolTypeIds)
                data["receiptToolTypeIds"].push(item);
        }
        data["previousStamp"] = this.previousStamp;
        data["receiptManualValidationRule"] = this.receiptManualValidationRule ? this.receiptManualValidationRule.toJSON() : undefined as any;
        data["isFinished"] = this.isFinished;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IPunchCardStrategy {
    name?: string | undefined;
    productSlug?: string | undefined;
    rewardTitle?: string | undefined;
    rewardPhotoUrl?: string | undefined;
    rewardThumbUrl?: string | undefined;
    rewardDescription?: string | undefined;
    stampCount?: number | undefined;
    allStampReceived?: number | undefined;
    initialStampCount?: number | undefined;
    maxStampCount?: number | undefined;
    timeLimit?: TimeLimitRule | undefined;
    consumptionLimit?: ConsumptionLimitRule | undefined;
    rewardsReceivedCount?: number | undefined;
    canReuseCode?: boolean | undefined;
    joinReward?: RewardData | undefined;
    firstConsumptionReward?: RewardData | undefined;
    consumptionReward?: RewardData | undefined;
    birthdayReward?: RewardData | undefined;
    firstConsumptionRewarded?: boolean | undefined;
    schemes?: PunchCardSchema[] | undefined;
    isDelivery?: boolean | undefined;
    flow?: PunchCardFlow | undefined;
    initialRewardStampGiven?: number | undefined;
    initialRewardPointGiven?: number | undefined;
    strategyType?: PunchCardStrategyType | undefined;
    points?: number | undefined;
    milestone?: number | undefined;
    secretCodeGuildlineVisuals?: SecretCodeGuildlineVisual[] | undefined;
    allowScanning?: boolean | undefined;
    receiptCheck?: ReceiptCheckOptions | undefined;
    receiptLocationCheck?: ReceiptLocationCheckOptions | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    fingerprintRegex?: string | undefined;
    secondsBetweenChances?: number | undefined;
    allowDuplicates?: boolean | undefined;
    receiptManualVerification?: boolean | undefined;
    gloOrderSync?: boolean | undefined;
    lastChanceGivenTime?: Date | undefined;
    scorePerChance?: number | undefined;
    maxChancesPerConsumptionEvent?: number | undefined;
    isUnderReview?: boolean | undefined;
    receiptToolTypeId?: PunchCardReceiptToolType | undefined;
    calculationBaseType?: CalculationBasedType | undefined;
    currencyCode?: string | undefined;
    isMultipleCaptureToolEnabled?: boolean | undefined;
    receiptToolTypeIds?: PunchCardReceiptToolType[] | undefined;
    previousStamp?: number | undefined;
    receiptManualValidationRule?: ReceiptManualValidationRule | undefined;
    isFinished?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum PunchCardStrategyType {
    Stamps = "Stamps",
    Points = "Points",
}

export class Receipt implements IReceipt {
    id?: string | undefined;
    advertiserId?: string | undefined;
    invoiceDate?: Date | undefined;
    createDate?: Date | undefined;
    modifyDate?: Date | undefined;
    userId?: string | undefined;
    userPhoneNo?: string | undefined;
    cardId?: string | undefined;
    campaignId?: string | undefined;
    campaignName?: string | undefined;
    campaignType?: string | undefined;
    invoiceNumber?: string | undefined;
    referenceNumber?: string | undefined;
    fingerprint?: string | undefined;
    accountNumber?: string | undefined;
    cardNumber?: string | undefined;
    currencyCode?: string | undefined;
    paymentType?: string | undefined;
    tax?: number | undefined;
    subTotal?: number | undefined;
    total?: number | undefined;
    isDuplicate?: boolean | undefined;
    incomplete?: boolean | undefined;
    ocrText?: string | undefined;
    rawJson?: string | undefined;
    receiptUrl?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    vendor?: VendorInfo | undefined;
    lineItems?: LineItem[] | undefined;
    tags?: string[] | undefined;
    duplicateGroup?: string | undefined;
    suspectDuplicateGroup?: string | undefined;
    fraudResult?: ReceiptFraudResult | undefined;
    verifyFingerprint?: string | undefined;
    verifyFingerprintItemsConcatenated?: string | undefined;
    notRecognizable?: boolean | undefined;
    manualAccepted?: boolean | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    username?: string | undefined;
    userMobilePhone?: string | undefined;
    contextCardDocumentVersion?: number | undefined;
    long?: number | undefined;
    lat?: number | undefined;
    email?: string | undefined;
    timeConstraint?: boolean | undefined;
    isNew?: boolean | undefined;
    note?: string | undefined;
    meta?: MetaInfo | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    reprocessingCount?: number | undefined;

    constructor(data?: IReceipt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.advertiserId = _data["advertiserId"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.modifyDate = _data["modifyDate"] ? new Date(_data["modifyDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.userPhoneNo = _data["userPhoneNo"];
            this.cardId = _data["cardId"];
            this.campaignId = _data["campaignId"];
            this.campaignName = _data["campaignName"];
            this.campaignType = _data["campaignType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.fingerprint = _data["fingerprint"];
            this.accountNumber = _data["accountNumber"];
            this.cardNumber = _data["cardNumber"];
            this.currencyCode = _data["currencyCode"];
            this.paymentType = _data["paymentType"];
            this.tax = _data["tax"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.isDuplicate = _data["isDuplicate"];
            this.incomplete = _data["incomplete"];
            this.ocrText = _data["ocrText"];
            this.rawJson = _data["rawJson"];
            this.receiptUrl = _data["receiptUrl"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.vendor = _data["vendor"] ? VendorInfo.fromJS(_data["vendor"]) : undefined as any;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(LineItem.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.duplicateGroup = _data["duplicateGroup"];
            this.suspectDuplicateGroup = _data["suspectDuplicateGroup"];
            this.fraudResult = _data["fraudResult"] ? ReceiptFraudResult.fromJS(_data["fraudResult"]) : undefined as any;
            this.verifyFingerprint = _data["verifyFingerprint"];
            this.verifyFingerprintItemsConcatenated = _data["verifyFingerprintItemsConcatenated"];
            this.notRecognizable = _data["notRecognizable"];
            this.manualAccepted = _data["manualAccepted"];
            this.campaignStartDate = _data["campaignStartDate"] ? new Date(_data["campaignStartDate"].toString()) : undefined as any;
            this.campaignEndDate = _data["campaignEndDate"] ? new Date(_data["campaignEndDate"].toString()) : undefined as any;
            this.username = _data["username"];
            this.userMobilePhone = _data["userMobilePhone"];
            this.contextCardDocumentVersion = _data["contextCardDocumentVersion"];
            this.long = _data["long"];
            this.lat = _data["lat"];
            this.email = _data["email"];
            this.timeConstraint = _data["timeConstraint"];
            this.isNew = _data["isNew"];
            this.note = _data["note"];
            this.meta = _data["meta"] ? MetaInfo.fromJS(_data["meta"]) : undefined as any;
            this.docId = _data["docId"];
            this.ocrDocId = _data["ocrDocId"];
            this.reprocessingCount = _data["reprocessingCount"];
        }
    }

    static fromJS(data: any): Receipt {
        data = typeof data === 'object' ? data : {};
        let result = new Receipt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["advertiserId"] = this.advertiserId;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["modifyDate"] = this.modifyDate ? this.modifyDate.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["userPhoneNo"] = this.userPhoneNo;
        data["cardId"] = this.cardId;
        data["campaignId"] = this.campaignId;
        data["campaignName"] = this.campaignName;
        data["campaignType"] = this.campaignType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["fingerprint"] = this.fingerprint;
        data["accountNumber"] = this.accountNumber;
        data["cardNumber"] = this.cardNumber;
        data["currencyCode"] = this.currencyCode;
        data["paymentType"] = this.paymentType;
        data["tax"] = this.tax;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["isDuplicate"] = this.isDuplicate;
        data["incomplete"] = this.incomplete;
        data["ocrText"] = this.ocrText;
        data["rawJson"] = this.rawJson;
        data["receiptUrl"] = this.receiptUrl;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : undefined as any;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["duplicateGroup"] = this.duplicateGroup;
        data["suspectDuplicateGroup"] = this.suspectDuplicateGroup;
        data["fraudResult"] = this.fraudResult ? this.fraudResult.toJSON() : undefined as any;
        data["verifyFingerprint"] = this.verifyFingerprint;
        data["verifyFingerprintItemsConcatenated"] = this.verifyFingerprintItemsConcatenated;
        data["notRecognizable"] = this.notRecognizable;
        data["manualAccepted"] = this.manualAccepted;
        data["campaignStartDate"] = this.campaignStartDate ? this.campaignStartDate.toISOString() : undefined as any;
        data["campaignEndDate"] = this.campaignEndDate ? this.campaignEndDate.toISOString() : undefined as any;
        data["username"] = this.username;
        data["userMobilePhone"] = this.userMobilePhone;
        data["contextCardDocumentVersion"] = this.contextCardDocumentVersion;
        data["long"] = this.long;
        data["lat"] = this.lat;
        data["email"] = this.email;
        data["timeConstraint"] = this.timeConstraint;
        data["isNew"] = this.isNew;
        data["note"] = this.note;
        data["meta"] = this.meta ? this.meta.toJSON() : undefined as any;
        data["docId"] = this.docId;
        data["ocrDocId"] = this.ocrDocId;
        data["reprocessingCount"] = this.reprocessingCount;
        return data;
    }
}

export interface IReceipt {
    id?: string | undefined;
    advertiserId?: string | undefined;
    invoiceDate?: Date | undefined;
    createDate?: Date | undefined;
    modifyDate?: Date | undefined;
    userId?: string | undefined;
    userPhoneNo?: string | undefined;
    cardId?: string | undefined;
    campaignId?: string | undefined;
    campaignName?: string | undefined;
    campaignType?: string | undefined;
    invoiceNumber?: string | undefined;
    referenceNumber?: string | undefined;
    fingerprint?: string | undefined;
    accountNumber?: string | undefined;
    cardNumber?: string | undefined;
    currencyCode?: string | undefined;
    paymentType?: string | undefined;
    tax?: number | undefined;
    subTotal?: number | undefined;
    total?: number | undefined;
    isDuplicate?: boolean | undefined;
    incomplete?: boolean | undefined;
    ocrText?: string | undefined;
    rawJson?: string | undefined;
    receiptUrl?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    vendor?: VendorInfo | undefined;
    lineItems?: LineItem[] | undefined;
    tags?: string[] | undefined;
    duplicateGroup?: string | undefined;
    suspectDuplicateGroup?: string | undefined;
    fraudResult?: ReceiptFraudResult | undefined;
    verifyFingerprint?: string | undefined;
    verifyFingerprintItemsConcatenated?: string | undefined;
    notRecognizable?: boolean | undefined;
    manualAccepted?: boolean | undefined;
    campaignStartDate?: Date | undefined;
    campaignEndDate?: Date | undefined;
    username?: string | undefined;
    userMobilePhone?: string | undefined;
    contextCardDocumentVersion?: number | undefined;
    long?: number | undefined;
    lat?: number | undefined;
    email?: string | undefined;
    timeConstraint?: boolean | undefined;
    isNew?: boolean | undefined;
    note?: string | undefined;
    meta?: MetaInfo | undefined;
    docId?: string | undefined;
    ocrDocId?: string | undefined;
    reprocessingCount?: number | undefined;
}

export class ReceiptCheckOptions implements IReceiptCheckOptions {
    rules?: number[] | undefined;

    constructor(data?: IReceiptCheckOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(item);
            }
        }
    }

    static fromJS(data: any): ReceiptCheckOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptCheckOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item);
        }
        return data;
    }
}

export interface IReceiptCheckOptions {
    rules?: number[] | undefined;
}

export class ReceiptCode implements IReceiptCode {
    id?: string | undefined;
    customerCode?: string | undefined;
    transactionDateTime?: string | undefined;
    invoiceNumber?: string | undefined;
    totalQuantity?: number | undefined;
    crc?: string | undefined;
    receiptDate?: Date | undefined;
    userId?: string | undefined;
    campaignId?: string | undefined;
    cardId?: string | undefined;
    scanDate?: Date | undefined;
    errorMessage?: string | undefined;
    receipt?: Receipt | undefined;

    constructor(data?: IReceiptCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerCode = _data["customerCode"];
            this.transactionDateTime = _data["transactionDateTime"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalQuantity = _data["totalQuantity"];
            this.crc = _data["crc"];
            this.receiptDate = _data["receiptDate"] ? new Date(_data["receiptDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.campaignId = _data["campaignId"];
            this.cardId = _data["cardId"];
            this.scanDate = _data["scanDate"] ? new Date(_data["scanDate"].toString()) : undefined as any;
            this.errorMessage = _data["errorMessage"];
            this.receipt = _data["receipt"] ? Receipt.fromJS(_data["receipt"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReceiptCode {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerCode"] = this.customerCode;
        data["transactionDateTime"] = this.transactionDateTime;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalQuantity"] = this.totalQuantity;
        data["crc"] = this.crc;
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["campaignId"] = this.campaignId;
        data["cardId"] = this.cardId;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : undefined as any;
        data["errorMessage"] = this.errorMessage;
        data["receipt"] = this.receipt ? this.receipt.toJSON() : undefined as any;
        return data;
    }
}

export interface IReceiptCode {
    id?: string | undefined;
    customerCode?: string | undefined;
    transactionDateTime?: string | undefined;
    invoiceNumber?: string | undefined;
    totalQuantity?: number | undefined;
    crc?: string | undefined;
    receiptDate?: Date | undefined;
    userId?: string | undefined;
    campaignId?: string | undefined;
    cardId?: string | undefined;
    scanDate?: Date | undefined;
    errorMessage?: string | undefined;
    receipt?: Receipt | undefined;
}

export class ReceiptCodeQuery implements IReceiptCodeQuery {
    scanDateGreaterThan?: Date | undefined;
    scanDateLessThan?: Date | undefined;
    receiptDateGreaterThan?: Date | undefined;
    receiptDateLessThan?: Date | undefined;
    id?: string | undefined;
    invoiceNumber?: string | undefined;
    transactionDateTime?: string | undefined;
    customerCode?: string | undefined;
    userId?: string | undefined;
    campaignId?: string | undefined;
    cardId?: string | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;

    constructor(data?: IReceiptCodeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scanDateGreaterThan = _data["scanDateGreaterThan"] ? new Date(_data["scanDateGreaterThan"].toString()) : undefined as any;
            this.scanDateLessThan = _data["scanDateLessThan"] ? new Date(_data["scanDateLessThan"].toString()) : undefined as any;
            this.receiptDateGreaterThan = _data["receiptDateGreaterThan"] ? new Date(_data["receiptDateGreaterThan"].toString()) : undefined as any;
            this.receiptDateLessThan = _data["receiptDateLessThan"] ? new Date(_data["receiptDateLessThan"].toString()) : undefined as any;
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.transactionDateTime = _data["transactionDateTime"];
            this.customerCode = _data["customerCode"];
            this.userId = _data["userId"];
            this.campaignId = _data["campaignId"];
            this.cardId = _data["cardId"];
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
        }
    }

    static fromJS(data: any): ReceiptCodeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptCodeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scanDateGreaterThan"] = this.scanDateGreaterThan ? this.scanDateGreaterThan.toISOString() : undefined as any;
        data["scanDateLessThan"] = this.scanDateLessThan ? this.scanDateLessThan.toISOString() : undefined as any;
        data["receiptDateGreaterThan"] = this.receiptDateGreaterThan ? this.receiptDateGreaterThan.toISOString() : undefined as any;
        data["receiptDateLessThan"] = this.receiptDateLessThan ? this.receiptDateLessThan.toISOString() : undefined as any;
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["transactionDateTime"] = this.transactionDateTime;
        data["customerCode"] = this.customerCode;
        data["userId"] = this.userId;
        data["campaignId"] = this.campaignId;
        data["cardId"] = this.cardId;
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        return data;
    }
}

export interface IReceiptCodeQuery {
    scanDateGreaterThan?: Date | undefined;
    scanDateLessThan?: Date | undefined;
    receiptDateGreaterThan?: Date | undefined;
    receiptDateLessThan?: Date | undefined;
    id?: string | undefined;
    invoiceNumber?: string | undefined;
    transactionDateTime?: string | undefined;
    customerCode?: string | undefined;
    userId?: string | undefined;
    campaignId?: string | undefined;
    cardId?: string | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
}

export class ReceiptCodeResponse implements IReceiptCodeResponse {
    receiptCodes?: ReceiptCode[] | undefined;
    total?: number | undefined;

    constructor(data?: IReceiptCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["receiptCodes"])) {
                this.receiptCodes = [] as any;
                for (let item of _data["receiptCodes"])
                    this.receiptCodes!.push(ReceiptCode.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ReceiptCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.receiptCodes)) {
            data["receiptCodes"] = [];
            for (let item of this.receiptCodes)
                data["receiptCodes"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IReceiptCodeResponse {
    receiptCodes?: ReceiptCode[] | undefined;
    total?: number | undefined;
}

export class ReceiptDetail implements IReceiptDetail {
    historyChanges?: ReceiptHistoryChange[] | undefined;
    campaign?: Campaign | undefined;
    receipt?: Receipt | undefined;
    userActivity?: UserActivity[] | undefined;

    constructor(data?: IReceiptDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["historyChanges"])) {
                this.historyChanges = [] as any;
                for (let item of _data["historyChanges"])
                    this.historyChanges!.push(ReceiptHistoryChange.fromJS(item));
            }
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : undefined as any;
            this.receipt = _data["receipt"] ? Receipt.fromJS(_data["receipt"]) : undefined as any;
            if (Array.isArray(_data["userActivity"])) {
                this.userActivity = [] as any;
                for (let item of _data["userActivity"])
                    this.userActivity!.push(UserActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiptDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.historyChanges)) {
            data["historyChanges"] = [];
            for (let item of this.historyChanges)
                data["historyChanges"].push(item ? item.toJSON() : undefined as any);
        }
        data["campaign"] = this.campaign ? this.campaign.toJSON() : undefined as any;
        data["receipt"] = this.receipt ? this.receipt.toJSON() : undefined as any;
        if (Array.isArray(this.userActivity)) {
            data["userActivity"] = [];
            for (let item of this.userActivity)
                data["userActivity"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReceiptDetail {
    historyChanges?: ReceiptHistoryChange[] | undefined;
    campaign?: Campaign | undefined;
    receipt?: Receipt | undefined;
    userActivity?: UserActivity[] | undefined;
}

export class ReceiptDetailedInfoResponse implements IReceiptDetailedInfoResponse {
    docId?: string | undefined;
    receiptDetails?: ReceiptDetail[] | undefined;

    constructor(data?: IReceiptDetailedInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            if (Array.isArray(_data["receiptDetails"])) {
                this.receiptDetails = [] as any;
                for (let item of _data["receiptDetails"])
                    this.receiptDetails!.push(ReceiptDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiptDetailedInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDetailedInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        if (Array.isArray(this.receiptDetails)) {
            data["receiptDetails"] = [];
            for (let item of this.receiptDetails)
                data["receiptDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReceiptDetailedInfoResponse {
    docId?: string | undefined;
    receiptDetails?: ReceiptDetail[] | undefined;
}

export class ReceiptFraudResult implements IReceiptFraudResult {
    receiptId?: string | undefined;
    duplicateReceiptId?: string | undefined;
    isDuplicate?: boolean | undefined;
    duplicateSuspectReceipts?: string[] | undefined;
    isDuplicateSuspect?: boolean | undefined;
    duplicateSuspectReceiptId?: string | undefined;
    isSuspectLocation?: boolean | undefined;
    attribution?: string | undefined;
    types?: string[] | undefined;

    constructor(data?: IReceiptFraudResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.duplicateReceiptId = _data["duplicateReceiptId"];
            this.isDuplicate = _data["isDuplicate"];
            if (Array.isArray(_data["duplicateSuspectReceipts"])) {
                this.duplicateSuspectReceipts = [] as any;
                for (let item of _data["duplicateSuspectReceipts"])
                    this.duplicateSuspectReceipts!.push(item);
            }
            this.isDuplicateSuspect = _data["isDuplicateSuspect"];
            this.duplicateSuspectReceiptId = _data["duplicateSuspectReceiptId"];
            this.isSuspectLocation = _data["isSuspectLocation"];
            this.attribution = _data["attribution"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): ReceiptFraudResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptFraudResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["duplicateReceiptId"] = this.duplicateReceiptId;
        data["isDuplicate"] = this.isDuplicate;
        if (Array.isArray(this.duplicateSuspectReceipts)) {
            data["duplicateSuspectReceipts"] = [];
            for (let item of this.duplicateSuspectReceipts)
                data["duplicateSuspectReceipts"].push(item);
        }
        data["isDuplicateSuspect"] = this.isDuplicateSuspect;
        data["duplicateSuspectReceiptId"] = this.duplicateSuspectReceiptId;
        data["isSuspectLocation"] = this.isSuspectLocation;
        data["attribution"] = this.attribution;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IReceiptFraudResult {
    receiptId?: string | undefined;
    duplicateReceiptId?: string | undefined;
    isDuplicate?: boolean | undefined;
    duplicateSuspectReceipts?: string[] | undefined;
    isDuplicateSuspect?: boolean | undefined;
    duplicateSuspectReceiptId?: string | undefined;
    isSuspectLocation?: boolean | undefined;
    attribution?: string | undefined;
    types?: string[] | undefined;
}

export class ReceiptHistoryChange implements IReceiptHistoryChange {
    id?: string | undefined;
    documentId?: string | undefined;
    field?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    date?: string | undefined;
    changedBy?: string | undefined;
    change?: string | undefined;
    metaData?: string | undefined;

    constructor(data?: IReceiptHistoryChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.field = _data["field"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.date = _data["date"];
            this.changedBy = _data["changedBy"];
            this.change = _data["change"];
            this.metaData = _data["metaData"];
        }
    }

    static fromJS(data: any): ReceiptHistoryChange {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptHistoryChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["field"] = this.field;
        data["from"] = this.from;
        data["to"] = this.to;
        data["date"] = this.date;
        data["changedBy"] = this.changedBy;
        data["change"] = this.change;
        data["metaData"] = this.metaData;
        return data;
    }
}

export interface IReceiptHistoryChange {
    id?: string | undefined;
    documentId?: string | undefined;
    field?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    date?: string | undefined;
    changedBy?: string | undefined;
    change?: string | undefined;
    metaData?: string | undefined;
}

export class ReceiptLocationCheckOptions implements IReceiptLocationCheckOptions {
    checkType?: ReceiptLocationCheckType | undefined;
    locationFilter?: CampaignLocationFilter | undefined;

    constructor(data?: IReceiptLocationCheckOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkType = _data["checkType"];
            this.locationFilter = _data["locationFilter"] ? CampaignLocationFilter.fromJS(_data["locationFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReceiptLocationCheckOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptLocationCheckOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkType"] = this.checkType;
        data["locationFilter"] = this.locationFilter ? this.locationFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IReceiptLocationCheckOptions {
    checkType?: ReceiptLocationCheckType | undefined;
    locationFilter?: CampaignLocationFilter | undefined;
}

export enum ReceiptLocationCheckType {
    Include = "Include",
    Exclude = "Exclude",
}

export class ReceiptManualValidationRule implements IReceiptManualValidationRule {
    maxReceipts?: number | undefined;
    windowDays?: number | undefined;
    enabled?: boolean | undefined;

    constructor(data?: IReceiptManualValidationRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxReceipts = _data["maxReceipts"];
            this.windowDays = _data["windowDays"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ReceiptManualValidationRule {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptManualValidationRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxReceipts"] = this.maxReceipts;
        data["windowDays"] = this.windowDays;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IReceiptManualValidationRule {
    maxReceipts?: number | undefined;
    windowDays?: number | undefined;
    enabled?: boolean | undefined;
}

export class ReceiptQuery implements IReceiptQuery {
    invoiceDate?: Date | undefined;
    createDateGreaterThan?: Date | undefined;
    createDateLessThan?: Date | undefined;
    invoiceDateGreaterThan?: Date | undefined;
    invoiceDateLessThan?: Date | undefined;
    id?: string | undefined;
    advertiserId?: string | undefined;
    fingerprint?: string | undefined;
    invoiceNumber?: string | undefined;
    referenceNumber?: string | undefined;
    accountNumber?: string | undefined;
    cardNumber?: string | undefined;
    currencyCode?: string | undefined;
    subTotal?: number | undefined;
    total?: number | undefined;
    vendorRawName?: string | undefined;
    vendorName?: string | undefined;
    userId?: string | undefined;
    userPhoneNo?: string | undefined;
    isDuplicate?: boolean | undefined;
    isDuplicateSuspect?: boolean | undefined;
    suspectDuplicateGroup?: string | undefined;
    cardId?: string | undefined;
    incomplete?: boolean | undefined;
    stages?: string[] | undefined;
    invoiceIds?: string[] | undefined;
    tags?: string[] | undefined;
    campaigns?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    hasMetaData?: boolean | undefined;

    constructor(data?: IReceiptQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.createDateGreaterThan = _data["createDateGreaterThan"] ? new Date(_data["createDateGreaterThan"].toString()) : undefined as any;
            this.createDateLessThan = _data["createDateLessThan"] ? new Date(_data["createDateLessThan"].toString()) : undefined as any;
            this.invoiceDateGreaterThan = _data["invoiceDateGreaterThan"] ? new Date(_data["invoiceDateGreaterThan"].toString()) : undefined as any;
            this.invoiceDateLessThan = _data["invoiceDateLessThan"] ? new Date(_data["invoiceDateLessThan"].toString()) : undefined as any;
            this.id = _data["id"];
            this.advertiserId = _data["advertiserId"];
            this.fingerprint = _data["fingerprint"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.accountNumber = _data["accountNumber"];
            this.cardNumber = _data["cardNumber"];
            this.currencyCode = _data["currencyCode"];
            this.subTotal = _data["subTotal"];
            this.total = _data["total"];
            this.vendorRawName = _data["vendorRawName"];
            this.vendorName = _data["vendorName"];
            this.userId = _data["userId"];
            this.userPhoneNo = _data["userPhoneNo"];
            this.isDuplicate = _data["isDuplicate"];
            this.isDuplicateSuspect = _data["isDuplicateSuspect"];
            this.suspectDuplicateGroup = _data["suspectDuplicateGroup"];
            this.cardId = _data["cardId"];
            this.incomplete = _data["incomplete"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(item);
            }
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(item);
            }
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
            this.hasMetaData = _data["hasMetaData"];
        }
    }

    static fromJS(data: any): ReceiptQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["createDateGreaterThan"] = this.createDateGreaterThan ? this.createDateGreaterThan.toISOString() : undefined as any;
        data["createDateLessThan"] = this.createDateLessThan ? this.createDateLessThan.toISOString() : undefined as any;
        data["invoiceDateGreaterThan"] = this.invoiceDateGreaterThan ? this.invoiceDateGreaterThan.toISOString() : undefined as any;
        data["invoiceDateLessThan"] = this.invoiceDateLessThan ? this.invoiceDateLessThan.toISOString() : undefined as any;
        data["id"] = this.id;
        data["advertiserId"] = this.advertiserId;
        data["fingerprint"] = this.fingerprint;
        data["invoiceNumber"] = this.invoiceNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["accountNumber"] = this.accountNumber;
        data["cardNumber"] = this.cardNumber;
        data["currencyCode"] = this.currencyCode;
        data["subTotal"] = this.subTotal;
        data["total"] = this.total;
        data["vendorRawName"] = this.vendorRawName;
        data["vendorName"] = this.vendorName;
        data["userId"] = this.userId;
        data["userPhoneNo"] = this.userPhoneNo;
        data["isDuplicate"] = this.isDuplicate;
        data["isDuplicateSuspect"] = this.isDuplicateSuspect;
        data["suspectDuplicateGroup"] = this.suspectDuplicateGroup;
        data["cardId"] = this.cardId;
        data["incomplete"] = this.incomplete;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item);
        }
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item);
        }
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        data["hasMetaData"] = this.hasMetaData;
        return data;
    }
}

export interface IReceiptQuery {
    invoiceDate?: Date | undefined;
    createDateGreaterThan?: Date | undefined;
    createDateLessThan?: Date | undefined;
    invoiceDateGreaterThan?: Date | undefined;
    invoiceDateLessThan?: Date | undefined;
    id?: string | undefined;
    advertiserId?: string | undefined;
    fingerprint?: string | undefined;
    invoiceNumber?: string | undefined;
    referenceNumber?: string | undefined;
    accountNumber?: string | undefined;
    cardNumber?: string | undefined;
    currencyCode?: string | undefined;
    subTotal?: number | undefined;
    total?: number | undefined;
    vendorRawName?: string | undefined;
    vendorName?: string | undefined;
    userId?: string | undefined;
    userPhoneNo?: string | undefined;
    isDuplicate?: boolean | undefined;
    isDuplicateSuspect?: boolean | undefined;
    suspectDuplicateGroup?: string | undefined;
    cardId?: string | undefined;
    incomplete?: boolean | undefined;
    stages?: string[] | undefined;
    invoiceIds?: string[] | undefined;
    tags?: string[] | undefined;
    campaigns?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    hasMetaData?: boolean | undefined;
}

export class ReceiptResponse implements IReceiptResponse {
    receipts?: Receipt[] | undefined;
    total?: number | undefined;

    constructor(data?: IReceiptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(Receipt.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ReceiptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IReceiptResponse {
    receipts?: Receipt[] | undefined;
    total?: number | undefined;
}

export class ReceiptScanResult implements IReceiptScanResult {
    consumptionEvent?: EventConsumption | undefined;
    serviceEvent?: EventService | undefined;

    constructor(data?: IReceiptScanResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumptionEvent = _data["consumptionEvent"] ? EventConsumption.fromJS(_data["consumptionEvent"]) : undefined as any;
            this.serviceEvent = _data["serviceEvent"] ? EventService.fromJS(_data["serviceEvent"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReceiptScanResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptScanResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumptionEvent"] = this.consumptionEvent ? this.consumptionEvent.toJSON() : undefined as any;
        data["serviceEvent"] = this.serviceEvent ? this.serviceEvent.toJSON() : undefined as any;
        return data;
    }
}

export interface IReceiptScanResult {
    consumptionEvent?: EventConsumption | undefined;
    serviceEvent?: EventService | undefined;
}

export class ReceiptTriageData implements IReceiptTriageData {
    receiptTags?: string[] | undefined;

    constructor(data?: IReceiptTriageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["receiptTags"])) {
                this.receiptTags = [] as any;
                for (let item of _data["receiptTags"])
                    this.receiptTags!.push(item);
            }
        }
    }

    static fromJS(data: any): ReceiptTriageData {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptTriageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.receiptTags)) {
            data["receiptTags"] = [];
            for (let item of this.receiptTags)
                data["receiptTags"].push(item);
        }
        return data;
    }
}

export interface IReceiptTriageData {
    receiptTags?: string[] | undefined;
}

export class ReceiptTriageError implements IReceiptTriageError {
    rejectReason?: string | undefined;
    rejectType?: RejectTypes | undefined;

    constructor(data?: IReceiptTriageError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rejectReason = _data["rejectReason"];
            this.rejectType = _data["rejectType"];
        }
    }

    static fromJS(data: any): ReceiptTriageError {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptTriageError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rejectReason"] = this.rejectReason;
        data["rejectType"] = this.rejectType;
        return data;
    }
}

export interface IReceiptTriageError {
    rejectReason?: string | undefined;
    rejectType?: RejectTypes | undefined;
}

export class ReceiptTriageResult implements IReceiptTriageResult {
    data?: ReceiptTriageData | undefined;
    error?: ReceiptTriageError | undefined;

    constructor(data?: IReceiptTriageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ReceiptTriageData.fromJS(_data["data"]) : undefined as any;
            this.error = _data["error"] ? ReceiptTriageError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReceiptTriageResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptTriageResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IReceiptTriageResult {
    data?: ReceiptTriageData | undefined;
    error?: ReceiptTriageError | undefined;
}

export class ReferralLinkSettings implements IReferralLinkSettings {
    title?: string | undefined;
    description?: string | undefined;
    thumbnailUrl?: string | undefined;
    message?: string | undefined;

    constructor(data?: IReferralLinkSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReferralLinkSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralLinkSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["message"] = this.message;
        return data;
    }
}

export interface IReferralLinkSettings {
    title?: string | undefined;
    description?: string | undefined;
    thumbnailUrl?: string | undefined;
    message?: string | undefined;
}

export class ReferralStrategy implements IReferralStrategy {
    finished?: boolean | undefined;
    readonly name?: string | undefined;
    allowDuplicates?: boolean | undefined;
    refCampaignId?: string | undefined;
    safeBoxCode?: string | undefined;
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    joinReward?: RewardData | undefined;
    firstConsumptionReward?: RewardData | undefined;
    anyConsumptionReward?: RewardData | undefined;
    totalCoins?: number | undefined;
    totalRewards?: number | undefined;
    totalReferrals?: number | undefined;
    repeatable?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IReferralStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finished = _data["finished"];
            (this as any).name = _data["name"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.refCampaignId = _data["refCampaignId"];
            this.safeBoxCode = _data["safeBoxCode"];
            this.productReward = _data["productReward"] ? ProductReward.fromJS(_data["productReward"]) : undefined as any;
            this.coinReward = _data["coinReward"] ? CoinReward.fromJS(_data["coinReward"]) : undefined as any;
            this.joinReward = _data["joinReward"] ? RewardData.fromJS(_data["joinReward"]) : undefined as any;
            this.firstConsumptionReward = _data["firstConsumptionReward"] ? RewardData.fromJS(_data["firstConsumptionReward"]) : undefined as any;
            this.anyConsumptionReward = _data["anyConsumptionReward"] ? RewardData.fromJS(_data["anyConsumptionReward"]) : undefined as any;
            this.totalCoins = _data["totalCoins"];
            this.totalRewards = _data["totalRewards"];
            this.totalReferrals = _data["totalReferrals"];
            this.repeatable = _data["repeatable"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): ReferralStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finished"] = this.finished;
        data["name"] = this.name;
        data["allowDuplicates"] = this.allowDuplicates;
        data["refCampaignId"] = this.refCampaignId;
        data["safeBoxCode"] = this.safeBoxCode;
        data["productReward"] = this.productReward ? this.productReward.toJSON() : undefined as any;
        data["coinReward"] = this.coinReward ? this.coinReward.toJSON() : undefined as any;
        data["joinReward"] = this.joinReward ? this.joinReward.toJSON() : undefined as any;
        data["firstConsumptionReward"] = this.firstConsumptionReward ? this.firstConsumptionReward.toJSON() : undefined as any;
        data["anyConsumptionReward"] = this.anyConsumptionReward ? this.anyConsumptionReward.toJSON() : undefined as any;
        data["totalCoins"] = this.totalCoins;
        data["totalRewards"] = this.totalRewards;
        data["totalReferrals"] = this.totalReferrals;
        data["repeatable"] = this.repeatable;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IReferralStrategy {
    finished?: boolean | undefined;
    name?: string | undefined;
    allowDuplicates?: boolean | undefined;
    refCampaignId?: string | undefined;
    safeBoxCode?: string | undefined;
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    joinReward?: RewardData | undefined;
    firstConsumptionReward?: RewardData | undefined;
    anyConsumptionReward?: RewardData | undefined;
    totalCoins?: number | undefined;
    totalRewards?: number | undefined;
    totalReferrals?: number | undefined;
    repeatable?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export enum RejectTypes {
    NotRecognizable = "NotRecognizable",
    Incomplete = "Incomplete",
    Duplicated = "Duplicated",
    PunchcardAlreadyCompleted = "PunchcardAlreadyCompleted",
    ReceiptUnderReview = "ReceiptUnderReview",
    TimeLimitReached = "TimeLimitReached",
    ManualReviewLimitExceeded = "ManualReviewLimitExceeded",
    FraudDetection = "FraudDetection",
    DuplicateSuspect = "DuplicateSuspect",
    FraudSuspectLocation = "FraudSuspectLocation",
    TimeConstraintNotValid = "TimeConstraintNotValid",
    EmptyDate = "EmptyDate",
    CurrencyConstraintNotPass = "CurrencyConstraintNotPass",
    RequireManualReview = "RequireManualReview",
}

export class Reward implements IReward {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    readonly name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productReward = _data["productReward"] ? ProductReward.fromJS(_data["productReward"]) : undefined as any;
            this.coinReward = _data["coinReward"] ? CoinReward.fromJS(_data["coinReward"]) : undefined as any;
            (this as any).name = _data["name"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): Reward {
        data = typeof data === 'object' ? data : {};
        let result = new Reward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productReward"] = this.productReward ? this.productReward.toJSON() : undefined as any;
        data["coinReward"] = this.coinReward ? this.coinReward.toJSON() : undefined as any;
        data["name"] = this.name;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IReward {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class RewardChance implements IRewardChance {
    chance?: number | undefined;
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;

    constructor(data?: IRewardChance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chance = _data["chance"];
            this.productReward = _data["productReward"] ? ProductReward.fromJS(_data["productReward"]) : undefined as any;
            this.coinReward = _data["coinReward"] ? CoinReward.fromJS(_data["coinReward"]) : undefined as any;
        }
    }

    static fromJS(data: any): RewardChance {
        data = typeof data === 'object' ? data : {};
        let result = new RewardChance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chance"] = this.chance;
        data["productReward"] = this.productReward ? this.productReward.toJSON() : undefined as any;
        data["coinReward"] = this.coinReward ? this.coinReward.toJSON() : undefined as any;
        return data;
    }
}

export interface IRewardChance {
    chance?: number | undefined;
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
}

export class RewardData implements IRewardData {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    stampReward?: StampReward | undefined;

    constructor(data?: IRewardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productReward = _data["productReward"] ? ProductReward.fromJS(_data["productReward"]) : undefined as any;
            this.coinReward = _data["coinReward"] ? CoinReward.fromJS(_data["coinReward"]) : undefined as any;
            this.stampReward = _data["stampReward"] ? StampReward.fromJS(_data["stampReward"]) : undefined as any;
        }
    }

    static fromJS(data: any): RewardData {
        data = typeof data === 'object' ? data : {};
        let result = new RewardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productReward"] = this.productReward ? this.productReward.toJSON() : undefined as any;
        data["coinReward"] = this.coinReward ? this.coinReward.toJSON() : undefined as any;
        data["stampReward"] = this.stampReward ? this.stampReward.toJSON() : undefined as any;
        return data;
    }
}

export interface IRewardData {
    productReward?: ProductReward | undefined;
    coinReward?: CoinReward | undefined;
    stampReward?: StampReward | undefined;
}

export class RewardInfo implements IRewardInfo {
    orderId?: string | undefined;
    orderKey?: string | undefined;
    redeemDate?: Date | undefined;
    isUsed?: boolean | undefined;
    isOnHold?: boolean | undefined;
    isStaffReward?: boolean | undefined;
    title?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    voucherCode1?: string | undefined;
    voucherCode1Label?: string | undefined;
    voucherCode1UrlText?: string | undefined;
    voucherCode2?: string | undefined;
    voucherCode2Label?: string | undefined;
    voucherCode2UrlText?: string | undefined;
    activityTitle?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    isGame?: boolean | undefined;
    gameUrl?: string | undefined;
    productId?: string | undefined;
    rewardName?: string | undefined;
    campaignId?: string | undefined;
    endDate?: Date | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    organizationLocations?: number | undefined;
    customerId?: string | undefined;
    completedBy?: string | undefined;

    constructor(data?: IRewardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderKey = _data["orderKey"];
            this.redeemDate = _data["redeemDate"] ? new Date(_data["redeemDate"].toString()) : undefined as any;
            this.isUsed = _data["isUsed"];
            this.isOnHold = _data["isOnHold"];
            this.isStaffReward = _data["isStaffReward"];
            this.title = _data["title"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
            this.isVoucher = _data["isVoucher"];
            this.voucherCode1 = _data["voucherCode1"];
            this.voucherCode1Label = _data["voucherCode1Label"];
            this.voucherCode1UrlText = _data["voucherCode1UrlText"];
            this.voucherCode2 = _data["voucherCode2"];
            this.voucherCode2Label = _data["voucherCode2Label"];
            this.voucherCode2UrlText = _data["voucherCode2UrlText"];
            this.activityTitle = _data["activityTitle"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.isGame = _data["isGame"];
            this.gameUrl = _data["gameUrl"];
            this.productId = _data["productId"];
            this.rewardName = _data["rewardName"];
            this.campaignId = _data["campaignId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.advertiserId = _data["advertiserId"];
            this.advertiserName = _data["advertiserName"];
            this.organizationLocations = _data["organizationLocations"];
            this.customerId = _data["customerId"];
            this.completedBy = _data["completedBy"];
        }
    }

    static fromJS(data: any): RewardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RewardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderKey"] = this.orderKey;
        data["redeemDate"] = this.redeemDate ? this.redeemDate.toISOString() : undefined as any;
        data["isUsed"] = this.isUsed;
        data["isOnHold"] = this.isOnHold;
        data["isStaffReward"] = this.isStaffReward;
        data["title"] = this.title;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        data["isVoucher"] = this.isVoucher;
        data["voucherCode1"] = this.voucherCode1;
        data["voucherCode1Label"] = this.voucherCode1Label;
        data["voucherCode1UrlText"] = this.voucherCode1UrlText;
        data["voucherCode2"] = this.voucherCode2;
        data["voucherCode2Label"] = this.voucherCode2Label;
        data["voucherCode2UrlText"] = this.voucherCode2UrlText;
        data["activityTitle"] = this.activityTitle;
        data["description"] = this.description;
        data["price"] = this.price;
        data["isGame"] = this.isGame;
        data["gameUrl"] = this.gameUrl;
        data["productId"] = this.productId;
        data["rewardName"] = this.rewardName;
        data["campaignId"] = this.campaignId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["advertiserId"] = this.advertiserId;
        data["advertiserName"] = this.advertiserName;
        data["organizationLocations"] = this.organizationLocations;
        data["customerId"] = this.customerId;
        data["completedBy"] = this.completedBy;
        return data;
    }
}

export interface IRewardInfo {
    orderId?: string | undefined;
    orderKey?: string | undefined;
    redeemDate?: Date | undefined;
    isUsed?: boolean | undefined;
    isOnHold?: boolean | undefined;
    isStaffReward?: boolean | undefined;
    title?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    isVoucher?: boolean | undefined;
    voucherCode1?: string | undefined;
    voucherCode1Label?: string | undefined;
    voucherCode1UrlText?: string | undefined;
    voucherCode2?: string | undefined;
    voucherCode2Label?: string | undefined;
    voucherCode2UrlText?: string | undefined;
    activityTitle?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    isGame?: boolean | undefined;
    gameUrl?: string | undefined;
    productId?: string | undefined;
    rewardName?: string | undefined;
    campaignId?: string | undefined;
    endDate?: Date | undefined;
    advertiserId?: string | undefined;
    advertiserName?: string | undefined;
    organizationLocations?: number | undefined;
    customerId?: string | undefined;
    completedBy?: string | undefined;
}

export enum RewardReason {
    PunchCardComplete = "PunchCardComplete",
    LuckyDrawChance = "LuckyDrawChance",
    GameReward = "GameReward",
    JoinedCampaign = "JoinedCampaign",
    JoinedStaffCampaign = "JoinedStaffCampaign",
    FirstConsumption = "FirstConsumption",
    ReferralCardGiven = "ReferralCardGiven",
    StaffCampaign = "StaffCampaign",
    MultiCampaign = "MultiCampaign",
    Consumption = "Consumption",
    StampsGiven = "StampsGiven",
    FlowStepComplete = "FlowStepComplete",
    ReferralFirstConsumption = "ReferralFirstConsumption",
    ReferralAnyConsumption = "ReferralAnyConsumption",
    ConsumerReferralJoin = "ConsumerReferralJoin",
    ConsumerReferralFirstConsumption = "ConsumerReferralFirstConsumption",
    ConsumerReferralComplete = "ConsumerReferralComplete",
    Birthday = "Birthday",
    LevelUnlocked = "LevelUnlocked",
    HandshakeCompleted = "HandshakeCompleted",
}

export class SafeBox implements ISafeBox {
    code?: string | undefined;
    meetingToken?: string | undefined;
    card?: Card | undefined;
    campaignReferenceList?: CampaignReference[] | undefined;
    isRedeemed?: boolean | undefined;
    isRead?: boolean | undefined;
    redeemedBy?: string | undefined;
    canReuse?: boolean | undefined;
    simulatedEvents?: any[] | undefined;
    staffId?: string | undefined;
    consumerId?: string | undefined;
    createdAt?: Date | undefined;
    redeemedAt?: Date | undefined;
    campaignReference?: CampaignReference | undefined;
    requiresOnboarding?: boolean | undefined;
    productSkuId?: string | undefined;
    numberOfCharacters?: number | undefined;
    format?: string | undefined;
    tags?: string | undefined;
    status?: string | undefined;
    hasReferralLinkSettings?: boolean | undefined;
    referralLinkSettings?: ReferralLinkSettings | undefined;
    handshakeQrContext?: HandshakeQrContext | undefined;

    constructor(data?: ISafeBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.meetingToken = _data["meetingToken"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            if (Array.isArray(_data["campaignReferenceList"])) {
                this.campaignReferenceList = [] as any;
                for (let item of _data["campaignReferenceList"])
                    this.campaignReferenceList!.push(CampaignReference.fromJS(item));
            }
            this.isRedeemed = _data["isRedeemed"];
            this.isRead = _data["isRead"];
            this.redeemedBy = _data["redeemedBy"];
            this.canReuse = _data["canReuse"];
            if (Array.isArray(_data["simulatedEvents"])) {
                this.simulatedEvents = [] as any;
                for (let item of _data["simulatedEvents"])
                    this.simulatedEvents!.push(item);
            }
            this.staffId = _data["staffId"];
            this.consumerId = _data["consumerId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.redeemedAt = _data["redeemedAt"] ? new Date(_data["redeemedAt"].toString()) : undefined as any;
            this.campaignReference = _data["campaignReference"] ? CampaignReference.fromJS(_data["campaignReference"]) : undefined as any;
            this.requiresOnboarding = _data["requiresOnboarding"];
            this.productSkuId = _data["productSkuId"];
            this.numberOfCharacters = _data["numberOfCharacters"];
            this.format = _data["format"];
            this.tags = _data["tags"];
            this.status = _data["status"];
            this.hasReferralLinkSettings = _data["hasReferralLinkSettings"];
            this.referralLinkSettings = _data["referralLinkSettings"] ? ReferralLinkSettings.fromJS(_data["referralLinkSettings"]) : undefined as any;
            this.handshakeQrContext = _data["handshakeQrContext"] ? HandshakeQrContext.fromJS(_data["handshakeQrContext"]) : undefined as any;
        }
    }

    static fromJS(data: any): SafeBox {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["meetingToken"] = this.meetingToken;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        if (Array.isArray(this.campaignReferenceList)) {
            data["campaignReferenceList"] = [];
            for (let item of this.campaignReferenceList)
                data["campaignReferenceList"].push(item ? item.toJSON() : undefined as any);
        }
        data["isRedeemed"] = this.isRedeemed;
        data["isRead"] = this.isRead;
        data["redeemedBy"] = this.redeemedBy;
        data["canReuse"] = this.canReuse;
        if (Array.isArray(this.simulatedEvents)) {
            data["simulatedEvents"] = [];
            for (let item of this.simulatedEvents)
                data["simulatedEvents"].push(item);
        }
        data["staffId"] = this.staffId;
        data["consumerId"] = this.consumerId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["redeemedAt"] = this.redeemedAt ? this.redeemedAt.toISOString() : undefined as any;
        data["campaignReference"] = this.campaignReference ? this.campaignReference.toJSON() : undefined as any;
        data["requiresOnboarding"] = this.requiresOnboarding;
        data["productSkuId"] = this.productSkuId;
        data["numberOfCharacters"] = this.numberOfCharacters;
        data["format"] = this.format;
        data["tags"] = this.tags;
        data["status"] = this.status;
        data["hasReferralLinkSettings"] = this.hasReferralLinkSettings;
        data["referralLinkSettings"] = this.referralLinkSettings ? this.referralLinkSettings.toJSON() : undefined as any;
        data["handshakeQrContext"] = this.handshakeQrContext ? this.handshakeQrContext.toJSON() : undefined as any;
        return data;
    }
}

export interface ISafeBox {
    code?: string | undefined;
    meetingToken?: string | undefined;
    card?: Card | undefined;
    campaignReferenceList?: CampaignReference[] | undefined;
    isRedeemed?: boolean | undefined;
    isRead?: boolean | undefined;
    redeemedBy?: string | undefined;
    canReuse?: boolean | undefined;
    simulatedEvents?: any[] | undefined;
    staffId?: string | undefined;
    consumerId?: string | undefined;
    createdAt?: Date | undefined;
    redeemedAt?: Date | undefined;
    campaignReference?: CampaignReference | undefined;
    requiresOnboarding?: boolean | undefined;
    productSkuId?: string | undefined;
    numberOfCharacters?: number | undefined;
    format?: string | undefined;
    tags?: string | undefined;
    status?: string | undefined;
    hasReferralLinkSettings?: boolean | undefined;
    referralLinkSettings?: ReferralLinkSettings | undefined;
    handshakeQrContext?: HandshakeQrContext | undefined;
}

export class SafeBoxBatchJobSummaryResponse implements ISafeBoxBatchJobSummaryResponse {
    jobId?: string | undefined;
    jobType?: string | undefined;
    status?: string | undefined;
    totalRows?: number | undefined;
    processedRows?: number | undefined;
    successCount?: number | undefined;
    failedCount?: number | undefined;
    progressPercentage?: number | undefined;
    message?: string | undefined;
    simulationId?: string | undefined;
    userId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;

    constructor(data?: ISafeBoxBatchJobSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobType = _data["jobType"];
            this.status = _data["status"];
            this.totalRows = _data["totalRows"];
            this.processedRows = _data["processedRows"];
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            this.progressPercentage = _data["progressPercentage"];
            this.message = _data["message"];
            this.simulationId = _data["simulationId"];
            this.userId = _data["userId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SafeBoxBatchJobSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxBatchJobSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobType"] = this.jobType;
        data["status"] = this.status;
        data["totalRows"] = this.totalRows;
        data["processedRows"] = this.processedRows;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        data["progressPercentage"] = this.progressPercentage;
        data["message"] = this.message;
        data["simulationId"] = this.simulationId;
        data["userId"] = this.userId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ISafeBoxBatchJobSummaryResponse {
    jobId?: string | undefined;
    jobType?: string | undefined;
    status?: string | undefined;
    totalRows?: number | undefined;
    processedRows?: number | undefined;
    successCount?: number | undefined;
    failedCount?: number | undefined;
    progressPercentage?: number | undefined;
    message?: string | undefined;
    simulationId?: string | undefined;
    userId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
}

export class SafeBoxConfirmRedeemRequest implements ISafeBoxConfirmRedeemRequest {
    rows?: SafeBoxConfirmRedeemRow[] | undefined;

    constructor(data?: ISafeBoxConfirmRedeemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SafeBoxConfirmRedeemRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafeBoxConfirmRedeemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxConfirmRedeemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISafeBoxConfirmRedeemRequest {
    rows?: SafeBoxConfirmRedeemRow[] | undefined;
}

export class SafeBoxConfirmRedeemRow implements ISafeBoxConfirmRedeemRow {
    userId?: string | undefined;
    code?: string | undefined;

    constructor(data?: ISafeBoxConfirmRedeemRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SafeBoxConfirmRedeemRow {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxConfirmRedeemRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["code"] = this.code;
        return data;
    }
}

export interface ISafeBoxConfirmRedeemRow {
    userId?: string | undefined;
    code?: string | undefined;
}

export class SafeBoxRedeemProgressResponse implements ISafeBoxRedeemProgressResponse {
    redeemJobId?: string | undefined;
    status?: string | undefined;
    totalRows?: number | undefined;
    processedRows?: number | undefined;
    successCount?: number | undefined;
    failedCount?: number | undefined;
    progressPercentage?: number | undefined;
    message?: string | undefined;
    logFileS3Url?: string | undefined;
    successReportS3Url?: string | undefined;
    errorReportS3Url?: string | undefined;

    constructor(data?: ISafeBoxRedeemProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redeemJobId = _data["redeemJobId"];
            this.status = _data["status"];
            this.totalRows = _data["totalRows"];
            this.processedRows = _data["processedRows"];
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            this.progressPercentage = _data["progressPercentage"];
            this.message = _data["message"];
            this.logFileS3Url = _data["logFileS3Url"];
            this.successReportS3Url = _data["successReportS3Url"];
            this.errorReportS3Url = _data["errorReportS3Url"];
        }
    }

    static fromJS(data: any): SafeBoxRedeemProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxRedeemProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redeemJobId"] = this.redeemJobId;
        data["status"] = this.status;
        data["totalRows"] = this.totalRows;
        data["processedRows"] = this.processedRows;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        data["progressPercentage"] = this.progressPercentage;
        data["message"] = this.message;
        data["logFileS3Url"] = this.logFileS3Url;
        data["successReportS3Url"] = this.successReportS3Url;
        data["errorReportS3Url"] = this.errorReportS3Url;
        return data;
    }
}

export interface ISafeBoxRedeemProgressResponse {
    redeemJobId?: string | undefined;
    status?: string | undefined;
    totalRows?: number | undefined;
    processedRows?: number | undefined;
    successCount?: number | undefined;
    failedCount?: number | undefined;
    progressPercentage?: number | undefined;
    message?: string | undefined;
    logFileS3Url?: string | undefined;
    successReportS3Url?: string | undefined;
    errorReportS3Url?: string | undefined;
}

export class SafeBoxRedeemRowResponse implements ISafeBoxRedeemRowResponse {
    userId?: string | undefined;
    code?: string | undefined;
    success?: boolean | undefined;
    message?: string | undefined;

    constructor(data?: ISafeBoxRedeemRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.code = _data["code"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SafeBoxRedeemRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxRedeemRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["code"] = this.code;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISafeBoxRedeemRowResponse {
    userId?: string | undefined;
    code?: string | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class SafeBoxRedeemStartResponse implements ISafeBoxRedeemStartResponse {
    message?: string | undefined;
    redeemJobId?: string | undefined;
    executionReference?: string | undefined;

    constructor(data?: ISafeBoxRedeemStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.redeemJobId = _data["redeemJobId"];
            this.executionReference = _data["executionReference"];
        }
    }

    static fromJS(data: any): SafeBoxRedeemStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxRedeemStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["redeemJobId"] = this.redeemJobId;
        data["executionReference"] = this.executionReference;
        return data;
    }
}

export interface ISafeBoxRedeemStartResponse {
    message?: string | undefined;
    redeemJobId?: string | undefined;
    executionReference?: string | undefined;
}

export class SafeBoxSimulationProgressResponse implements ISafeBoxSimulationProgressResponse {
    simulationId?: string | undefined;
    status?: string | undefined;
    totalRows?: number | undefined;
    processedRows?: number | undefined;
    validCount?: number | undefined;
    invalidCount?: number | undefined;
    progressPercentage?: number | undefined;
    message?: string | undefined;
    logFileS3Url?: string | undefined;
    successReportS3Url?: string | undefined;
    errorReportS3Url?: string | undefined;

    constructor(data?: ISafeBoxSimulationProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.simulationId = _data["simulationId"];
            this.status = _data["status"];
            this.totalRows = _data["totalRows"];
            this.processedRows = _data["processedRows"];
            this.validCount = _data["validCount"];
            this.invalidCount = _data["invalidCount"];
            this.progressPercentage = _data["progressPercentage"];
            this.message = _data["message"];
            this.logFileS3Url = _data["logFileS3Url"];
            this.successReportS3Url = _data["successReportS3Url"];
            this.errorReportS3Url = _data["errorReportS3Url"];
        }
    }

    static fromJS(data: any): SafeBoxSimulationProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxSimulationProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simulationId"] = this.simulationId;
        data["status"] = this.status;
        data["totalRows"] = this.totalRows;
        data["processedRows"] = this.processedRows;
        data["validCount"] = this.validCount;
        data["invalidCount"] = this.invalidCount;
        data["progressPercentage"] = this.progressPercentage;
        data["message"] = this.message;
        data["logFileS3Url"] = this.logFileS3Url;
        data["successReportS3Url"] = this.successReportS3Url;
        data["errorReportS3Url"] = this.errorReportS3Url;
        return data;
    }
}

export interface ISafeBoxSimulationProgressResponse {
    simulationId?: string | undefined;
    status?: string | undefined;
    totalRows?: number | undefined;
    processedRows?: number | undefined;
    validCount?: number | undefined;
    invalidCount?: number | undefined;
    progressPercentage?: number | undefined;
    message?: string | undefined;
    logFileS3Url?: string | undefined;
    successReportS3Url?: string | undefined;
    errorReportS3Url?: string | undefined;
}

export class SafeBoxSimulationRowResponse implements ISafeBoxSimulationRowResponse {
    userId?: string | undefined;
    code?: string | undefined;
    status?: string | undefined;
    isRedeemable?: boolean | undefined;
    message?: string | undefined;
    campaignName?: string | undefined;
    rewardSummary?: string | undefined;

    constructor(data?: ISafeBoxSimulationRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.isRedeemable = _data["isRedeemable"];
            this.message = _data["message"];
            this.campaignName = _data["campaignName"];
            this.rewardSummary = _data["rewardSummary"];
        }
    }

    static fromJS(data: any): SafeBoxSimulationRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxSimulationRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["code"] = this.code;
        data["status"] = this.status;
        data["isRedeemable"] = this.isRedeemable;
        data["message"] = this.message;
        data["campaignName"] = this.campaignName;
        data["rewardSummary"] = this.rewardSummary;
        return data;
    }
}

export interface ISafeBoxSimulationRowResponse {
    userId?: string | undefined;
    code?: string | undefined;
    status?: string | undefined;
    isRedeemable?: boolean | undefined;
    message?: string | undefined;
    campaignName?: string | undefined;
    rewardSummary?: string | undefined;
}

export class SafeBoxSimulationStartResponse implements ISafeBoxSimulationStartResponse {
    message?: string | undefined;
    simulationId?: string | undefined;
    executionReference?: string | undefined;

    constructor(data?: ISafeBoxSimulationStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.simulationId = _data["simulationId"];
            this.executionReference = _data["executionReference"];
        }
    }

    static fromJS(data: any): SafeBoxSimulationStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxSimulationStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["simulationId"] = this.simulationId;
        data["executionReference"] = this.executionReference;
        return data;
    }
}

export interface ISafeBoxSimulationStartResponse {
    message?: string | undefined;
    simulationId?: string | undefined;
    executionReference?: string | undefined;
}

export class SafeBoxStartSimulationRequest implements ISafeBoxStartSimulationRequest {
    csvS3Url?: string | undefined;
    isCheckLimitRule?: boolean | undefined;

    constructor(data?: ISafeBoxStartSimulationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.csvS3Url = _data["csvS3Url"];
            this.isCheckLimitRule = _data["isCheckLimitRule"];
        }
    }

    static fromJS(data: any): SafeBoxStartSimulationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SafeBoxStartSimulationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["csvS3Url"] = this.csvS3Url;
        data["isCheckLimitRule"] = this.isCheckLimitRule;
        return data;
    }
}

export interface ISafeBoxStartSimulationRequest {
    csvS3Url?: string | undefined;
    isCheckLimitRule?: boolean | undefined;
}

export class SchemeLocationFilter implements ISchemeLocationFilter {
    schemeId?: string | undefined;
    filters?: any[] | undefined;

    constructor(data?: ISchemeLocationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemeId = _data["schemeId"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(item);
            }
        }
    }

    static fromJS(data: any): SchemeLocationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SchemeLocationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemeId"] = this.schemeId;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item);
        }
        return data;
    }
}

export interface ISchemeLocationFilter {
    schemeId?: string | undefined;
    filters?: any[] | undefined;
}

export class SecretCodeGuildlineVisual implements ISecretCodeGuildlineVisual {
    guildlineVisualUrl?: string | undefined;
    displayOrder?: number | undefined;

    constructor(data?: ISecretCodeGuildlineVisual) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guildlineVisualUrl = _data["guildlineVisualUrl"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): SecretCodeGuildlineVisual {
        data = typeof data === 'object' ? data : {};
        let result = new SecretCodeGuildlineVisual();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guildlineVisualUrl"] = this.guildlineVisualUrl;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ISecretCodeGuildlineVisual {
    guildlineVisualUrl?: string | undefined;
    displayOrder?: number | undefined;
}

export class Sequential implements ISequential {
    currentExecutingIndex?: number | undefined;
    children?: any[] | undefined;
    readonly name?: string | undefined;
    readonly currentStrategy?: any | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: ISequential) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentExecutingIndex = _data["currentExecutingIndex"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(item);
            }
            (this as any).name = _data["name"];
            (this as any).currentStrategy = _data["currentStrategy"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): Sequential {
        data = typeof data === 'object' ? data : {};
        let result = new Sequential();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentExecutingIndex"] = this.currentExecutingIndex;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item);
        }
        data["name"] = this.name;
        data["currentStrategy"] = this.currentStrategy;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface ISequential {
    currentExecutingIndex?: number | undefined;
    children?: any[] | undefined;
    name?: string | undefined;
    currentStrategy?: any | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class StaffCampaignStrategy implements IStaffCampaignStrategy {
    finished?: boolean | undefined;
    readonly name?: string | undefined;
    allowDuplicates?: boolean | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    coinMultiplier?: number | undefined;
    minScore?: number | undefined;
    totalCoins?: number | undefined;
    totalReceipts?: number | undefined;
    totalStampEvents?: number | undefined;
    serviceReward?: RewardData | undefined;
    timeLimit?: TimeLimitRule | undefined;
    repeatable?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IStaffCampaignStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finished = _data["finished"];
            (this as any).name = _data["name"];
            this.allowDuplicates = _data["allowDuplicates"];
            if (Array.isArray(_data["consumptionFilters"])) {
                this.consumptionFilters = [] as any;
                for (let item of _data["consumptionFilters"])
                    this.consumptionFilters!.push(ConsumptionFilterStrategy.fromJS(item));
            }
            this.coinMultiplier = _data["coinMultiplier"];
            this.minScore = _data["minScore"];
            this.totalCoins = _data["totalCoins"];
            this.totalReceipts = _data["totalReceipts"];
            this.totalStampEvents = _data["totalStampEvents"];
            this.serviceReward = _data["serviceReward"] ? RewardData.fromJS(_data["serviceReward"]) : undefined as any;
            this.timeLimit = _data["timeLimit"] ? TimeLimitRule.fromJS(_data["timeLimit"]) : undefined as any;
            this.repeatable = _data["repeatable"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): StaffCampaignStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new StaffCampaignStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finished"] = this.finished;
        data["name"] = this.name;
        data["allowDuplicates"] = this.allowDuplicates;
        if (Array.isArray(this.consumptionFilters)) {
            data["consumptionFilters"] = [];
            for (let item of this.consumptionFilters)
                data["consumptionFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["coinMultiplier"] = this.coinMultiplier;
        data["minScore"] = this.minScore;
        data["totalCoins"] = this.totalCoins;
        data["totalReceipts"] = this.totalReceipts;
        data["totalStampEvents"] = this.totalStampEvents;
        data["serviceReward"] = this.serviceReward ? this.serviceReward.toJSON() : undefined as any;
        data["timeLimit"] = this.timeLimit ? this.timeLimit.toJSON() : undefined as any;
        data["repeatable"] = this.repeatable;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IStaffCampaignStrategy {
    finished?: boolean | undefined;
    name?: string | undefined;
    allowDuplicates?: boolean | undefined;
    consumptionFilters?: ConsumptionFilterStrategy[] | undefined;
    coinMultiplier?: number | undefined;
    minScore?: number | undefined;
    totalCoins?: number | undefined;
    totalReceipts?: number | undefined;
    totalStampEvents?: number | undefined;
    serviceReward?: RewardData | undefined;
    timeLimit?: TimeLimitRule | undefined;
    repeatable?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class StaffInformationStrategy implements IStaffInformationStrategy {
    readonly name?: string | undefined;
    validateReward?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IStaffInformationStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.validateReward = _data["validateReward"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): StaffInformationStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new StaffInformationStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["validateReward"] = this.validateReward;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IStaffInformationStrategy {
    name?: string | undefined;
    validateReward?: boolean | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class StaffPointReset implements IStaffPointReset {
    baseDate?: Date | undefined;
    period?: TimePeriod | undefined;
    nextReset?: Date | undefined;

    constructor(data?: IStaffPointReset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseDate = _data["baseDate"] ? new Date(_data["baseDate"].toString()) : undefined as any;
            this.period = _data["period"] ? TimePeriod.fromJS(_data["period"]) : undefined as any;
            this.nextReset = _data["nextReset"] ? new Date(_data["nextReset"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StaffPointReset {
        data = typeof data === 'object' ? data : {};
        let result = new StaffPointReset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseDate"] = this.baseDate ? this.baseDate.toISOString() : undefined as any;
        data["period"] = this.period ? this.period.toJSON() : undefined as any;
        data["nextReset"] = this.nextReset ? this.nextReset.toISOString() : undefined as any;
        return data;
    }
}

export interface IStaffPointReset {
    baseDate?: Date | undefined;
    period?: TimePeriod | undefined;
    nextReset?: Date | undefined;
}

export class StaffPointStrategy implements IStaffPointStrategy {
    allowDuplicates?: boolean | undefined;
    initialPoints?: number | undefined;
    pointsForRaffleTicket?: number | undefined;
    baseline?: PointBaseline | undefined;
    productLimit?: StaffProductLimit | undefined;
    pointReset?: StaffPointReset | undefined;
    receiptTimeConstraint?: TimeConstraint | undefined;
    checkExternalId?: boolean | undefined;
    productsInTimeInterval?: number | undefined;
    pointsInTimeInterval?: number | undefined;
    totalPoints?: number | undefined;
    raffleTickets?: number | undefined;
    readonly name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    readonly startTime?: Date | undefined;
    readonly endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    readonly isStarted?: boolean | undefined;
    readonly isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;

    constructor(data?: IStaffPointStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowDuplicates = _data["allowDuplicates"];
            this.initialPoints = _data["initialPoints"];
            this.pointsForRaffleTicket = _data["pointsForRaffleTicket"];
            this.baseline = _data["baseline"] ? PointBaseline.fromJS(_data["baseline"]) : undefined as any;
            this.productLimit = _data["productLimit"] ? StaffProductLimit.fromJS(_data["productLimit"]) : undefined as any;
            this.pointReset = _data["pointReset"] ? StaffPointReset.fromJS(_data["pointReset"]) : undefined as any;
            this.receiptTimeConstraint = _data["receiptTimeConstraint"] ? TimeConstraint.fromJS(_data["receiptTimeConstraint"]) : undefined as any;
            this.checkExternalId = _data["checkExternalId"];
            this.productsInTimeInterval = _data["productsInTimeInterval"];
            this.pointsInTimeInterval = _data["pointsInTimeInterval"];
            this.totalPoints = _data["totalPoints"];
            this.raffleTickets = _data["raffleTickets"];
            (this as any).name = _data["name"];
            this.title = _data["title"];
            this.campaignName = _data["campaignName"];
            this.description = _data["description"];
            this.htmlDetailedDescription = _data["htmlDetailedDescription"];
            (this as any).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            (this as any).endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.restartable = _data["restartable"];
            this.restartCount = _data["restartCount"];
            this.restartLimit = _data["restartLimit"];
            (this as any).isStarted = _data["isStarted"];
            (this as any).isFinished = _data["isFinished"];
            this.consumerReferral = _data["consumerReferral"] ? ConsumerReferralData.fromJS(_data["consumerReferral"]) : undefined as any;
            this.staffReferralData = _data["staffReferralData"] ? StaffReferralData.fromJS(_data["staffReferralData"]) : undefined as any;
            this.banner = _data["banner"] ? CampaignBanner.fromJS(_data["banner"]) : undefined as any;
            this.detailBanner = _data["detailBanner"] ? CampaignBanner.fromJS(_data["detailBanner"]) : undefined as any;
            this.timeConstraint = _data["timeConstraint"];
        }
    }

    static fromJS(data: any): StaffPointStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new StaffPointStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowDuplicates"] = this.allowDuplicates;
        data["initialPoints"] = this.initialPoints;
        data["pointsForRaffleTicket"] = this.pointsForRaffleTicket;
        data["baseline"] = this.baseline ? this.baseline.toJSON() : undefined as any;
        data["productLimit"] = this.productLimit ? this.productLimit.toJSON() : undefined as any;
        data["pointReset"] = this.pointReset ? this.pointReset.toJSON() : undefined as any;
        data["receiptTimeConstraint"] = this.receiptTimeConstraint ? this.receiptTimeConstraint.toJSON() : undefined as any;
        data["checkExternalId"] = this.checkExternalId;
        data["productsInTimeInterval"] = this.productsInTimeInterval;
        data["pointsInTimeInterval"] = this.pointsInTimeInterval;
        data["totalPoints"] = this.totalPoints;
        data["raffleTickets"] = this.raffleTickets;
        data["name"] = this.name;
        data["title"] = this.title;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["htmlDetailedDescription"] = this.htmlDetailedDescription;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["state"] = this.state;
        data["restartable"] = this.restartable;
        data["restartCount"] = this.restartCount;
        data["restartLimit"] = this.restartLimit;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["consumerReferral"] = this.consumerReferral ? this.consumerReferral.toJSON() : undefined as any;
        data["staffReferralData"] = this.staffReferralData ? this.staffReferralData.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["detailBanner"] = this.detailBanner ? this.detailBanner.toJSON() : undefined as any;
        data["timeConstraint"] = this.timeConstraint;
        return data;
    }
}

export interface IStaffPointStrategy {
    allowDuplicates?: boolean | undefined;
    initialPoints?: number | undefined;
    pointsForRaffleTicket?: number | undefined;
    baseline?: PointBaseline | undefined;
    productLimit?: StaffProductLimit | undefined;
    pointReset?: StaffPointReset | undefined;
    receiptTimeConstraint?: TimeConstraint | undefined;
    checkExternalId?: boolean | undefined;
    productsInTimeInterval?: number | undefined;
    pointsInTimeInterval?: number | undefined;
    totalPoints?: number | undefined;
    raffleTickets?: number | undefined;
    name?: string | undefined;
    title?: string | undefined;
    campaignName?: string | undefined;
    description?: string | undefined;
    htmlDetailedDescription?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    state?: StrategyState | undefined;
    restartable?: boolean | undefined;
    restartCount?: number | undefined;
    restartLimit?: number | undefined;
    isStarted?: boolean | undefined;
    isFinished?: boolean | undefined;
    consumerReferral?: ConsumerReferralData | undefined;
    staffReferralData?: StaffReferralData | undefined;
    banner?: CampaignBanner | undefined;
    detailBanner?: CampaignBanner | undefined;
    timeConstraint?: boolean | undefined;
}

export class StaffProductLimit implements IStaffProductLimit {
    baseDate?: Date | undefined;
    period?: TimePeriod | undefined;
    nextReset?: Date | undefined;
    maxValue?: number | undefined;
    maxPercent?: number | undefined;

    constructor(data?: IStaffProductLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseDate = _data["baseDate"] ? new Date(_data["baseDate"].toString()) : undefined as any;
            this.period = _data["period"] ? TimePeriod.fromJS(_data["period"]) : undefined as any;
            this.nextReset = _data["nextReset"] ? new Date(_data["nextReset"].toString()) : undefined as any;
            this.maxValue = _data["maxValue"];
            this.maxPercent = _data["maxPercent"];
        }
    }

    static fromJS(data: any): StaffProductLimit {
        data = typeof data === 'object' ? data : {};
        let result = new StaffProductLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseDate"] = this.baseDate ? this.baseDate.toISOString() : undefined as any;
        data["period"] = this.period ? this.period.toJSON() : undefined as any;
        data["nextReset"] = this.nextReset ? this.nextReset.toISOString() : undefined as any;
        data["maxValue"] = this.maxValue;
        data["maxPercent"] = this.maxPercent;
        return data;
    }
}

export interface IStaffProductLimit {
    baseDate?: Date | undefined;
    period?: TimePeriod | undefined;
    nextReset?: Date | undefined;
    maxValue?: number | undefined;
    maxPercent?: number | undefined;
}

export class StaffReferralData implements IStaffReferralData {
    senderId?: string | undefined;
    createdByCode?: string | undefined;
    referralCampaignId?: string | undefined;

    constructor(data?: IStaffReferralData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderId = _data["senderId"];
            this.createdByCode = _data["createdByCode"];
            this.referralCampaignId = _data["referralCampaignId"];
        }
    }

    static fromJS(data: any): StaffReferralData {
        data = typeof data === 'object' ? data : {};
        let result = new StaffReferralData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderId"] = this.senderId;
        data["createdByCode"] = this.createdByCode;
        data["referralCampaignId"] = this.referralCampaignId;
        return data;
    }
}

export interface IStaffReferralData {
    senderId?: string | undefined;
    createdByCode?: string | undefined;
    referralCampaignId?: string | undefined;
}

export class StampReward implements IStampReward {
    stamps?: number | undefined;

    constructor(data?: IStampReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stamps = _data["stamps"];
        }
    }

    static fromJS(data: any): StampReward {
        data = typeof data === 'object' ? data : {};
        let result = new StampReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stamps"] = this.stamps;
        return data;
    }
}

export interface IStampReward {
    stamps?: number | undefined;
}

export class StartGame implements IStartGame {
    encryptionKey?: string | undefined;
    chances?: GameChance[] | undefined;
    survey?: SurveyQuestionnaire | undefined;
    vouchersOutOfStock?: ProductInfo[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;

    constructor(data?: IStartGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encryptionKey = _data["encryptionKey"];
            if (Array.isArray(_data["chances"])) {
                this.chances = [] as any;
                for (let item of _data["chances"])
                    this.chances!.push(GameChance.fromJS(item));
            }
            this.survey = _data["survey"] ? SurveyQuestionnaire.fromJS(_data["survey"]) : undefined as any;
            if (Array.isArray(_data["vouchersOutOfStock"])) {
                this.vouchersOutOfStock = [] as any;
                for (let item of _data["vouchersOutOfStock"])
                    this.vouchersOutOfStock!.push(ProductInfo.fromJS(item));
            }
            this.calculateWinningChanceServerside = _data["calculateWinningChanceServerside"];
        }
    }

    static fromJS(data: any): StartGame {
        data = typeof data === 'object' ? data : {};
        let result = new StartGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encryptionKey"] = this.encryptionKey;
        if (Array.isArray(this.chances)) {
            data["chances"] = [];
            for (let item of this.chances)
                data["chances"].push(item ? item.toJSON() : undefined as any);
        }
        data["survey"] = this.survey ? this.survey.toJSON() : undefined as any;
        if (Array.isArray(this.vouchersOutOfStock)) {
            data["vouchersOutOfStock"] = [];
            for (let item of this.vouchersOutOfStock)
                data["vouchersOutOfStock"].push(item ? item.toJSON() : undefined as any);
        }
        data["calculateWinningChanceServerside"] = this.calculateWinningChanceServerside;
        return data;
    }
}

export interface IStartGame {
    encryptionKey?: string | undefined;
    chances?: GameChance[] | undefined;
    survey?: SurveyQuestionnaire | undefined;
    vouchersOutOfStock?: ProductInfo[] | undefined;
    calculateWinningChanceServerside?: boolean | undefined;
}

export enum StrategyState {
    None = "None",
    Started = "Started",
    Finished = "Finished",
}

export class SurveyAnswerInfo implements ISurveyAnswerInfo {
    externalId?: string | undefined;
    answerId?: string | undefined;
    answerDescription?: string | undefined;
    language?: string | undefined;

    constructor(data?: ISurveyAnswerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.answerId = _data["answerId"];
            this.answerDescription = _data["answerDescription"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): SurveyAnswerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["answerId"] = this.answerId;
        data["answerDescription"] = this.answerDescription;
        data["language"] = this.language;
        return data;
    }
}

export interface ISurveyAnswerInfo {
    externalId?: string | undefined;
    answerId?: string | undefined;
    answerDescription?: string | undefined;
    language?: string | undefined;
}

export class SurveyGameInfo implements ISurveyGameInfo {
    questionId?: string | undefined;
    questionDescription?: string | undefined;
    multipleChoices?: boolean | undefined;
    answers?: SurveyAnswerInfo[] | undefined;

    constructor(data?: ISurveyGameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.questionDescription = _data["questionDescription"];
            this.multipleChoices = _data["multipleChoices"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswerInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyGameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyGameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionDescription"] = this.questionDescription;
        data["multipleChoices"] = this.multipleChoices;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyGameInfo {
    questionId?: string | undefined;
    questionDescription?: string | undefined;
    multipleChoices?: boolean | undefined;
    answers?: SurveyAnswerInfo[] | undefined;
}

export class SurveyQuestionnaire implements ISurveyQuestionnaire {
    adminId?: string | undefined;
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    defaultLanguage?: string | undefined;
    questionnaires?: SurveyGameInfo[] | undefined;

    constructor(data?: ISurveyQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminId = _data["adminId"];
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            this.defaultLanguage = _data["defaultLanguage"];
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(SurveyGameInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminId"] = this.adminId;
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        data["defaultLanguage"] = this.defaultLanguage;
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyQuestionnaire {
    adminId?: string | undefined;
    surveyId?: string | undefined;
    surveyName?: string | undefined;
    defaultLanguage?: string | undefined;
    questionnaires?: SurveyGameInfo[] | undefined;
}

export class SyncConsumerDataRequest implements ISyncConsumerDataRequest {
    userId?: string | undefined;
    latestEmail?: string | undefined;
    advertiserIds?: string[] | undefined;

    constructor(data?: ISyncConsumerDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.latestEmail = _data["latestEmail"];
            if (Array.isArray(_data["advertiserIds"])) {
                this.advertiserIds = [] as any;
                for (let item of _data["advertiserIds"])
                    this.advertiserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SyncConsumerDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncConsumerDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["latestEmail"] = this.latestEmail;
        if (Array.isArray(this.advertiserIds)) {
            data["advertiserIds"] = [];
            for (let item of this.advertiserIds)
                data["advertiserIds"].push(item);
        }
        return data;
    }
}

export interface ISyncConsumerDataRequest {
    userId?: string | undefined;
    latestEmail?: string | undefined;
    advertiserIds?: string[] | undefined;
}

export class TagItem implements ITagItem {
    tag?: string | undefined;
    value?: string | undefined;

    constructor(data?: ITagItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TagItem {
        data = typeof data === 'object' ? data : {};
        let result = new TagItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["value"] = this.value;
        return data;
    }
}

export interface ITagItem {
    tag?: string | undefined;
    value?: string | undefined;
}

export class TimeConstraint implements ITimeConstraint {
    current?: PeriodUnit | undefined;
    last?: TimePeriod | undefined;

    constructor(data?: ITimeConstraint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"];
            this.last = _data["last"] ? TimePeriod.fromJS(_data["last"]) : undefined as any;
        }
    }

    static fromJS(data: any): TimeConstraint {
        data = typeof data === 'object' ? data : {};
        let result = new TimeConstraint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["last"] = this.last ? this.last.toJSON() : undefined as any;
        return data;
    }
}

export interface ITimeConstraint {
    current?: PeriodUnit | undefined;
    last?: TimePeriod | undefined;
}

export class TimeLimitRule implements ITimeLimitRule {
    maxLimit?: number | undefined;
    interval?: string | undefined;
    dateStart?: Date | undefined;
    currrent?: number | undefined;

    constructor(data?: ITimeLimitRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxLimit = _data["maxLimit"];
            this.interval = _data["interval"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : undefined as any;
            this.currrent = _data["currrent"];
        }
    }

    static fromJS(data: any): TimeLimitRule {
        data = typeof data === 'object' ? data : {};
        let result = new TimeLimitRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxLimit"] = this.maxLimit;
        data["interval"] = this.interval;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : undefined as any;
        data["currrent"] = this.currrent;
        return data;
    }
}

export interface ITimeLimitRule {
    maxLimit?: number | undefined;
    interval?: string | undefined;
    dateStart?: Date | undefined;
    currrent?: number | undefined;
}

export class TimePeriod implements ITimePeriod {
    unit?: PeriodUnit | undefined;
    multiply?: number | undefined;

    constructor(data?: ITimePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"];
            this.multiply = _data["multiply"];
        }
    }

    static fromJS(data: any): TimePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new TimePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["multiply"] = this.multiply;
        return data;
    }
}

export interface ITimePeriod {
    unit?: PeriodUnit | undefined;
    multiply?: number | undefined;
}

export class TimeZoneItem implements ITimeZoneItem {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: ITimeZoneItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TimeZoneItem {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITimeZoneItem {
    id?: string | undefined;
    name?: string | undefined;
}

export class UpdateAdvertiserLinkedCampaignsResponse implements IUpdateAdvertiserLinkedCampaignsResponse {
    message?: string | undefined;

    constructor(data?: IUpdateAdvertiserLinkedCampaignsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateAdvertiserLinkedCampaignsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdvertiserLinkedCampaignsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IUpdateAdvertiserLinkedCampaignsResponse {
    message?: string | undefined;
}

export class UpdateCampaignOnboardingUrlRequest implements IUpdateCampaignOnboardingUrlRequest {
    onboardingUrl?: string | undefined;

    constructor(data?: IUpdateCampaignOnboardingUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onboardingUrl = _data["onboardingUrl"];
        }
    }

    static fromJS(data: any): UpdateCampaignOnboardingUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignOnboardingUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onboardingUrl"] = this.onboardingUrl;
        return data;
    }
}

export interface IUpdateCampaignOnboardingUrlRequest {
    onboardingUrl?: string | undefined;
}

export class UpdateCampaignPartialRequest implements IUpdateCampaignPartialRequest {
    title?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    clearEndDate?: boolean | undefined;
    canJoin?: boolean | undefined;
    shouldAdvertise?: boolean | undefined;
    photoBannerUrl?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    onboardingUrl?: string | undefined;
    /** Upload key for banner image (wide format). When provided, backend processes the upload and generates the CDN URL. */
    uploadKeyBanner?: string | undefined;
    /** Upload key for full-size photo. When provided, backend processes the upload and generates the CDN URL. */
    uploadKeyFull?: string | undefined;
    /** Upload key for thumbnail photo. When provided, backend processes thumb+full and generates CDN URLs. */
    uploadKeyThumb?: string | undefined;

    constructor(data?: IUpdateCampaignPartialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.clearEndDate = _data["clearEndDate"];
            this.canJoin = _data["canJoin"];
            this.shouldAdvertise = _data["shouldAdvertise"];
            this.photoBannerUrl = _data["photoBannerUrl"];
            this.photoFullUrl = _data["photoFullUrl"];
            this.photoThumbUrl = _data["photoThumbUrl"];
            this.onboardingUrl = _data["onboardingUrl"];
            this.uploadKeyBanner = _data["uploadKeyBanner"];
            this.uploadKeyFull = _data["uploadKeyFull"];
            this.uploadKeyThumb = _data["uploadKeyThumb"];
        }
    }

    static fromJS(data: any): UpdateCampaignPartialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignPartialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["clearEndDate"] = this.clearEndDate;
        data["canJoin"] = this.canJoin;
        data["shouldAdvertise"] = this.shouldAdvertise;
        data["photoBannerUrl"] = this.photoBannerUrl;
        data["photoFullUrl"] = this.photoFullUrl;
        data["photoThumbUrl"] = this.photoThumbUrl;
        data["onboardingUrl"] = this.onboardingUrl;
        data["uploadKeyBanner"] = this.uploadKeyBanner;
        data["uploadKeyFull"] = this.uploadKeyFull;
        data["uploadKeyThumb"] = this.uploadKeyThumb;
        return data;
    }
}

export interface IUpdateCampaignPartialRequest {
    title?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    clearEndDate?: boolean | undefined;
    canJoin?: boolean | undefined;
    shouldAdvertise?: boolean | undefined;
    photoBannerUrl?: string | undefined;
    photoFullUrl?: string | undefined;
    photoThumbUrl?: string | undefined;
    onboardingUrl?: string | undefined;
    /** Upload key for banner image (wide format). When provided, backend processes the upload and generates the CDN URL. */
    uploadKeyBanner?: string | undefined;
    /** Upload key for full-size photo. When provided, backend processes the upload and generates the CDN URL. */
    uploadKeyFull?: string | undefined;
    /** Upload key for thumbnail photo. When provided, backend processes thumb+full and generates CDN URLs. */
    uploadKeyThumb?: string | undefined;
}

export class UpdateOutboundEventConfigRequestDto implements IUpdateOutboundEventConfigRequestDto {
    provider?: OutboundEventProvider | undefined;
    credentials?: { [key: string]: string; } | undefined;
    subscribedEventTypes?: OutboundEvents[] | undefined;

    constructor(data?: IUpdateOutboundEventConfigRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            if (_data["credentials"]) {
                this.credentials = {} as any;
                for (let key in _data["credentials"]) {
                    if (_data["credentials"].hasOwnProperty(key))
                        (this.credentials as any)![key] = _data["credentials"][key];
                }
            }
            if (Array.isArray(_data["subscribedEventTypes"])) {
                this.subscribedEventTypes = [] as any;
                for (let item of _data["subscribedEventTypes"])
                    this.subscribedEventTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateOutboundEventConfigRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOutboundEventConfigRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        if (this.credentials) {
            data["credentials"] = {};
            for (let key in this.credentials) {
                if (this.credentials.hasOwnProperty(key))
                    (data["credentials"] as any)[key] = (this.credentials as any)[key];
            }
        }
        if (Array.isArray(this.subscribedEventTypes)) {
            data["subscribedEventTypes"] = [];
            for (let item of this.subscribedEventTypes)
                data["subscribedEventTypes"].push(item);
        }
        return data;
    }
}

export interface IUpdateOutboundEventConfigRequestDto {
    provider?: OutboundEventProvider | undefined;
    credentials?: { [key: string]: string; } | undefined;
    subscribedEventTypes?: OutboundEvents[] | undefined;
}

export class UpdateReceiptRequest implements IUpdateReceiptRequest {
    receipt?: Receipt | undefined;
    actions?: string[] | undefined;
    numberOfStamps?: number | undefined;
    note?: string | undefined;
    isReprocess?: boolean | undefined;
    isUpdateReceipt?: boolean | undefined;

    constructor(data?: IUpdateReceiptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receipt = _data["receipt"] ? Receipt.fromJS(_data["receipt"]) : undefined as any;
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            this.numberOfStamps = _data["numberOfStamps"];
            this.note = _data["note"];
            this.isReprocess = _data["isReprocess"];
            this.isUpdateReceipt = _data["isUpdateReceipt"];
        }
    }

    static fromJS(data: any): UpdateReceiptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReceiptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receipt"] = this.receipt ? this.receipt.toJSON() : undefined as any;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        data["numberOfStamps"] = this.numberOfStamps;
        data["note"] = this.note;
        data["isReprocess"] = this.isReprocess;
        data["isUpdateReceipt"] = this.isUpdateReceipt;
        return data;
    }
}

export interface IUpdateReceiptRequest {
    receipt?: Receipt | undefined;
    actions?: string[] | undefined;
    numberOfStamps?: number | undefined;
    note?: string | undefined;
    isReprocess?: boolean | undefined;
    isUpdateReceipt?: boolean | undefined;
}

export class UserActivity implements IUserActivity {
    id?: string | undefined;
    userId?: string | undefined;
    eventData?: any | undefined;
    context?: EventContext | undefined;
    eventType?: string | undefined;
    timestamp?: Date | undefined;
    coordinates?: Coordinates | undefined;
    category?: UserActivityCategory | undefined;

    constructor(data?: IUserActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.eventData = _data["eventData"];
            this.context = _data["context"] ? EventContext.fromJS(_data["context"]) : undefined as any;
            this.eventType = _data["eventType"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : undefined as any;
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): UserActivity {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["eventData"] = this.eventData;
        data["context"] = this.context ? this.context.toJSON() : undefined as any;
        data["eventType"] = this.eventType;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : undefined as any;
        data["category"] = this.category;
        return data;
    }
}

export interface IUserActivity {
    id?: string | undefined;
    userId?: string | undefined;
    eventData?: any | undefined;
    context?: EventContext | undefined;
    eventType?: string | undefined;
    timestamp?: Date | undefined;
    coordinates?: Coordinates | undefined;
    category?: UserActivityCategory | undefined;
}

export enum UserActivityCategory {
    Customer = "Customer",
    Staff = "Staff",
    System = "System",
}

export class VendorInfo implements IVendorInfo {
    name?: string | undefined;
    rawName?: string | undefined;
    address?: string | undefined;
    vendorType?: string | undefined;

    constructor(data?: IVendorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rawName = _data["rawName"];
            this.address = _data["address"];
            this.vendorType = _data["vendorType"];
        }
    }

    static fromJS(data: any): VendorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rawName"] = this.rawName;
        data["address"] = this.address;
        data["vendorType"] = this.vendorType;
        return data;
    }
}

export interface IVendorInfo {
    name?: string | undefined;
    rawName?: string | undefined;
    address?: string | undefined;
    vendorType?: string | undefined;
}

export class Warning implements IWarning {
    message?: string | undefined;
    type?: string | undefined;

    constructor(data?: IWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Warning {
        data = typeof data === 'object' ? data : {};
        let result = new Warning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["type"] = this.type;
        return data;
    }
}

export interface IWarning {
    message?: string | undefined;
    type?: string | undefined;
}

export class WebhookRequestDto implements IWebhookRequestDto {
    provider?: string | undefined;
    eventType?: string | undefined;
    data?: { [key: string]: any; } | undefined;

    constructor(data?: IWebhookRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.eventType = _data["eventType"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): WebhookRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["eventType"] = this.eventType;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = (this.data as any)[key];
            }
        }
        return data;
    }
}

export interface IWebhookRequestDto {
    provider?: string | undefined;
    eventType?: string | undefined;
    data?: { [key: string]: any; } | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new SwaggerException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}